// src/rentals-api-v3/models/Address.ts
function instanceOfAddress(value) {
  return true;
}
function AddressFromJSON(json) {
  return AddressFromJSONTyped(json, false);
}
function AddressFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    street: json["street"] == null ? void 0 : json["street"],
    state: json["state"] == null ? void 0 : json["state"],
    city: json["city"] == null ? void 0 : json["city"],
    country: json["country"] == null ? void 0 : json["country"],
    postCode: json["postCode"] == null ? void 0 : json["postCode"]
  };
}
function AddressToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    street: value["street"],
    state: value["state"],
    city: value["city"],
    country: value["country"],
    postCode: value["postCode"]
  };
}

// src/rentals-api-v3/models/CurrencyValue.ts
function instanceOfCurrencyValue(value) {
  if (!("currencyCode" in value) || value["currencyCode"] === void 0) return false;
  if (!("value" in value) || value["value"] === void 0) return false;
  return true;
}
function CurrencyValueFromJSON(json) {
  return CurrencyValueFromJSONTyped(json, false);
}
function CurrencyValueFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    currencyCode: json["currencyCode"],
    value: json["value"]
  };
}
function CurrencyValueToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    currencyCode: value["currencyCode"],
    value: value["value"]
  };
}

// src/rentals-api-v3/models/AfterpayConfig.ts
function instanceOfAfterpayConfig(value) {
  return true;
}
function AfterpayConfigFromJSON(json) {
  return AfterpayConfigFromJSONTyped(json, false);
}
function AfterpayConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    minimumAmount: json["minimumAmount"] == null ? void 0 : CurrencyValueFromJSON(json["minimumAmount"]),
    maximumAmount: json["maximumAmount"] == null ? void 0 : CurrencyValueFromJSON(json["maximumAmount"])
  };
}
function AfterpayConfigToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    minimumAmount: CurrencyValueToJSON(value["minimumAmount"]),
    maximumAmount: CurrencyValueToJSON(value["maximumAmount"])
  };
}

// src/rentals-api-v3/models/AgentRegionSettings.ts
function instanceOfAgentRegionSettings(value) {
  return true;
}
function AgentRegionSettingsFromJSON(json) {
  return AgentRegionSettingsFromJSONTyped(json, false);
}
function AgentRegionSettingsFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    rateType: json["rateType"] == null ? void 0 : json["rateType"],
    paymentType: json["paymentType"] == null ? void 0 : json["paymentType"],
    commission: json["commission"] == null ? void 0 : json["commission"]
  };
}
function AgentRegionSettingsToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    rateType: value["rateType"],
    paymentType: value["paymentType"],
    commission: value["commission"]
  };
}

// src/rentals-api-v3/models/LeadTime1.ts
function instanceOfLeadTime1(value) {
  return true;
}
function LeadTime1FromJSON(json) {
  return LeadTime1FromJSONTyped(json, false);
}
function LeadTime1FromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    fleetTypeCode: json["fleetTypeCode"] == null ? void 0 : json["fleetTypeCode"],
    leadTime: json["leadTime"] == null ? void 0 : json["leadTime"]
  };
}
function LeadTime1ToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    fleetTypeCode: value["fleetTypeCode"],
    leadTime: value["leadTime"]
  };
}

// src/rentals-api-v3/models/AgentSettings.ts
function instanceOfAgentSettings(value) {
  if (!("au" in value) || value["au"] === void 0) return false;
  if (!("nz" in value) || value["nz"] === void 0) return false;
  return true;
}
function AgentSettingsFromJSON(json) {
  return AgentSettingsFromJSONTyped(json, false);
}
function AgentSettingsFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    au: AgentRegionSettingsFromJSON(json["au"]),
    nz: AgentRegionSettingsFromJSON(json["nz"]),
    cancellationMinimum: json["cancellationMinimum"] == null ? void 0 : json["cancellationMinimum"],
    leadTimes: json["leadTimes"] == null ? void 0 : json["leadTimes"].map(LeadTime1FromJSON)
  };
}
function AgentSettingsToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    au: AgentRegionSettingsToJSON(value["au"]),
    nz: AgentRegionSettingsToJSON(value["nz"]),
    cancellationMinimum: value["cancellationMinimum"],
    leadTimes: value["leadTimes"] == null ? void 0 : value["leadTimes"].map(LeadTime1ToJSON)
  };
}

// src/rentals-api-v3/models/AgentInfo.ts
function instanceOfAgentInfo(value) {
  if (!("id" in value) || value["id"] === void 0) return false;
  if (!("name" in value) || value["name"] === void 0) return false;
  if (!("code" in value) || value["code"] === void 0) return false;
  return true;
}
function AgentInfoFromJSON(json) {
  return AgentInfoFromJSONTyped(json, false);
}
function AgentInfoFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
    code: json["code"],
    parent: json["parent"] == null ? void 0 : json["parent"],
    branch: json["branch"] == null ? void 0 : json["branch"],
    type: json["type"] == null ? void 0 : json["type"],
    logo: json["logo"] == null ? void 0 : json["logo"],
    settings: json["settings"] == null ? void 0 : AgentSettingsFromJSON(json["settings"]),
    features: json["features"] == null ? void 0 : json["features"]
  };
}
function AgentInfoToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    id: value["id"],
    name: value["name"],
    code: value["code"],
    parent: value["parent"],
    branch: value["branch"],
    type: value["type"],
    logo: value["logo"],
    settings: AgentSettingsToJSON(value["settings"]),
    features: value["features"]
  };
}

// src/rentals-api-v3/models/AgentInfoRequest.ts
function instanceOfAgentInfoRequest(value) {
  if (!("id" in value) || value["id"] === void 0) return false;
  return true;
}
function AgentInfoRequestFromJSON(json) {
  return AgentInfoRequestFromJSONTyped(json, false);
}
function AgentInfoRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"]
  };
}
function AgentInfoRequestToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    id: value["id"]
  };
}

// src/rentals-api-v3/models/JucyCountryCode.ts
var JucyCountryCode = {
  Au: "au",
  Nz: "nz"
};
function instanceOfJucyCountryCode(value) {
  for (const key in JucyCountryCode) {
    if (Object.prototype.hasOwnProperty.call(JucyCountryCode, key)) {
      if (JucyCountryCode[key] === value) {
        return true;
      }
    }
  }
  return false;
}
function JucyCountryCodeFromJSON(json) {
  return JucyCountryCodeFromJSONTyped(json, false);
}
function JucyCountryCodeFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function JucyCountryCodeToJSON(value) {
  return value;
}

// src/rentals-api-v3/models/AgentRatesQuery.ts
function instanceOfAgentRatesQuery(value) {
  if (!("region" in value) || value["region"] === void 0) return false;
  return true;
}
function AgentRatesQueryFromJSON(json) {
  return AgentRatesQueryFromJSONTyped(json, false);
}
function AgentRatesQueryFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    region: JucyCountryCodeFromJSON(json["region"])
  };
}
function AgentRatesQueryToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    region: JucyCountryCodeToJSON(value["region"])
  };
}

// src/rentals-api-v3/models/AgentRatesRequest.ts
function instanceOfAgentRatesRequest(value) {
  if (!("id" in value) || value["id"] === void 0) return false;
  return true;
}
function AgentRatesRequestFromJSON(json) {
  return AgentRatesRequestFromJSONTyped(json, false);
}
function AgentRatesRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"]
  };
}
function AgentRatesRequestToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    id: value["id"]
  };
}

// src/rentals-api-v3/models/FleetTypeCode.ts
var FleetTypeCode = {
  Car: "car",
  Campervan: "campervan",
  Motorhome: "motorhome"
};
function instanceOfFleetTypeCode(value) {
  for (const key in FleetTypeCode) {
    if (Object.prototype.hasOwnProperty.call(FleetTypeCode, key)) {
      if (FleetTypeCode[key] === value) {
        return true;
      }
    }
  }
  return false;
}
function FleetTypeCodeFromJSON(json) {
  return FleetTypeCodeFromJSONTyped(json, false);
}
function FleetTypeCodeFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function FleetTypeCodeToJSON(value) {
  return value;
}

// src/rentals-api-v3/models/AlternateDatesAvailabilityRequest.ts
function instanceOfAlternateDatesAvailabilityRequest(value) {
  if (!("pickUpLocation" in value) || value["pickUpLocation"] === void 0) return false;
  if (!("dropOffLocation" in value) || value["dropOffLocation"] === void 0) return false;
  if (!("pickUpDate" in value) || value["pickUpDate"] === void 0) return false;
  if (!("dropOffDate" in value) || value["dropOffDate"] === void 0) return false;
  if (!("fleetTypeCode" in value) || value["fleetTypeCode"] === void 0) return false;
  if (!("days" in value) || value["days"] === void 0) return false;
  return true;
}
function AlternateDatesAvailabilityRequestFromJSON(json) {
  return AlternateDatesAvailabilityRequestFromJSONTyped(json, false);
}
function AlternateDatesAvailabilityRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    pickUpLocation: json["pickUpLocation"],
    dropOffLocation: json["dropOffLocation"],
    pickUpDate: json["pickUpDate"],
    dropOffDate: json["dropOffDate"],
    fleetTypeCode: FleetTypeCodeFromJSON(json["fleetTypeCode"]),
    campaignCode: json["campaignCode"] == null ? void 0 : json["campaignCode"],
    days: json["days"]
  };
}
function AlternateDatesAvailabilityRequestToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    pickUpLocation: value["pickUpLocation"],
    dropOffLocation: value["dropOffLocation"],
    pickUpDate: value["pickUpDate"],
    dropOffDate: value["dropOffDate"],
    fleetTypeCode: FleetTypeCodeToJSON(value["fleetTypeCode"]),
    campaignCode: value["campaignCode"],
    days: value["days"]
  };
}

// src/rentals-api-v3/models/AutoPaymentParam.ts
function instanceOfAutoPaymentParam(value) {
  if (!("ref" in value) || value["ref"] === void 0) return false;
  return true;
}
function AutoPaymentParamFromJSON(json) {
  return AutoPaymentParamFromJSONTyped(json, false);
}
function AutoPaymentParamFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    ref: json["ref"]
  };
}
function AutoPaymentParamToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    ref: value["ref"]
  };
}

// src/rentals-api-v3/models/AutoPaymentRequest.ts
function instanceOfAutoPaymentRequest(value) {
  if (!("setAutoPayment" in value) || value["setAutoPayment"] === void 0) return false;
  return true;
}
function AutoPaymentRequestFromJSON(json) {
  return AutoPaymentRequestFromJSONTyped(json, false);
}
function AutoPaymentRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    setAutoPayment: json["setAutoPayment"]
  };
}
function AutoPaymentRequestToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    setAutoPayment: value["setAutoPayment"]
  };
}

// src/rentals-api-v3/runtime.ts
import { formatISO } from "date-fns";
var BASE_PATH = "https://rentals.api.jucy.cloud".replace(/\/+$/, "");
var Configuration = class {
  constructor(configuration = {}) {
    this.configuration = configuration;
  }
  set config(configuration) {
    this.configuration = configuration;
  }
  get basePath() {
    return this.configuration.basePath != null ? this.configuration.basePath : BASE_PATH;
  }
  get fetchApi() {
    return this.configuration.fetchApi || fetch;
  }
  get middleware() {
    return this.configuration.middleware || [];
  }
  get queryParamsStringify() {
    return this.configuration.queryParamsStringify || querystring;
  }
  get username() {
    return this.configuration.username;
  }
  get password() {
    return this.configuration.password;
  }
  get apiKey() {
    const apiKey = this.configuration.apiKey;
    if (apiKey) {
      return typeof apiKey === "function" ? apiKey : () => apiKey;
    }
    return void 0;
  }
  get accessToken() {
    const accessToken = this.configuration.accessToken;
    if (accessToken) {
      return typeof accessToken === "function" ? accessToken : async () => accessToken;
    }
    return void 0;
  }
  get headers() {
    return this.configuration.headers;
  }
  get credentials() {
    return this.configuration.credentials;
  }
};
var DefaultConfig = new Configuration();
async function createResponseErrorMessage(response, fallback = "Response returned an error code") {
  try {
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.startsWith("application/json")) {
      const json = await response.json();
      return new ResponseError(response, json?.message || json?.Message || response.statusText || fallback, json);
    }
    const body = await response.text();
    return new ResponseError(response, body || response.statusText || fallback, { body });
  } catch (e) {
    return new ResponseError(response, fallback, { error: e });
  }
}
var BaseAPI = class _BaseAPI {
  constructor(configuration = DefaultConfig) {
    this.configuration = configuration;
    this.middleware = configuration.middleware;
  }
  static jsonRegex = new RegExp("^(:?application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(:?;.*)?$", "i");
  middleware;
  withMiddleware(...middlewares) {
    const next = this.clone();
    next.middleware = next.middleware.concat(...middlewares);
    return next;
  }
  withPreMiddleware(...preMiddlewares) {
    const middlewares = preMiddlewares.map((pre) => ({ pre }));
    return this.withMiddleware(...middlewares);
  }
  withPostMiddleware(...postMiddlewares) {
    const middlewares = postMiddlewares.map((post) => ({ post }));
    return this.withMiddleware(...middlewares);
  }
  /**
   * Check if the given MIME is a JSON MIME.
   * JSON MIME examples:
   *   application/json
   *   application/json; charset=UTF8
   *   APPLICATION/JSON
   *   application/vnd.company+json
   * @param mime - MIME (Multipurpose Internet Mail Extensions)
   * @return True if the given MIME is JSON, false otherwise.
   */
  isJsonMime(mime) {
    if (!mime) {
      return false;
    }
    return _BaseAPI.jsonRegex.test(mime);
  }
  async request(context, initOverrides) {
    const { url, init } = await this.createFetchParams(context, initOverrides);
    const response = await this.fetchApi(url, init);
    if (response && response.status >= 200 && response.status < 300) {
      return response;
    }
    throw await createResponseErrorMessage(response, "Response returned an error code");
  }
  async createFetchParams(context, initOverrides) {
    let url = this.configuration.basePath + context.path;
    if (context.query !== void 0 && Object.keys(context.query).length !== 0) {
      url += "?" + this.configuration.queryParamsStringify(context.query);
    }
    const headers = Object.assign({}, this.configuration.headers, context.headers);
    Object.keys(headers).forEach((key) => headers[key] === void 0 ? delete headers[key] : {});
    const initOverrideFn = typeof initOverrides === "function" ? initOverrides : async () => initOverrides;
    const initParams = {
      method: context.method,
      headers,
      body: context.body,
      credentials: this.configuration.credentials
    };
    const overriddenInit = {
      ...initParams,
      ...await initOverrideFn({
        init: initParams,
        context
      })
    };
    let body;
    if (isFormData(overriddenInit.body) || overriddenInit.body instanceof URLSearchParams || isBlob(overriddenInit.body)) {
      body = overriddenInit.body;
    } else if (this.isJsonMime(headers["Content-Type"])) {
      body = JSON.stringify(overriddenInit.body);
    } else {
      body = overriddenInit.body;
    }
    const init = {
      ...overriddenInit,
      body
    };
    return { url, init };
  }
  fetchApi = async (url, init) => {
    let fetchParams = { url, init };
    for (const middleware of this.middleware) {
      if (middleware.pre) {
        fetchParams = await middleware.pre({
          fetch: this.fetchApi,
          ...fetchParams
        }) || fetchParams;
      }
    }
    let response = void 0;
    try {
      response = await (this.configuration.fetchApi || fetch)(fetchParams.url, fetchParams.init);
    } catch (e) {
      for (const middleware of this.middleware) {
        if (middleware.onError) {
          response = await middleware.onError({
            fetch: this.fetchApi,
            url: fetchParams.url,
            init: fetchParams.init,
            error: e,
            response: response ? response.clone() : void 0
          }) || response;
        }
      }
      if (response === void 0) {
        if (e instanceof Error) {
          throw new FetchError(e, "The request failed and the interceptors did not return an alternative response");
        } else {
          throw e;
        }
      }
    }
    for (const middleware of this.middleware) {
      if (middleware.post) {
        response = await middleware.post({
          fetch: this.fetchApi,
          url: fetchParams.url,
          init: fetchParams.init,
          response: response.clone()
        }) || response;
      }
    }
    return response;
  };
  /**
   * Create a shallow clone of `this` by constructing a new instance
   * and then shallow cloning data members.
   */
  clone() {
    const constructor = this.constructor;
    const next = new constructor(this.configuration);
    next.middleware = this.middleware.slice();
    return next;
  }
};
function isBlob(value) {
  return typeof Blob !== "undefined" && value instanceof Blob;
}
function isFormData(value) {
  return typeof FormData !== "undefined" && value instanceof FormData;
}
function stringToDate(value) {
  return value ? new Date(value.replace(/Z$/, "")) : /* @__PURE__ */ new Date("invalid");
}
function dateToString(value) {
  return value ? formatISO(value)?.replace(/Z$/, "") : void 0;
}
var ResponseError = class extends Error {
  constructor(response, msg, data) {
    super(msg);
    this.response = response;
    this.data = data;
  }
  name = "ResponseError";
  data;
};
var FetchError = class extends Error {
  constructor(cause, msg) {
    super(msg);
    this.cause = cause;
  }
  name = "FetchError";
};
function querystring(params, prefix = "") {
  return Object.keys(params).map((key) => querystringSingleKey(key, params[key], prefix)).filter((part) => part.length > 0).join("&");
}
function querystringSingleKey(key, value, keyPrefix = "") {
  const fullKey = keyPrefix + (keyPrefix.length ? `[${key}]` : key);
  if (value instanceof Array) {
    const multiValue = value.map((singleValue) => encodeURIComponent(String(singleValue))).join(`&${encodeURIComponent(fullKey)}=`);
    return `${encodeURIComponent(fullKey)}=${multiValue}`;
  }
  if (value instanceof Set) {
    const valueAsArray = Array.from(value);
    return querystringSingleKey(key, valueAsArray, keyPrefix);
  }
  if (value instanceof Date) {
    return `${encodeURIComponent(fullKey)}=${encodeURIComponent(formatISO(value))}`;
  }
  if (value instanceof Object) {
    return querystring(value, fullKey);
  }
  return `${encodeURIComponent(fullKey)}=${encodeURIComponent(String(value))}`;
}

// src/rentals-api-v3/models/MandatoryProduct.ts
function instanceOfMandatoryProduct(value) {
  if (!("productId" in value) || value["productId"] === void 0) return false;
  if (!("sortOrder" in value) || value["sortOrder"] === void 0) return false;
  if (!("productCode" in value) || value["productCode"] === void 0) return false;
  if (!("name" in value) || value["name"] === void 0) return false;
  if (!("category" in value) || value["category"] === void 0) return false;
  if (!("isMandatory" in value) || value["isMandatory"] === void 0) return false;
  if (!("description" in value) || value["description"] === void 0) return false;
  if (!("price" in value) || value["price"] === void 0) return false;
  if (!("productType" in value) || value["productType"] === void 0) return false;
  if (!("isPercentageOnTotalCost" in value) || value["isPercentageOnTotalCost"] === void 0) return false;
  if (!("allowMultiple" in value) || value["allowMultiple"] === void 0) return false;
  if (!("commissionable" in value) || value["commissionable"] === void 0) return false;
  if (!("rentalDays" in value) || value["rentalDays"] === void 0) return false;
  if (!("numberOfDaysCalculated" in value) || value["numberOfDaysCalculated"] === void 0) return false;
  if (!("qty" in value) || value["qty"] === void 0) return false;
  if (!("total" in value) || value["total"] === void 0) return false;
  return true;
}
function MandatoryProductFromJSON(json) {
  return MandatoryProductFromJSONTyped(json, false);
}
function MandatoryProductFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    productId: json["productId"],
    sortOrder: json["sortOrder"],
    productCode: json["productCode"],
    name: json["name"],
    category: json["category"],
    isMandatory: json["isMandatory"],
    description: json["description"],
    price: CurrencyValueFromJSON(json["price"]),
    productType: json["productType"],
    isPercentageOnTotalCost: json["isPercentageOnTotalCost"],
    allowMultiple: json["allowMultiple"],
    commissionable: json["commissionable"],
    associatedProductCode: json["associatedProductCode"] == null ? void 0 : json["associatedProductCode"],
    rentalDays: json["rentalDays"],
    numberOfDaysCalculated: json["numberOfDaysCalculated"],
    maxPrice: json["maxPrice"] == null ? void 0 : CurrencyValueFromJSON(json["maxPrice"]),
    qty: json["qty"],
    total: CurrencyValueFromJSON(json["total"]),
    isExcluded: json["isExcluded"] == null ? void 0 : json["isExcluded"]
  };
}
function MandatoryProductToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    productId: value["productId"],
    sortOrder: value["sortOrder"],
    productCode: value["productCode"],
    name: value["name"],
    category: value["category"],
    isMandatory: value["isMandatory"],
    description: value["description"],
    price: CurrencyValueToJSON(value["price"]),
    productType: value["productType"],
    isPercentageOnTotalCost: value["isPercentageOnTotalCost"],
    allowMultiple: value["allowMultiple"],
    commissionable: value["commissionable"],
    associatedProductCode: value["associatedProductCode"],
    rentalDays: value["rentalDays"],
    numberOfDaysCalculated: value["numberOfDaysCalculated"],
    maxPrice: CurrencyValueToJSON(value["maxPrice"]),
    qty: value["qty"],
    total: CurrencyValueToJSON(value["total"]),
    isExcluded: value["isExcluded"]
  };
}

// src/rentals-api-v3/models/FleetCategory.ts
var FleetCategoryAvailabilityEnum = {
  FreeSell: "FreeSell",
  OnRequest: "OnRequest",
  StopSell: "StopSell",
  MinimumHire: "MinimumHire"
};
function instanceOfFleetCategory(value) {
  if (!("name" in value) || value["name"] === void 0) return false;
  if (!("description" in value) || value["description"] === void 0) return false;
  if (!("code" in value) || value["code"] === void 0) return false;
  if (!("categoryCode" in value) || value["categoryCode"] === void 0) return false;
  if (!("id" in value) || value["id"] === void 0) return false;
  if (!("type" in value) || value["type"] === void 0) return false;
  if (!("rentalDays" in value) || value["rentalDays"] === void 0) return false;
  if (!("fleetTypeCode" in value) || value["fleetTypeCode"] === void 0) return false;
  if (!("availabilityMessage" in value) || value["availabilityMessage"] === void 0) return false;
  if (!("dailyRate" in value) || value["dailyRate"] === void 0) return false;
  if (!("total" in value) || value["total"] === void 0) return false;
  if (!("availability" in value) || value["availability"] === void 0) return false;
  return true;
}
function FleetCategoryFromJSON(json) {
  return FleetCategoryFromJSONTyped(json, false);
}
function FleetCategoryFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
    description: json["description"],
    code: json["code"],
    categoryCode: json["categoryCode"],
    campaignCode: json["campaignCode"] == null ? void 0 : json["campaignCode"],
    campaignId: json["campaignId"] == null ? void 0 : json["campaignId"],
    id: json["id"],
    type: json["type"],
    rentalDays: json["rentalDays"],
    dealText: json["dealText"] == null ? void 0 : json["dealText"],
    freeDays: json["freeDays"] == null ? void 0 : json["freeDays"],
    fleetTypeCode: json["fleetTypeCode"],
    availabilityMessage: json["availabilityMessage"],
    dailyRate: CurrencyValueFromJSON(json["dailyRate"]),
    total: CurrencyValueFromJSON(json["total"]),
    discountPercentageApplied: json["discountPercentageApplied"] == null ? void 0 : json["discountPercentageApplied"],
    mandatoryFees: json["mandatoryFees"] == null ? void 0 : json["mandatoryFees"].map(MandatoryProductFromJSON),
    minimumHirePeriod: json["minimumHirePeriod"] == null ? void 0 : json["minimumHirePeriod"],
    isAfterHourPickUp: json["isAfterHourPickUp"] == null ? void 0 : json["isAfterHourPickUp"],
    availability: json["availability"]
  };
}
function FleetCategoryToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    name: value["name"],
    description: value["description"],
    code: value["code"],
    categoryCode: value["categoryCode"],
    campaignCode: value["campaignCode"],
    campaignId: value["campaignId"],
    id: value["id"],
    type: value["type"],
    rentalDays: value["rentalDays"],
    dealText: value["dealText"],
    freeDays: value["freeDays"],
    fleetTypeCode: value["fleetTypeCode"],
    availabilityMessage: value["availabilityMessage"],
    dailyRate: CurrencyValueToJSON(value["dailyRate"]),
    total: CurrencyValueToJSON(value["total"]),
    discountPercentageApplied: value["discountPercentageApplied"],
    mandatoryFees: value["mandatoryFees"] == null ? void 0 : value["mandatoryFees"].map(MandatoryProductToJSON),
    minimumHirePeriod: value["minimumHirePeriod"],
    isAfterHourPickUp: value["isAfterHourPickUp"],
    availability: value["availability"]
  };
}

// src/rentals-api-v3/models/AvailabilitySearchResponse.ts
function instanceOfAvailabilitySearchResponse(value) {
  if (!("pickUpLocation" in value) || value["pickUpLocation"] === void 0) return false;
  if (!("dropOffLocation" in value) || value["dropOffLocation"] === void 0) return false;
  if (!("pickUpDate" in value) || value["pickUpDate"] === void 0) return false;
  if (!("dropOffDate" in value) || value["dropOffDate"] === void 0) return false;
  if (!("rentalDays" in value) || value["rentalDays"] === void 0) return false;
  if (!("fleetCategories" in value) || value["fleetCategories"] === void 0) return false;
  return true;
}
function AvailabilitySearchResponseFromJSON(json) {
  return AvailabilitySearchResponseFromJSONTyped(json, false);
}
function AvailabilitySearchResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    pickUpLocation: json["pickUpLocation"],
    dropOffLocation: json["dropOffLocation"],
    pickUpDate: stringToDate(json["pickUpDate"]),
    dropOffDate: stringToDate(json["dropOffDate"]),
    rentalDays: json["rentalDays"],
    fleetCategories: json["fleetCategories"].map(FleetCategoryFromJSON)
  };
}
function AvailabilitySearchResponseToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    pickUpLocation: value["pickUpLocation"],
    dropOffLocation: value["dropOffLocation"],
    pickUpDate: dateToString(value["pickUpDate"]),
    dropOffDate: dateToString(value["dropOffDate"]),
    rentalDays: value["rentalDays"],
    fleetCategories: value["fleetCategories"].map(FleetCategoryToJSON)
  };
}

// src/rentals-api-v3/models/AvailabilityType.ts
var AvailabilityType = {
  FreeSell: "FreeSell",
  OnRequest: "OnRequest",
  StopSell: "StopSell",
  MinimumHire: "MinimumHire"
};
function instanceOfAvailabilityType(value) {
  for (const key in AvailabilityType) {
    if (Object.prototype.hasOwnProperty.call(AvailabilityType, key)) {
      if (AvailabilityType[key] === value) {
        return true;
      }
    }
  }
  return false;
}
function AvailabilityTypeFromJSON(json) {
  return AvailabilityTypeFromJSONTyped(json, false);
}
function AvailabilityTypeFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function AvailabilityTypeToJSON(value) {
  return value;
}

// src/rentals-api-v3/models/BookedWith.ts
function instanceOfBookedWith(value) {
  if (!("name" in value) || value["name"] === void 0) return false;
  return true;
}
function BookedWithFromJSON(json) {
  return BookedWithFromJSONTyped(json, false);
}
function BookedWithFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
    email: json["email"] == null ? void 0 : json["email"],
    phone: json["phone"] == null ? void 0 : json["phone"],
    logo: json["logo"] == null ? void 0 : json["logo"]
  };
}
function BookedWithToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    name: value["name"],
    email: value["email"],
    phone: value["phone"],
    logo: value["logo"]
  };
}

// src/rentals-api-v3/models/InsuranceType.ts
var InsuranceType = {
  Full: "Full",
  Standard: "Standard",
  Basic: "Basic",
  Partner: "Partner"
};
function instanceOfInsuranceType(value) {
  for (const key in InsuranceType) {
    if (Object.prototype.hasOwnProperty.call(InsuranceType, key)) {
      if (InsuranceType[key] === value) {
        return true;
      }
    }
  }
  return false;
}
function InsuranceTypeFromJSON(json) {
  return InsuranceTypeFromJSONTyped(json, false);
}
function InsuranceTypeFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function InsuranceTypeToJSON(value) {
  return value;
}

// src/rentals-api-v3/models/BookingLinesInner.ts
var BookingLinesInnerCategoryEnum = {
  InsuranceFee: "InsuranceFee"
};
function instanceOfBookingLinesInner(value) {
  if (!("productId" in value) || value["productId"] === void 0) return false;
  if (!("sortOrder" in value) || value["sortOrder"] === void 0) return false;
  if (!("productCode" in value) || value["productCode"] === void 0) return false;
  if (!("name" in value) || value["name"] === void 0) return false;
  if (!("category" in value) || value["category"] === void 0) return false;
  if (!("isMandatory" in value) || value["isMandatory"] === void 0) return false;
  if (!("description" in value) || value["description"] === void 0) return false;
  if (!("price" in value) || value["price"] === void 0) return false;
  if (!("productType" in value) || value["productType"] === void 0) return false;
  if (!("isPercentageOnTotalCost" in value) || value["isPercentageOnTotalCost"] === void 0) return false;
  if (!("allowMultiple" in value) || value["allowMultiple"] === void 0) return false;
  if (!("commissionable" in value) || value["commissionable"] === void 0) return false;
  if (!("rentalDays" in value) || value["rentalDays"] === void 0) return false;
  if (!("numberOfDaysCalculated" in value) || value["numberOfDaysCalculated"] === void 0) return false;
  if (!("qty" in value) || value["qty"] === void 0) return false;
  if (!("total" in value) || value["total"] === void 0) return false;
  if (!("excessType" in value) || value["excessType"] === void 0) return false;
  if (!("excess" in value) || value["excess"] === void 0) return false;
  if (!("bond" in value) || value["bond"] === void 0) return false;
  return true;
}
function BookingLinesInnerFromJSON(json) {
  return BookingLinesInnerFromJSONTyped(json, false);
}
function BookingLinesInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    productId: json["productId"],
    sortOrder: json["sortOrder"],
    productCode: json["productCode"],
    name: json["name"],
    category: json["category"],
    isMandatory: json["isMandatory"],
    description: json["description"],
    price: CurrencyValueFromJSON(json["price"]),
    productType: json["productType"],
    isPercentageOnTotalCost: json["isPercentageOnTotalCost"],
    allowMultiple: json["allowMultiple"],
    commissionable: json["commissionable"],
    associatedProductCode: json["associatedProductCode"] == null ? void 0 : json["associatedProductCode"],
    rentalDays: json["rentalDays"],
    numberOfDaysCalculated: json["numberOfDaysCalculated"],
    maxPrice: json["maxPrice"] == null ? void 0 : CurrencyValueFromJSON(json["maxPrice"]),
    qty: json["qty"],
    total: CurrencyValueFromJSON(json["total"]),
    isExcluded: json["isExcluded"] == null ? void 0 : json["isExcluded"],
    excessType: InsuranceTypeFromJSON(json["excessType"]),
    excess: CurrencyValueFromJSON(json["excess"]),
    bond: CurrencyValueFromJSON(json["bond"])
  };
}
function BookingLinesInnerToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    productId: value["productId"],
    sortOrder: value["sortOrder"],
    productCode: value["productCode"],
    name: value["name"],
    category: value["category"],
    isMandatory: value["isMandatory"],
    description: value["description"],
    price: CurrencyValueToJSON(value["price"]),
    productType: value["productType"],
    isPercentageOnTotalCost: value["isPercentageOnTotalCost"],
    allowMultiple: value["allowMultiple"],
    commissionable: value["commissionable"],
    associatedProductCode: value["associatedProductCode"],
    rentalDays: value["rentalDays"],
    numberOfDaysCalculated: value["numberOfDaysCalculated"],
    maxPrice: CurrencyValueToJSON(value["maxPrice"]),
    qty: value["qty"],
    total: CurrencyValueToJSON(value["total"]),
    isExcluded: value["isExcluded"],
    excessType: InsuranceTypeToJSON(value["excessType"]),
    excess: CurrencyValueToJSON(value["excess"]),
    bond: CurrencyValueToJSON(value["bond"])
  };
}

// src/rentals-api-v3/models/BookingPaymentInfo.ts
function instanceOfBookingPaymentInfo(value) {
  if (!("amount" in value) || value["amount"] === void 0) return false;
  if (!("date" in value) || value["date"] === void 0) return false;
  if (!("type" in value) || value["type"] === void 0) return false;
  return true;
}
function BookingPaymentInfoFromJSON(json) {
  return BookingPaymentInfoFromJSONTyped(json, false);
}
function BookingPaymentInfoFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    amount: CurrencyValueFromJSON(json["amount"]),
    date: stringToDate(json["date"]),
    type: json["type"],
    merchantFeeName: json["merchantFeeName"] == null ? void 0 : json["merchantFeeName"],
    merchantFeeAmount: json["merchantFeeAmount"] == null ? void 0 : CurrencyValueFromJSON(json["merchantFeeAmount"]),
    total: json["total"] == null ? void 0 : CurrencyValueFromJSON(json["total"])
  };
}
function BookingPaymentInfoToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    amount: CurrencyValueToJSON(value["amount"]),
    date: dateToString(value["date"])?.substring(0, 10),
    type: value["type"],
    merchantFeeName: value["merchantFeeName"],
    merchantFeeAmount: CurrencyValueToJSON(value["merchantFeeAmount"]),
    total: CurrencyValueToJSON(value["total"])
  };
}

// src/rentals-api-v3/models/BookingStatus.ts
var BookingStatus = {
  Quote: "quote",
  ReservationConfirmed: "reservation-confirmed",
  Cancelled: "cancelled",
  Returned: "returned",
  ReservationRequest: "reservation-request",
  Hired: "hired",
  Maintenance: "maintenance"
};
function instanceOfBookingStatus(value) {
  for (const key in BookingStatus) {
    if (Object.prototype.hasOwnProperty.call(BookingStatus, key)) {
      if (BookingStatus[key] === value) {
        return true;
      }
    }
  }
  return false;
}
function BookingStatusFromJSON(json) {
  return BookingStatusFromJSONTyped(json, false);
}
function BookingStatusFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function BookingStatusToJSON(value) {
  return value;
}

// src/rentals-api-v3/models/DriversLicence.ts
function instanceOfDriversLicence(value) {
  if (!("country" in value) || value["country"] === void 0) return false;
  return true;
}
function DriversLicenceFromJSON(json) {
  return DriversLicenceFromJSONTyped(json, false);
}
function DriversLicenceFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    expiry: json["expiry"] == null ? void 0 : stringToDate(json["expiry"]),
    country: json["country"],
    number: json["number"] == null ? void 0 : json["number"]
  };
}
function DriversLicenceToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    expiry: value.expiry === void 0 ? void 0 : dateToString(value["expiry"])?.substring(0, 10),
    country: value["country"],
    number: value["number"]
  };
}

// src/rentals-api-v3/models/HirerDetails.ts
function instanceOfHirerDetails(value) {
  if (!("firstName" in value) || value["firstName"] === void 0) return false;
  if (!("lastName" in value) || value["lastName"] === void 0) return false;
  if (!("email" in value) || value["email"] === void 0) return false;
  if (!("mobileNumber" in value) || value["mobileNumber"] === void 0) return false;
  return true;
}
function HirerDetailsFromJSON(json) {
  return HirerDetailsFromJSONTyped(json, false);
}
function HirerDetailsFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    firstName: json["firstName"],
    lastName: json["lastName"],
    email: json["email"],
    mobileNumber: json["mobileNumber"],
    address: json["address"] == null ? void 0 : AddressFromJSON(json["address"]),
    dateOfBirth: json["dateOfBirth"] == null ? void 0 : stringToDate(json["dateOfBirth"]),
    driversLicence: json["driversLicence"] == null ? void 0 : DriversLicenceFromJSON(json["driversLicence"]),
    lucyClubNumber: json["lucyClubNumber"] == null ? void 0 : json["lucyClubNumber"],
    mailingList: json["mailingList"] == null ? void 0 : json["mailingList"],
    arrivalFlightNumber: json["arrivalFlightNumber"] == null ? void 0 : json["arrivalFlightNumber"],
    departureFlightNumber: json["departureFlightNumber"] == null ? void 0 : json["departureFlightNumber"],
    numberOfPeople: json["numberOfPeople"] == null ? void 0 : json["numberOfPeople"],
    loyalty: json["loyalty"] == null ? void 0 : json["loyalty"]
  };
}
function HirerDetailsToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    firstName: value["firstName"],
    lastName: value["lastName"],
    email: value["email"],
    mobileNumber: value["mobileNumber"],
    address: AddressToJSON(value["address"]),
    dateOfBirth: value.dateOfBirth === void 0 ? void 0 : dateToString(value["dateOfBirth"])?.substring(0, 10),
    driversLicence: DriversLicenceToJSON(value["driversLicence"]),
    lucyClubNumber: value["lucyClubNumber"],
    mailingList: value["mailingList"],
    arrivalFlightNumber: value["arrivalFlightNumber"],
    departureFlightNumber: value["departureFlightNumber"],
    numberOfPeople: value["numberOfPeople"],
    loyalty: value["loyalty"]
  };
}

// src/rentals-api-v3/models/Booking.ts
function instanceOfBooking(value) {
  if (!("quoteId" in value) || value["quoteId"] === void 0) return false;
  if (!("reservationId" in value) || value["reservationId"] === void 0) return false;
  if (!("reservationReference" in value) || value["reservationReference"] === void 0) return false;
  if (!("status" in value) || value["status"] === void 0) return false;
  if (!("pickUpLocation" in value) || value["pickUpLocation"] === void 0) return false;
  if (!("dropOffLocation" in value) || value["dropOffLocation"] === void 0) return false;
  if (!("dateCreated" in value) || value["dateCreated"] === void 0) return false;
  if (!("pickUpDate" in value) || value["pickUpDate"] === void 0) return false;
  if (!("dropOffDate" in value) || value["dropOffDate"] === void 0) return false;
  if (!("rentalDays" in value) || value["rentalDays"] === void 0) return false;
  if (!("totalPrice" in value) || value["totalPrice"] === void 0) return false;
  if (!("driverAge" in value) || value["driverAge"] === void 0) return false;
  if (!("fleetCategory" in value) || value["fleetCategory"] === void 0) return false;
  return true;
}
function BookingFromJSON(json) {
  return BookingFromJSONTyped(json, false);
}
function BookingFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    quoteId: json["quoteId"],
    reservationId: json["reservationId"],
    reservationReference: json["reservationReference"],
    agentBalanceDue: json["agentBalanceDue"] == null ? void 0 : CurrencyValueFromJSON(json["agentBalanceDue"]),
    agentCollects: json["agentCollects"] == null ? void 0 : CurrencyValueFromJSON(json["agentCollects"]),
    agentCommission: json["agentCommission"] == null ? void 0 : CurrencyValueFromJSON(json["agentCommission"]),
    voucherReference: json["voucherReference"] == null ? void 0 : json["voucherReference"],
    agentName: json["agentName"] == null ? void 0 : json["agentName"],
    balanceDue: json["balanceDue"] == null ? void 0 : CurrencyValueFromJSON(json["balanceDue"]),
    payments: json["payments"] == null ? void 0 : json["payments"].map(BookingPaymentInfoFromJSON),
    status: BookingStatusFromJSON(json["status"]),
    pickUpLocation: json["pickUpLocation"],
    dropOffLocation: json["dropOffLocation"],
    dateCreated: stringToDate(json["dateCreated"]),
    pickUpDate: stringToDate(json["pickUpDate"]),
    dropOffDate: stringToDate(json["dropOffDate"]),
    rentalDays: json["rentalDays"],
    totalPrice: CurrencyValueFromJSON(json["totalPrice"]),
    driverAge: json["driverAge"],
    lines: json["lines"] == null ? void 0 : json["lines"].map(BookingLinesInnerFromJSON),
    hirerDetails: json["hirerDetails"] == null ? void 0 : HirerDetailsFromJSON(json["hirerDetails"]),
    fleetCategory: FleetCategoryFromJSON(json["fleetCategory"]),
    referrerCode: json["referrerCode"] == null ? void 0 : json["referrerCode"]
  };
}
function BookingToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    quoteId: value["quoteId"],
    reservationId: value["reservationId"],
    reservationReference: value["reservationReference"],
    agentBalanceDue: CurrencyValueToJSON(value["agentBalanceDue"]),
    agentCollects: CurrencyValueToJSON(value["agentCollects"]),
    agentCommission: CurrencyValueToJSON(value["agentCommission"]),
    voucherReference: value["voucherReference"],
    agentName: value["agentName"],
    balanceDue: CurrencyValueToJSON(value["balanceDue"]),
    payments: value["payments"] == null ? void 0 : value["payments"].map(BookingPaymentInfoToJSON),
    status: BookingStatusToJSON(value["status"]),
    pickUpLocation: value["pickUpLocation"],
    dropOffLocation: value["dropOffLocation"],
    dateCreated: dateToString(value["dateCreated"]),
    pickUpDate: dateToString(value["pickUpDate"]),
    dropOffDate: dateToString(value["dropOffDate"]),
    rentalDays: value["rentalDays"],
    totalPrice: CurrencyValueToJSON(value["totalPrice"]),
    driverAge: value["driverAge"],
    lines: value["lines"] == null ? void 0 : value["lines"].map(BookingLinesInnerToJSON),
    hirerDetails: HirerDetailsToJSON(value["hirerDetails"]),
    fleetCategory: FleetCategoryToJSON(value["fleetCategory"]),
    referrerCode: value["referrerCode"]
  };
}

// src/rentals-api-v3/models/InsuranceProduct.ts
function instanceOfInsuranceProduct(value) {
  if (!("productId" in value) || value["productId"] === void 0) return false;
  if (!("sortOrder" in value) || value["sortOrder"] === void 0) return false;
  if (!("productCode" in value) || value["productCode"] === void 0) return false;
  if (!("name" in value) || value["name"] === void 0) return false;
  if (!("category" in value) || value["category"] === void 0) return false;
  if (!("isMandatory" in value) || value["isMandatory"] === void 0) return false;
  if (!("description" in value) || value["description"] === void 0) return false;
  if (!("price" in value) || value["price"] === void 0) return false;
  if (!("productType" in value) || value["productType"] === void 0) return false;
  if (!("isPercentageOnTotalCost" in value) || value["isPercentageOnTotalCost"] === void 0) return false;
  if (!("allowMultiple" in value) || value["allowMultiple"] === void 0) return false;
  if (!("commissionable" in value) || value["commissionable"] === void 0) return false;
  if (!("rentalDays" in value) || value["rentalDays"] === void 0) return false;
  if (!("numberOfDaysCalculated" in value) || value["numberOfDaysCalculated"] === void 0) return false;
  if (!("excessType" in value) || value["excessType"] === void 0) return false;
  if (!("excess" in value) || value["excess"] === void 0) return false;
  if (!("bond" in value) || value["bond"] === void 0) return false;
  return true;
}
function InsuranceProductFromJSON(json) {
  return InsuranceProductFromJSONTyped(json, false);
}
function InsuranceProductFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    productId: json["productId"],
    sortOrder: json["sortOrder"],
    productCode: json["productCode"],
    name: json["name"],
    category: json["category"],
    isMandatory: json["isMandatory"],
    description: json["description"],
    price: CurrencyValueFromJSON(json["price"]),
    productType: json["productType"],
    isPercentageOnTotalCost: json["isPercentageOnTotalCost"],
    allowMultiple: json["allowMultiple"],
    commissionable: json["commissionable"],
    associatedProductCode: json["associatedProductCode"] == null ? void 0 : json["associatedProductCode"],
    rentalDays: json["rentalDays"],
    numberOfDaysCalculated: json["numberOfDaysCalculated"],
    maxPrice: json["maxPrice"] == null ? void 0 : CurrencyValueFromJSON(json["maxPrice"]),
    excessType: InsuranceTypeFromJSON(json["excessType"]),
    excess: CurrencyValueFromJSON(json["excess"]),
    bond: CurrencyValueFromJSON(json["bond"]),
    rcmId: json["rcmId"] == null ? void 0 : json["rcmId"]
  };
}
function InsuranceProductToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    productId: value["productId"],
    sortOrder: value["sortOrder"],
    productCode: value["productCode"],
    name: value["name"],
    category: value["category"],
    isMandatory: value["isMandatory"],
    description: value["description"],
    price: CurrencyValueToJSON(value["price"]),
    productType: value["productType"],
    isPercentageOnTotalCost: value["isPercentageOnTotalCost"],
    allowMultiple: value["allowMultiple"],
    commissionable: value["commissionable"],
    associatedProductCode: value["associatedProductCode"],
    rentalDays: value["rentalDays"],
    numberOfDaysCalculated: value["numberOfDaysCalculated"],
    maxPrice: CurrencyValueToJSON(value["maxPrice"]),
    excessType: InsuranceTypeToJSON(value["excessType"]),
    excess: CurrencyValueToJSON(value["excess"]),
    bond: CurrencyValueToJSON(value["bond"]),
    rcmId: value["rcmId"]
  };
}

// src/rentals-api-v3/models/InsuranceProductGroup.ts
function instanceOfInsuranceProductGroup(value) {
  if (!("group" in value) || value["group"] === void 0) return false;
  if (!("webCategory" in value) || value["webCategory"] === void 0) return false;
  if (!("required" in value) || value["required"] === void 0) return false;
  if (!("allowMultiple" in value) || value["allowMultiple"] === void 0) return false;
  if (!("description" in value) || value["description"] === void 0) return false;
  if (!("items" in value) || value["items"] === void 0) return false;
  return true;
}
function InsuranceProductGroupFromJSON(json) {
  return InsuranceProductGroupFromJSONTyped(json, false);
}
function InsuranceProductGroupFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    group: json["group"],
    webCategory: json["webCategory"],
    required: json["required"],
    allowMultiple: json["allowMultiple"],
    description: json["description"],
    items: json["items"].map(InsuranceProductFromJSON)
  };
}
function InsuranceProductGroupToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    group: value["group"],
    webCategory: value["webCategory"],
    required: value["required"],
    allowMultiple: value["allowMultiple"],
    description: value["description"],
    items: value["items"].map(InsuranceProductToJSON)
  };
}

// src/rentals-api-v3/models/SecondaryProduct.ts
var SecondaryProductCategoryEnum = {
  SecondaryProduct: "SecondaryProduct",
  BundledProduct: "BundledProduct",
  FerryAccommodationProduct: "FerryAccommodationProduct",
  FerryVehicleProduct: "FerryVehicleProduct",
  FerryPassengerTicketProduct: "FerryPassengerTicketProduct"
};
function instanceOfSecondaryProduct(value) {
  if (!("productId" in value) || value["productId"] === void 0) return false;
  if (!("sortOrder" in value) || value["sortOrder"] === void 0) return false;
  if (!("productCode" in value) || value["productCode"] === void 0) return false;
  if (!("name" in value) || value["name"] === void 0) return false;
  if (!("category" in value) || value["category"] === void 0) return false;
  if (!("isMandatory" in value) || value["isMandatory"] === void 0) return false;
  if (!("description" in value) || value["description"] === void 0) return false;
  if (!("price" in value) || value["price"] === void 0) return false;
  if (!("productType" in value) || value["productType"] === void 0) return false;
  if (!("isPercentageOnTotalCost" in value) || value["isPercentageOnTotalCost"] === void 0) return false;
  if (!("allowMultiple" in value) || value["allowMultiple"] === void 0) return false;
  if (!("commissionable" in value) || value["commissionable"] === void 0) return false;
  if (!("rentalDays" in value) || value["rentalDays"] === void 0) return false;
  if (!("numberOfDaysCalculated" in value) || value["numberOfDaysCalculated"] === void 0) return false;
  return true;
}
function SecondaryProductFromJSON(json) {
  return SecondaryProductFromJSONTyped(json, false);
}
function SecondaryProductFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    productId: json["productId"],
    sortOrder: json["sortOrder"],
    productCode: json["productCode"],
    name: json["name"],
    category: json["category"],
    isMandatory: json["isMandatory"],
    description: json["description"],
    price: CurrencyValueFromJSON(json["price"]),
    productType: json["productType"],
    isPercentageOnTotalCost: json["isPercentageOnTotalCost"],
    allowMultiple: json["allowMultiple"],
    commissionable: json["commissionable"],
    associatedProductCode: json["associatedProductCode"] == null ? void 0 : json["associatedProductCode"],
    rentalDays: json["rentalDays"],
    numberOfDaysCalculated: json["numberOfDaysCalculated"],
    maxPrice: json["maxPrice"] == null ? void 0 : CurrencyValueFromJSON(json["maxPrice"])
  };
}
function SecondaryProductToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    productId: value["productId"],
    sortOrder: value["sortOrder"],
    productCode: value["productCode"],
    name: value["name"],
    category: value["category"],
    isMandatory: value["isMandatory"],
    description: value["description"],
    price: CurrencyValueToJSON(value["price"]),
    productType: value["productType"],
    isPercentageOnTotalCost: value["isPercentageOnTotalCost"],
    allowMultiple: value["allowMultiple"],
    commissionable: value["commissionable"],
    associatedProductCode: value["associatedProductCode"],
    rentalDays: value["rentalDays"],
    numberOfDaysCalculated: value["numberOfDaysCalculated"],
    maxPrice: CurrencyValueToJSON(value["maxPrice"])
  };
}

// src/rentals-api-v3/models/ProductBundle.ts
function instanceOfProductBundle(value) {
  if (!("productCode" in value) || value["productCode"] === void 0) return false;
  if (!("bundledProducts" in value) || value["bundledProducts"] === void 0) return false;
  return true;
}
function ProductBundleFromJSON(json) {
  return ProductBundleFromJSONTyped(json, false);
}
function ProductBundleFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    productCode: json["productCode"],
    bundledProducts: json["bundledProducts"].map(SecondaryProductFromJSON)
  };
}
function ProductBundleToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    productCode: value["productCode"],
    bundledProducts: value["bundledProducts"].map(SecondaryProductToJSON)
  };
}

// src/rentals-api-v3/models/SecondaryProductGroup.ts
function instanceOfSecondaryProductGroup(value) {
  if (!("group" in value) || value["group"] === void 0) return false;
  if (!("webCategory" in value) || value["webCategory"] === void 0) return false;
  if (!("required" in value) || value["required"] === void 0) return false;
  if (!("allowMultiple" in value) || value["allowMultiple"] === void 0) return false;
  if (!("description" in value) || value["description"] === void 0) return false;
  if (!("items" in value) || value["items"] === void 0) return false;
  return true;
}
function SecondaryProductGroupFromJSON(json) {
  return SecondaryProductGroupFromJSONTyped(json, false);
}
function SecondaryProductGroupFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    group: json["group"],
    webCategory: json["webCategory"],
    required: json["required"],
    allowMultiple: json["allowMultiple"],
    description: json["description"],
    items: json["items"].map(SecondaryProductFromJSON)
  };
}
function SecondaryProductGroupToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    group: value["group"],
    webCategory: value["webCategory"],
    required: value["required"],
    allowMultiple: value["allowMultiple"],
    description: value["description"],
    items: value["items"].map(SecondaryProductToJSON)
  };
}

// src/rentals-api-v3/models/BookingOptions.ts
function instanceOfBookingOptions(value) {
  if (!("secondaryProducts" in value) || value["secondaryProducts"] === void 0) return false;
  if (!("insuranceProducts" in value) || value["insuranceProducts"] === void 0) return false;
  return true;
}
function BookingOptionsFromJSON(json) {
  return BookingOptionsFromJSONTyped(json, false);
}
function BookingOptionsFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    secondaryProducts: json["secondaryProducts"].map(SecondaryProductGroupFromJSON),
    insuranceProducts: InsuranceProductGroupFromJSON(json["insuranceProducts"]),
    bundles: json["bundles"] == null ? void 0 : json["bundles"].map(ProductBundleFromJSON)
  };
}
function BookingOptionsToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    secondaryProducts: value["secondaryProducts"].map(SecondaryProductGroupToJSON),
    insuranceProducts: InsuranceProductGroupToJSON(value["insuranceProducts"]),
    bundles: value["bundles"] == null ? void 0 : value["bundles"].map(ProductBundleToJSON)
  };
}

// src/rentals-api-v3/models/BookingSummaryHirer.ts
function instanceOfBookingSummaryHirer(value) {
  if (!("firstName" in value) || value["firstName"] === void 0) return false;
  if (!("lastName" in value) || value["lastName"] === void 0) return false;
  if (!("email" in value) || value["email"] === void 0) return false;
  if (!("checkedIn" in value) || value["checkedIn"] === void 0) return false;
  return true;
}
function BookingSummaryHirerFromJSON(json) {
  return BookingSummaryHirerFromJSONTyped(json, false);
}
function BookingSummaryHirerFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    firstName: json["firstName"],
    lastName: json["lastName"],
    email: json["email"],
    checkedIn: json["checkedIn"]
  };
}
function BookingSummaryHirerToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    firstName: value["firstName"],
    lastName: value["lastName"],
    email: value["email"],
    checkedIn: value["checkedIn"]
  };
}

// src/rentals-api-v3/models/Brand.ts
var Brand = {
  Star: "star",
  Jucy: "jucy"
};
function instanceOfBrand(value) {
  for (const key in Brand) {
    if (Object.prototype.hasOwnProperty.call(Brand, key)) {
      if (Brand[key] === value) {
        return true;
      }
    }
  }
  return false;
}
function BrandFromJSON(json) {
  return BrandFromJSONTyped(json, false);
}
function BrandFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function BrandToJSON(value) {
  return value;
}

// src/rentals-api-v3/models/QuoteAvailability.ts
var QuoteAvailability = {
  Freesell: "freesell",
  Onrequest: "onrequest",
  Stopsell: "stopsell"
};
function instanceOfQuoteAvailability(value) {
  for (const key in QuoteAvailability) {
    if (Object.prototype.hasOwnProperty.call(QuoteAvailability, key)) {
      if (QuoteAvailability[key] === value) {
        return true;
      }
    }
  }
  return false;
}
function QuoteAvailabilityFromJSON(json) {
  return QuoteAvailabilityFromJSONTyped(json, false);
}
function QuoteAvailabilityFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function QuoteAvailabilityToJSON(value) {
  return value;
}

// src/rentals-api-v3/models/QuoteStatus.ts
var QuoteStatus = {
  Quote: "quote",
  Confirmed: "confirmed",
  Cancelled: "cancelled",
  OnRoad: "on-road",
  Returned: "returned"
};
function instanceOfQuoteStatus(value) {
  for (const key in QuoteStatus) {
    if (Object.prototype.hasOwnProperty.call(QuoteStatus, key)) {
      if (QuoteStatus[key] === value) {
        return true;
      }
    }
  }
  return false;
}
function QuoteStatusFromJSON(json) {
  return QuoteStatusFromJSONTyped(json, false);
}
function QuoteStatusFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function QuoteStatusToJSON(value) {
  return value;
}

// src/rentals-api-v3/models/BookingSummary.ts
function instanceOfBookingSummary(value) {
  if (!("id" in value) || value["id"] === void 0) return false;
  if (!("ref" in value) || value["ref"] === void 0) return false;
  if (!("bookingNo" in value) || value["bookingNo"] === void 0) return false;
  if (!("reservationId" in value) || value["reservationId"] === void 0) return false;
  if (!("created" in value) || value["created"] === void 0) return false;
  if (!("updated" in value) || value["updated"] === void 0) return false;
  if (!("status" in value) || value["status"] === void 0) return false;
  if (!("availability" in value) || value["availability"] === void 0) return false;
  if (!("hirer" in value) || value["hirer"] === void 0) return false;
  if (!("pickUpSiteCode" in value) || value["pickUpSiteCode"] === void 0) return false;
  if (!("pickUpSiteName" in value) || value["pickUpSiteName"] === void 0) return false;
  if (!("dropOffSiteCode" in value) || value["dropOffSiteCode"] === void 0) return false;
  if (!("dropOffSiteName" in value) || value["dropOffSiteName"] === void 0) return false;
  if (!("rentalDays" in value) || value["rentalDays"] === void 0) return false;
  if (!("pickUpDate" in value) || value["pickUpDate"] === void 0) return false;
  if (!("dropOffDate" in value) || value["dropOffDate"] === void 0) return false;
  if (!("disableCheckIn" in value) || value["disableCheckIn"] === void 0) return false;
  if (!("brand" in value) || value["brand"] === void 0) return false;
  return true;
}
function BookingSummaryFromJSON(json) {
  return BookingSummaryFromJSONTyped(json, false);
}
function BookingSummaryFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    ref: json["ref"],
    bookingNo: json["bookingNo"],
    reservationId: json["reservationId"],
    voucherRef: json["voucherRef"] == null ? void 0 : json["voucherRef"],
    created: stringToDate(json["created"]),
    updated: stringToDate(json["updated"]),
    status: QuoteStatusFromJSON(json["status"]),
    availability: QuoteAvailabilityFromJSON(json["availability"]),
    hirer: BookingSummaryHirerFromJSON(json["hirer"]),
    pickUpSiteCode: json["pickUpSiteCode"],
    pickUpSiteName: json["pickUpSiteName"],
    dropOffSiteCode: json["dropOffSiteCode"],
    dropOffSiteName: json["dropOffSiteName"],
    rentalDays: json["rentalDays"],
    pickUpDate: stringToDate(json["pickUpDate"]),
    dropOffDate: stringToDate(json["dropOffDate"]),
    disableCheckIn: json["disableCheckIn"],
    bookedWith: json["bookedWith"] == null ? void 0 : BookedWithFromJSON(json["bookedWith"]),
    brand: BrandFromJSON(json["brand"])
  };
}
function BookingSummaryToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    id: value["id"],
    ref: value["ref"],
    bookingNo: value["bookingNo"],
    reservationId: value["reservationId"],
    voucherRef: value["voucherRef"],
    created: dateToString(value["created"]),
    updated: dateToString(value["updated"]),
    status: QuoteStatusToJSON(value["status"]),
    availability: QuoteAvailabilityToJSON(value["availability"]),
    hirer: BookingSummaryHirerToJSON(value["hirer"]),
    pickUpSiteCode: value["pickUpSiteCode"],
    pickUpSiteName: value["pickUpSiteName"],
    dropOffSiteCode: value["dropOffSiteCode"],
    dropOffSiteName: value["dropOffSiteName"],
    rentalDays: value["rentalDays"],
    pickUpDate: dateToString(value["pickUpDate"]),
    dropOffDate: dateToString(value["dropOffDate"]),
    disableCheckIn: value["disableCheckIn"],
    bookedWith: BookedWithToJSON(value["bookedWith"]),
    brand: BrandToJSON(value["brand"])
  };
}

// src/rentals-api-v3/models/BookingSummaryQuery.ts
var BookingSummaryQueryStatusEnum = {
  Quote: "quote",
  Confirmed: "confirmed",
  Cancelled: "cancelled",
  OnRoad: "on-road",
  Returned: "returned"
};
function instanceOfBookingSummaryQuery(value) {
  return true;
}
function BookingSummaryQueryFromJSON(json) {
  return BookingSummaryQueryFromJSONTyped(json, false);
}
function BookingSummaryQueryFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    status: json["status"] == null ? void 0 : json["status"]
  };
}
function BookingSummaryQueryToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    status: value["status"]
  };
}

// src/rentals-api-v3/models/BookingSummaryResponse.ts
function instanceOfBookingSummaryResponse(value) {
  if (!("items" in value) || value["items"] === void 0) return false;
  return true;
}
function BookingSummaryResponseFromJSON(json) {
  return BookingSummaryResponseFromJSONTyped(json, false);
}
function BookingSummaryResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    items: json["items"].map(BookingSummaryFromJSON)
  };
}
function BookingSummaryResponseToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    items: value["items"].map(BookingSummaryToJSON)
  };
}

// src/rentals-api-v3/models/BookingSummaryStatus.ts
var BookingSummaryStatus = {
  Quote: "quote",
  Confirmed: "confirmed",
  Hired: "hired",
  Cancelled: "cancelled",
  Maintenance: "maintenance",
  Returned: "returned",
  OnRequest: "on-request"
};
function instanceOfBookingSummaryStatus(value) {
  for (const key in BookingSummaryStatus) {
    if (Object.prototype.hasOwnProperty.call(BookingSummaryStatus, key)) {
      if (BookingSummaryStatus[key] === value) {
        return true;
      }
    }
  }
  return false;
}
function BookingSummaryStatusFromJSON(json) {
  return BookingSummaryStatusFromJSONTyped(json, false);
}
function BookingSummaryStatusFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function BookingSummaryStatusToJSON(value) {
  return value;
}

// src/rentals-api-v3/models/BookingType.ts
var BookingType = {
  Quote: "quote",
  Booking: "booking"
};
function instanceOfBookingType(value) {
  for (const key in BookingType) {
    if (Object.prototype.hasOwnProperty.call(BookingType, key)) {
      if (BookingType[key] === value) {
        return true;
      }
    }
  }
  return false;
}
function BookingTypeFromJSON(json) {
  return BookingTypeFromJSONTyped(json, false);
}
function BookingTypeFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function BookingTypeToJSON(value) {
  return value;
}

// src/rentals-api-v3/models/BranchContentPages.ts
function instanceOfBranchContentPages(value) {
  return true;
}
function BranchContentPagesFromJSON(json) {
  return BranchContentPagesFromJSONTyped(json, false);
}
function BranchContentPagesFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    car: json["car"] == null ? void 0 : json["car"],
    camper: json["camper"] == null ? void 0 : json["camper"],
    motorhome: json["motorhome"] == null ? void 0 : json["motorhome"]
  };
}
function BranchContentPagesToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    car: value["car"],
    camper: value["camper"],
    motorhome: value["motorhome"]
  };
}

// src/rentals-api-v3/models/BranchContent.ts
function instanceOfBranchContent(value) {
  if (!("id" in value) || value["id"] === void 0) return false;
  if (!("name" in value) || value["name"] === void 0) return false;
  if (!("code" in value) || value["code"] === void 0) return false;
  if (!("mapInfo" in value) || value["mapInfo"] === void 0) return false;
  if (!("title" in value) || value["title"] === void 0) return false;
  if (!("content" in value) || value["content"] === void 0) return false;
  if (!("pages" in value) || value["pages"] === void 0) return false;
  if (!("brand" in value) || value["brand"] === void 0) return false;
  if (!("timezone" in value) || value["timezone"] === void 0) return false;
  if (!("countryCode" in value) || value["countryCode"] === void 0) return false;
  return true;
}
function BranchContentFromJSON(json) {
  return BranchContentFromJSONTyped(json, false);
}
function BranchContentFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
    code: json["code"],
    mapInfo: json["mapInfo"],
    title: json["title"],
    content: json["content"],
    pages: BranchContentPagesFromJSON(json["pages"]),
    brand: json["brand"],
    timezone: json["timezone"],
    countryCode: JucyCountryCodeFromJSON(json["countryCode"])
  };
}
function BranchContentToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    id: value["id"],
    name: value["name"],
    code: value["code"],
    mapInfo: value["mapInfo"],
    title: value["title"],
    content: value["content"],
    pages: BranchContentPagesToJSON(value["pages"]),
    brand: value["brand"],
    timezone: value["timezone"],
    countryCode: JucyCountryCodeToJSON(value["countryCode"])
  };
}

// src/rentals-api-v3/models/BusinessUnit.ts
function instanceOfBusinessUnit(value) {
  if (!("name" in value) || value["name"] === void 0) return false;
  if (!("guid" in value) || value["guid"] === void 0) return false;
  if (!("code" in value) || value["code"] === void 0) return false;
  if (!("countryCode" in value) || value["countryCode"] === void 0) return false;
  if (!("salesTaxPercentage" in value) || value["salesTaxPercentage"] === void 0) return false;
  if (!("brand" in value) || value["brand"] === void 0) return false;
  return true;
}
function BusinessUnitFromJSON(json) {
  return BusinessUnitFromJSONTyped(json, false);
}
function BusinessUnitFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
    guid: json["guid"],
    code: json["code"],
    countryCode: json["countryCode"],
    salesTaxPercentage: json["salesTaxPercentage"],
    brand: json["brand"]
  };
}
function BusinessUnitToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    name: value["name"],
    guid: value["guid"],
    code: value["code"],
    countryCode: value["countryCode"],
    salesTaxPercentage: value["salesTaxPercentage"],
    brand: value["brand"]
  };
}

// src/rentals-api-v3/models/CatalogFloorPlan.ts
function instanceOfCatalogFloorPlan(value) {
  if (!("name" in value) || value["name"] === void 0) return false;
  if (!("url" in value) || value["url"] === void 0) return false;
  return true;
}
function CatalogFloorPlanFromJSON(json) {
  return CatalogFloorPlanFromJSONTyped(json, false);
}
function CatalogFloorPlanFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    ...json,
    name: json["name"],
    url: json["url"]
  };
}
function CatalogFloorPlanToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    ...value,
    name: value["name"],
    url: value["url"]
  };
}

// src/rentals-api-v3/models/CatalogItemPage.ts
function instanceOfCatalogItemPage(value) {
  if (!("locale" in value) || value["locale"] === void 0) return false;
  if (!("url" in value) || value["url"] === void 0) return false;
  return true;
}
function CatalogItemPageFromJSON(json) {
  return CatalogItemPageFromJSONTyped(json, false);
}
function CatalogItemPageFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    ...json,
    locale: json["locale"],
    title: json["title"] == null ? void 0 : json["title"],
    url: json["url"]
  };
}
function CatalogItemPageToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    ...value,
    locale: value["locale"],
    title: value["title"],
    url: value["url"]
  };
}

// src/rentals-api-v3/models/ExcessReductionFeatureSchemaBasic.ts
function instanceOfExcessReductionFeatureSchemaBasic(value) {
  return true;
}
function ExcessReductionFeatureSchemaBasicFromJSON(json) {
  return ExcessReductionFeatureSchemaBasicFromJSONTyped(json, false);
}
function ExcessReductionFeatureSchemaBasicFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function ExcessReductionFeatureSchemaBasicToJSON(value) {
  return value;
}

// src/rentals-api-v3/models/ExcessReductionFeatureType.ts
var ExcessReductionFeatureType = {
  Boolean: "boolean",
  Text: "text"
};
function instanceOfExcessReductionFeatureType(value) {
  for (const key in ExcessReductionFeatureType) {
    if (Object.prototype.hasOwnProperty.call(ExcessReductionFeatureType, key)) {
      if (ExcessReductionFeatureType[key] === value) {
        return true;
      }
    }
  }
  return false;
}
function ExcessReductionFeatureTypeFromJSON(json) {
  return ExcessReductionFeatureTypeFromJSONTyped(json, false);
}
function ExcessReductionFeatureTypeFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function ExcessReductionFeatureTypeToJSON(value) {
  return value;
}

// src/rentals-api-v3/models/ExcessReductionFeatureSchema.ts
function instanceOfExcessReductionFeatureSchema(value) {
  if (!("name" in value) || value["name"] === void 0) return false;
  if (!("type" in value) || value["type"] === void 0) return false;
  if (!("basic" in value) || value["basic"] === void 0) return false;
  if (!("standard" in value) || value["standard"] === void 0) return false;
  if (!("full" in value) || value["full"] === void 0) return false;
  return true;
}
function ExcessReductionFeatureSchemaFromJSON(json) {
  return ExcessReductionFeatureSchemaFromJSONTyped(json, false);
}
function ExcessReductionFeatureSchemaFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    ...json,
    name: json["name"],
    type: ExcessReductionFeatureTypeFromJSON(json["type"]),
    basic: ExcessReductionFeatureSchemaBasicFromJSON(json["basic"]),
    standard: ExcessReductionFeatureSchemaBasicFromJSON(json["standard"]),
    full: ExcessReductionFeatureSchemaBasicFromJSON(json["full"])
  };
}
function ExcessReductionFeatureSchemaToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    ...value,
    name: value["name"],
    type: ExcessReductionFeatureTypeToJSON(value["type"]),
    basic: ExcessReductionFeatureSchemaBasicToJSON(value["basic"]),
    standard: ExcessReductionFeatureSchemaBasicToJSON(value["standard"]),
    full: ExcessReductionFeatureSchemaBasicToJSON(value["full"])
  };
}

// src/rentals-api-v3/models/FeatureItem.ts
function instanceOfFeatureItem(value) {
  if (!("title" in value) || value["title"] === void 0) return false;
  if (!("type" in value) || value["type"] === void 0) return false;
  return true;
}
function FeatureItemFromJSON(json) {
  return FeatureItemFromJSONTyped(json, false);
}
function FeatureItemFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    ...json,
    title: json["title"],
    type: json["type"],
    icon: json["icon"] == null ? void 0 : json["icon"],
    iconClass: json["iconClass"] == null ? void 0 : json["iconClass"]
  };
}
function FeatureItemToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    ...value,
    title: value["title"],
    type: value["type"],
    icon: value["icon"],
    iconClass: value["iconClass"]
  };
}

// src/rentals-api-v3/models/FeatureList.ts
function instanceOfFeatureList(value) {
  if (!("title" in value) || value["title"] === void 0) return false;
  if (!("items" in value) || value["items"] === void 0) return false;
  return true;
}
function FeatureListFromJSON(json) {
  return FeatureListFromJSONTyped(json, false);
}
function FeatureListFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    ...json,
    title: json["title"],
    content: json["content"] == null ? void 0 : json["content"],
    items: json["items"]
  };
}
function FeatureListToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    ...value,
    title: value["title"],
    content: value["content"],
    items: value["items"]
  };
}

// src/rentals-api-v3/models/GalleryItemType.ts
var GalleryItemType = {
  Image: "Image",
  Image360: "Image 360"
};
function instanceOfGalleryItemType(value) {
  for (const key in GalleryItemType) {
    if (Object.prototype.hasOwnProperty.call(GalleryItemType, key)) {
      if (GalleryItemType[key] === value) {
        return true;
      }
    }
  }
  return false;
}
function GalleryItemTypeFromJSON(json) {
  return GalleryItemTypeFromJSONTyped(json, false);
}
function GalleryItemTypeFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function GalleryItemTypeToJSON(value) {
  return value;
}

// src/rentals-api-v3/models/GalleryItem.ts
function instanceOfGalleryItem(value) {
  if (!("original" in value) || value["original"] === void 0) return false;
  if (!("thumbnail" in value) || value["thumbnail"] === void 0) return false;
  if (!("type" in value) || value["type"] === void 0) return false;
  if (!("carousel" in value) || value["carousel"] === void 0) return false;
  return true;
}
function GalleryItemFromJSON(json) {
  return GalleryItemFromJSONTyped(json, false);
}
function GalleryItemFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    ...json,
    originalAlt: json["originalAlt"] == null ? void 0 : json["originalAlt"],
    original: json["original"],
    thumbnail: json["thumbnail"],
    type: GalleryItemTypeFromJSON(json["type"]),
    carousel: json["carousel"]
  };
}
function GalleryItemToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    ...value,
    originalAlt: value["originalAlt"],
    original: value["original"],
    thumbnail: value["thumbnail"],
    type: GalleryItemTypeToJSON(value["type"]),
    carousel: value["carousel"]
  };
}

// src/rentals-api-v3/models/CatalogItem.ts
function instanceOfCatalogItem(value) {
  if (!("id" in value) || value["id"] === void 0) return false;
  if (!("code" in value) || value["code"] === void 0) return false;
  if (!("name" in value) || value["name"] === void 0) return false;
  if (!("region" in value) || value["region"] === void 0) return false;
  if (!("fleetType" in value) || value["fleetType"] === void 0) return false;
  if (!("fleetTypeId" in value) || value["fleetTypeId"] === void 0) return false;
  if (!("fleetTypeSlug" in value) || value["fleetTypeSlug"] === void 0) return false;
  if (!("description" in value) || value["description"] === void 0) return false;
  if (!("shortDescription" in value) || value["shortDescription"] === void 0) return false;
  if (!("featuresDescription" in value) || value["featuresDescription"] === void 0) return false;
  if (!("excessReductionFeatures" in value) || value["excessReductionFeatures"] === void 0) return false;
  if (!("excessReductionDescription" in value) || value["excessReductionDescription"] === void 0) return false;
  if (!("specificationsDescription" in value) || value["specificationsDescription"] === void 0) return false;
  if (!("specifications" in value) || value["specifications"] === void 0) return false;
  if (!("gallery" in value) || value["gallery"] === void 0) return false;
  if (!("keyFeatures" in value) || value["keyFeatures"] === void 0) return false;
  if (!("includedWith" in value) || value["includedWith"] === void 0) return false;
  if (!("features" in value) || value["features"] === void 0) return false;
  if (!("pages" in value) || value["pages"] === void 0) return false;
  return true;
}
function CatalogItemFromJSON(json) {
  return CatalogItemFromJSONTyped(json, false);
}
function CatalogItemFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    ...json,
    id: json["id"],
    code: json["code"],
    name: json["name"],
    region: json["region"],
    fleetType: json["fleetType"],
    fleetTypeId: json["fleetTypeId"],
    fleetTypeSlug: json["fleetTypeSlug"],
    description: json["description"],
    shortDescription: json["shortDescription"],
    featuresDescription: json["featuresDescription"],
    highlightedFeatures: json["highlightedFeatures"] == null ? void 0 : json["highlightedFeatures"],
    vehicleDescription: json["vehicleDescription"] == null ? void 0 : json["vehicleDescription"],
    seatCount: json["seatCount"] == null ? void 0 : json["seatCount"],
    sleepCount: json["sleepCount"] == null ? void 0 : json["sleepCount"],
    sleepDescription: json["sleepDescription"] == null ? void 0 : json["sleepDescription"],
    transmission: json["transmission"] == null ? void 0 : json["transmission"],
    engineSize: json["engineSize"] == null ? void 0 : json["engineSize"],
    bodyStyle: json["bodyStyle"] == null ? void 0 : json["bodyStyle"],
    weight: json["weight"] == null ? void 0 : json["weight"],
    length: json["length"] == null ? void 0 : json["length"],
    width: json["width"] == null ? void 0 : json["width"],
    luggageSmall: json["luggageSmall"] == null ? void 0 : json["luggageSmall"],
    luggageLarge: json["luggageLarge"] == null ? void 0 : json["luggageLarge"],
    excessReductionFeatures: json["excessReductionFeatures"].map(ExcessReductionFeatureSchemaFromJSON),
    excessReductionDescription: json["excessReductionDescription"],
    specificationsDescription: json["specificationsDescription"],
    specifications: json["specifications"],
    scenicImage: json["scenicImage"] == null ? void 0 : json["scenicImage"],
    studioImage: json["studioImage"] == null ? void 0 : json["studioImage"],
    emailImage: json["emailImage"] == null ? void 0 : json["emailImage"],
    floorPlans: json["floorPlans"] == null ? void 0 : json["floorPlans"].map(CatalogFloorPlanFromJSON),
    gallery: json["gallery"].map(GalleryItemFromJSON),
    keyFeatures: json["keyFeatures"].map(FeatureItemFromJSON),
    includedWith: json["includedWith"].map(FeatureItemFromJSON),
    features: json["features"].map(FeatureListFromJSON),
    pages: json["pages"].map(CatalogItemPageFromJSON)
  };
}
function CatalogItemToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    ...value,
    id: value["id"],
    code: value["code"],
    name: value["name"],
    region: value["region"],
    fleetType: value["fleetType"],
    fleetTypeId: value["fleetTypeId"],
    fleetTypeSlug: value["fleetTypeSlug"],
    description: value["description"],
    shortDescription: value["shortDescription"],
    featuresDescription: value["featuresDescription"],
    highlightedFeatures: value["highlightedFeatures"],
    vehicleDescription: value["vehicleDescription"],
    seatCount: value["seatCount"],
    sleepCount: value["sleepCount"],
    sleepDescription: value["sleepDescription"],
    transmission: value["transmission"],
    engineSize: value["engineSize"],
    bodyStyle: value["bodyStyle"],
    weight: value["weight"],
    length: value["length"],
    width: value["width"],
    luggageSmall: value["luggageSmall"],
    luggageLarge: value["luggageLarge"],
    excessReductionFeatures: value["excessReductionFeatures"].map(ExcessReductionFeatureSchemaToJSON),
    excessReductionDescription: value["excessReductionDescription"],
    specificationsDescription: value["specificationsDescription"],
    specifications: value["specifications"],
    scenicImage: value["scenicImage"],
    studioImage: value["studioImage"],
    emailImage: value["emailImage"],
    floorPlans: value["floorPlans"] == null ? void 0 : value["floorPlans"].map(CatalogFloorPlanToJSON),
    gallery: value["gallery"].map(GalleryItemToJSON),
    keyFeatures: value["keyFeatures"].map(FeatureItemToJSON),
    includedWith: value["includedWith"].map(FeatureItemToJSON),
    features: value["features"].map(FeatureListToJSON),
    pages: value["pages"].map(CatalogItemPageToJSON)
  };
}

// src/rentals-api-v3/models/CommissionStatus.ts
var CommissionStatus = {
  Pending: "pending",
  Confirmed: "confirmed",
  Cancelled: "cancelled"
};
function instanceOfCommissionStatus(value) {
  for (const key in CommissionStatus) {
    if (Object.prototype.hasOwnProperty.call(CommissionStatus, key)) {
      if (CommissionStatus[key] === value) {
        return true;
      }
    }
  }
  return false;
}
function CommissionStatusFromJSON(json) {
  return CommissionStatusFromJSONTyped(json, false);
}
function CommissionStatusFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function CommissionStatusToJSON(value) {
  return value;
}

// src/rentals-api-v3/models/Commission.ts
function instanceOfCommission(value) {
  if (!("quoteId" in value) || value["quoteId"] === void 0) return false;
  if (!("reservationId" in value) || value["reservationId"] === void 0) return false;
  if (!("reservationReference" in value) || value["reservationReference"] === void 0) return false;
  if (!("bookingNo" in value) || value["bookingNo"] === void 0) return false;
  if (!("region" in value) || value["region"] === void 0) return false;
  if (!("dateCreated" in value) || value["dateCreated"] === void 0) return false;
  if (!("pickUpDate" in value) || value["pickUpDate"] === void 0) return false;
  if (!("commission" in value) || value["commission"] === void 0) return false;
  if (!("status" in value) || value["status"] === void 0) return false;
  return true;
}
function CommissionFromJSON(json) {
  return CommissionFromJSONTyped(json, false);
}
function CommissionFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    quoteId: json["quoteId"],
    reservationId: json["reservationId"],
    reservationReference: json["reservationReference"],
    bookingNo: json["bookingNo"],
    region: JucyCountryCodeFromJSON(json["region"]),
    dateCreated: stringToDate(json["dateCreated"]),
    pickUpDate: stringToDate(json["pickUpDate"]),
    commission: CurrencyValueFromJSON(json["commission"]),
    campaignCode: json["campaignCode"] == null ? void 0 : json["campaignCode"],
    referrerCode: json["referrerCode"] == null ? void 0 : json["referrerCode"],
    status: CommissionStatusFromJSON(json["status"])
  };
}
function CommissionToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    quoteId: value["quoteId"],
    reservationId: value["reservationId"],
    reservationReference: value["reservationReference"],
    bookingNo: value["bookingNo"],
    region: JucyCountryCodeToJSON(value["region"]),
    dateCreated: dateToString(value["dateCreated"]),
    pickUpDate: dateToString(value["pickUpDate"]),
    commission: CurrencyValueToJSON(value["commission"]),
    campaignCode: value["campaignCode"],
    referrerCode: value["referrerCode"],
    status: CommissionStatusToJSON(value["status"])
  };
}

// src/rentals-api-v3/models/ConvertQuotePaymentType.ts
var ConvertQuotePaymentType = {
  Full: "full",
  Deposit: "deposit"
};
function instanceOfConvertQuotePaymentType(value) {
  for (const key in ConvertQuotePaymentType) {
    if (Object.prototype.hasOwnProperty.call(ConvertQuotePaymentType, key)) {
      if (ConvertQuotePaymentType[key] === value) {
        return true;
      }
    }
  }
  return false;
}
function ConvertQuotePaymentTypeFromJSON(json) {
  return ConvertQuotePaymentTypeFromJSONTyped(json, false);
}
function ConvertQuotePaymentTypeFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function ConvertQuotePaymentTypeToJSON(value) {
  return value;
}

// src/rentals-api-v3/models/CreateBookingResponseStatus.ts
var CreateBookingResponseStatus = {
  Quote: "quote",
  PaymentRequired: "payment-required",
  ReservationConfirmed: "reservation-confirmed",
  ReservationRequest: "reservation-request"
};
function instanceOfCreateBookingResponseStatus(value) {
  for (const key in CreateBookingResponseStatus) {
    if (Object.prototype.hasOwnProperty.call(CreateBookingResponseStatus, key)) {
      if (CreateBookingResponseStatus[key] === value) {
        return true;
      }
    }
  }
  return false;
}
function CreateBookingResponseStatusFromJSON(json) {
  return CreateBookingResponseStatusFromJSONTyped(json, false);
}
function CreateBookingResponseStatusFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function CreateBookingResponseStatusToJSON(value) {
  return value;
}

// src/rentals-api-v3/models/ConvertQuoteResponse.ts
function instanceOfConvertQuoteResponse(value) {
  if (!("status" in value) || value["status"] === void 0) return false;
  if (!("reference" in value) || value["reference"] === void 0) return false;
  if (!("bookingNo" in value) || value["bookingNo"] === void 0) return false;
  return true;
}
function ConvertQuoteResponseFromJSON(json) {
  return ConvertQuoteResponseFromJSONTyped(json, false);
}
function ConvertQuoteResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    paymentUrl: json["paymentUrl"] == null ? void 0 : json["paymentUrl"],
    status: CreateBookingResponseStatusFromJSON(json["status"]),
    reference: json["reference"],
    bookingNo: json["bookingNo"]
  };
}
function ConvertQuoteResponseToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    paymentUrl: value["paymentUrl"],
    status: CreateBookingResponseStatusToJSON(value["status"]),
    reference: value["reference"],
    bookingNo: value["bookingNo"]
  };
}

// src/rentals-api-v3/models/CountryData.ts
function instanceOfCountryData(value) {
  if (!("code" in value) || value["code"] === void 0) return false;
  if (!("name" in value) || value["name"] === void 0) return false;
  if (!("phonePrefix" in value) || value["phonePrefix"] === void 0) return false;
  return true;
}
function CountryDataFromJSON(json) {
  return CountryDataFromJSONTyped(json, false);
}
function CountryDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    ...json,
    code: json["code"],
    name: json["name"],
    phonePrefix: json["phonePrefix"],
    suggested: json["suggested"] == null ? void 0 : json["suggested"],
    licensePermitExempt: json["licensePermitExempt"] == null ? void 0 : json["licensePermitExempt"]
  };
}
function CountryDataToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    ...value,
    code: value["code"],
    name: value["name"],
    phonePrefix: value["phonePrefix"],
    suggested: value["suggested"],
    licensePermitExempt: value["licensePermitExempt"]
  };
}

// src/rentals-api-v3/models/HirerDetailsSummary.ts
function instanceOfHirerDetailsSummary(value) {
  return true;
}
function HirerDetailsSummaryFromJSON(json) {
  return HirerDetailsSummaryFromJSONTyped(json, false);
}
function HirerDetailsSummaryFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    firstName: json["firstName"] == null ? void 0 : json["firstName"],
    lastName: json["lastName"] == null ? void 0 : json["lastName"],
    mobileNumber: json["mobileNumber"] == null ? void 0 : json["mobileNumber"],
    email: json["email"] == null ? void 0 : json["email"],
    driversLicenceCountry: json["driversLicenceCountry"] == null ? void 0 : json["driversLicenceCountry"],
    acceptedTerms: json["acceptedTerms"] == null ? void 0 : json["acceptedTerms"],
    mailingList: json["mailingList"] == null ? void 0 : json["mailingList"],
    loyalty: json["loyalty"] == null ? void 0 : json["loyalty"]
  };
}
function HirerDetailsSummaryToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    firstName: value["firstName"],
    lastName: value["lastName"],
    mobileNumber: value["mobileNumber"],
    email: value["email"],
    driversLicenceCountry: value["driversLicenceCountry"],
    acceptedTerms: value["acceptedTerms"],
    mailingList: value["mailingList"],
    loyalty: value["loyalty"]
  };
}

// src/rentals-api-v3/models/CreateBookingRequest.ts
function instanceOfCreateBookingRequest(value) {
  if (!("pickUpLocation" in value) || value["pickUpLocation"] === void 0) return false;
  if (!("dropOffLocation" in value) || value["dropOffLocation"] === void 0) return false;
  if (!("pickUpDate" in value) || value["pickUpDate"] === void 0) return false;
  if (!("dropOffDate" in value) || value["dropOffDate"] === void 0) return false;
  if (!("fleetCategory" in value) || value["fleetCategory"] === void 0) return false;
  if (!("insurance" in value) || value["insurance"] === void 0) return false;
  if (!("hirerDetails" in value) || value["hirerDetails"] === void 0) return false;
  return true;
}
function CreateBookingRequestFromJSON(json) {
  return CreateBookingRequestFromJSONTyped(json, false);
}
function CreateBookingRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    pickUpLocation: json["pickUpLocation"],
    dropOffLocation: json["dropOffLocation"],
    pickUpDate: json["pickUpDate"],
    dropOffDate: json["dropOffDate"],
    fleetCategory: json["fleetCategory"],
    driverAge: json["driverAge"] == null ? void 0 : json["driverAge"],
    numberOfPeople: json["numberOfPeople"] == null ? void 0 : json["numberOfPeople"],
    campaignCode: json["campaignCode"] == null ? void 0 : json["campaignCode"],
    pascal: json["pascal"] == null ? void 0 : json["pascal"],
    type: json["type"] == null ? void 0 : BookingTypeFromJSON(json["type"]),
    insurance: json["insurance"],
    secondaryProducts: json["secondaryProducts"] == null ? void 0 : json["secondaryProducts"],
    hirerDetails: HirerDetailsSummaryFromJSON(json["hirerDetails"]),
    voucherReference: json["voucherReference"] == null ? void 0 : json["voucherReference"],
    agentName: json["agentName"] == null ? void 0 : json["agentName"],
    gateway: json["gateway"] == null ? void 0 : json["gateway"],
    payment: json["payment"] == null ? void 0 : json["payment"]
  };
}
function CreateBookingRequestToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    pickUpLocation: value["pickUpLocation"],
    dropOffLocation: value["dropOffLocation"],
    pickUpDate: value["pickUpDate"],
    dropOffDate: value["dropOffDate"],
    fleetCategory: value["fleetCategory"],
    driverAge: value["driverAge"],
    numberOfPeople: value["numberOfPeople"],
    campaignCode: value["campaignCode"],
    pascal: value["pascal"],
    type: BookingTypeToJSON(value["type"]),
    insurance: value["insurance"],
    secondaryProducts: value["secondaryProducts"],
    hirerDetails: HirerDetailsSummaryToJSON(value["hirerDetails"]),
    voucherReference: value["voucherReference"],
    agentName: value["agentName"],
    gateway: value["gateway"],
    payment: value["payment"]
  };
}

// src/rentals-api-v3/models/CreateBookingResponse.ts
function instanceOfCreateBookingResponse(value) {
  if (!("booking" in value) || value["booking"] === void 0) return false;
  if (!("status" in value) || value["status"] === void 0) return false;
  if (!("reference" in value) || value["reference"] === void 0) return false;
  if (!("bookingNo" in value) || value["bookingNo"] === void 0) return false;
  return true;
}
function CreateBookingResponseFromJSON(json) {
  return CreateBookingResponseFromJSONTyped(json, false);
}
function CreateBookingResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    booking: BookingFromJSON(json["booking"]),
    status: CreateBookingResponseStatusFromJSON(json["status"]),
    convertUrl: json["convertUrl"] == null ? void 0 : json["convertUrl"],
    reference: json["reference"],
    bookingNo: json["bookingNo"],
    paymentToken: json["paymentToken"] == null ? void 0 : json["paymentToken"]
  };
}
function CreateBookingResponseToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    booking: BookingToJSON(value["booking"]),
    status: CreateBookingResponseStatusToJSON(value["status"]),
    convertUrl: value["convertUrl"],
    reference: value["reference"],
    bookingNo: value["bookingNo"],
    paymentToken: value["paymentToken"]
  };
}

// src/rentals-api-v3/models/ExchangeRates.ts
function instanceOfExchangeRates(value) {
  if (!("nZD" in value) || value["nZD"] === void 0) return false;
  if (!("aUD" in value) || value["aUD"] === void 0) return false;
  if (!("eUR" in value) || value["eUR"] === void 0) return false;
  if (!("cAD" in value) || value["cAD"] === void 0) return false;
  if (!("uSD" in value) || value["uSD"] === void 0) return false;
  if (!("gBP" in value) || value["gBP"] === void 0) return false;
  if (!("cHF" in value) || value["cHF"] === void 0) return false;
  if (!("jPY" in value) || value["jPY"] === void 0) return false;
  if (!("kRW" in value) || value["kRW"] === void 0) return false;
  if (!("sGD" in value) || value["sGD"] === void 0) return false;
  if (!("cNY" in value) || value["cNY"] === void 0) return false;
  if (!("aRS" in value) || value["aRS"] === void 0) return false;
  if (!("hKD" in value) || value["hKD"] === void 0) return false;
  if (!("mYR" in value) || value["mYR"] === void 0) return false;
  if (!("iNR" in value) || value["iNR"] === void 0) return false;
  return true;
}
function ExchangeRatesFromJSON(json) {
  return ExchangeRatesFromJSONTyped(json, false);
}
function ExchangeRatesFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    nZD: json["NZD"],
    aUD: json["AUD"],
    eUR: json["EUR"],
    cAD: json["CAD"],
    uSD: json["USD"],
    gBP: json["GBP"],
    cHF: json["CHF"],
    jPY: json["JPY"],
    kRW: json["KRW"],
    sGD: json["SGD"],
    cNY: json["CNY"],
    aRS: json["ARS"],
    hKD: json["HKD"],
    mYR: json["MYR"],
    iNR: json["INR"]
  };
}
function ExchangeRatesToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    NZD: value["nZD"],
    AUD: value["aUD"],
    EUR: value["eUR"],
    CAD: value["cAD"],
    USD: value["uSD"],
    GBP: value["gBP"],
    CHF: value["cHF"],
    JPY: value["jPY"],
    KRW: value["kRW"],
    SGD: value["sGD"],
    CNY: value["cNY"],
    ARS: value["aRS"],
    HKD: value["hKD"],
    MYR: value["mYR"],
    INR: value["iNR"]
  };
}

// src/rentals-api-v3/models/CurrencyRateResult.ts
function instanceOfCurrencyRateResult(value) {
  if (!("nZD" in value) || value["nZD"] === void 0) return false;
  if (!("aUD" in value) || value["aUD"] === void 0) return false;
  return true;
}
function CurrencyRateResultFromJSON(json) {
  return CurrencyRateResultFromJSONTyped(json, false);
}
function CurrencyRateResultFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    nZD: ExchangeRatesFromJSON(json["NZD"]),
    aUD: ExchangeRatesFromJSON(json["AUD"])
  };
}
function CurrencyRateResultToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    NZD: ExchangeRatesToJSON(value["nZD"]),
    AUD: ExchangeRatesToJSON(value["aUD"])
  };
}

// src/rentals-api-v3/models/EmailQuoteRequest.ts
function instanceOfEmailQuoteRequest(value) {
  if (!("pickUpLocation" in value) || value["pickUpLocation"] === void 0) return false;
  if (!("dropOffLocation" in value) || value["dropOffLocation"] === void 0) return false;
  if (!("pickUpDate" in value) || value["pickUpDate"] === void 0) return false;
  if (!("dropOffDate" in value) || value["dropOffDate"] === void 0) return false;
  if (!("fleetCategory" in value) || value["fleetCategory"] === void 0) return false;
  if (!("insurance" in value) || value["insurance"] === void 0) return false;
  if (!("hirerDetails" in value) || value["hirerDetails"] === void 0) return false;
  return true;
}
function EmailQuoteRequestFromJSON(json) {
  return EmailQuoteRequestFromJSONTyped(json, false);
}
function EmailQuoteRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    pickUpLocation: json["pickUpLocation"],
    dropOffLocation: json["dropOffLocation"],
    pickUpDate: json["pickUpDate"],
    dropOffDate: json["dropOffDate"],
    fleetCategory: json["fleetCategory"],
    driverAge: json["driverAge"] == null ? void 0 : json["driverAge"],
    numberOfPeople: json["numberOfPeople"] == null ? void 0 : json["numberOfPeople"],
    campaignCode: json["campaignCode"] == null ? void 0 : json["campaignCode"],
    pascal: json["pascal"] == null ? void 0 : json["pascal"],
    insurance: json["insurance"],
    secondaryProducts: json["secondaryProducts"] == null ? void 0 : json["secondaryProducts"],
    hirerDetails: HirerDetailsSummaryFromJSON(json["hirerDetails"]),
    voucherReference: json["voucherReference"] == null ? void 0 : json["voucherReference"],
    reservationReference: json["reservationReference"] == null ? void 0 : json["reservationReference"]
  };
}
function EmailQuoteRequestToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    pickUpLocation: value["pickUpLocation"],
    dropOffLocation: value["dropOffLocation"],
    pickUpDate: value["pickUpDate"],
    dropOffDate: value["dropOffDate"],
    fleetCategory: value["fleetCategory"],
    driverAge: value["driverAge"],
    numberOfPeople: value["numberOfPeople"],
    campaignCode: value["campaignCode"],
    pascal: value["pascal"],
    insurance: value["insurance"],
    secondaryProducts: value["secondaryProducts"],
    hirerDetails: HirerDetailsSummaryToJSON(value["hirerDetails"]),
    voucherReference: value["voucherReference"],
    reservationReference: value["reservationReference"]
  };
}

// src/rentals-api-v3/models/ErrorResponse.ts
function instanceOfErrorResponse(value) {
  return true;
}
function ErrorResponseFromJSON(json) {
  return ErrorResponseFromJSONTyped(json, false);
}
function ErrorResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    statusCode: json["statusCode"] == null ? void 0 : json["statusCode"],
    error: json["error"] == null ? void 0 : json["error"],
    message: json["message"] == null ? void 0 : json["message"]
  };
}
function ErrorResponseToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    statusCode: value["statusCode"],
    error: value["error"],
    message: value["message"]
  };
}

// src/rentals-api-v3/models/ExportBookingRequestQuery.ts
function instanceOfExportBookingRequestQuery(value) {
  if (!("fromDate" in value) || value["fromDate"] === void 0) return false;
  if (!("toDate" in value) || value["toDate"] === void 0) return false;
  return true;
}
function ExportBookingRequestQueryFromJSON(json) {
  return ExportBookingRequestQueryFromJSONTyped(json, false);
}
function ExportBookingRequestQueryFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    fromDate: json["fromDate"],
    toDate: json["toDate"]
  };
}
function ExportBookingRequestQueryToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    fromDate: value["fromDate"],
    toDate: value["toDate"]
  };
}

// src/rentals-api-v3/models/ExportMaintenanceBookingRequestQuery.ts
function instanceOfExportMaintenanceBookingRequestQuery(value) {
  if (!("fromDate" in value) || value["fromDate"] === void 0) return false;
  if (!("toDate" in value) || value["toDate"] === void 0) return false;
  return true;
}
function ExportMaintenanceBookingRequestQueryFromJSON(json) {
  return ExportMaintenanceBookingRequestQueryFromJSONTyped(json, false);
}
function ExportMaintenanceBookingRequestQueryFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    fromDate: json["fromDate"],
    toDate: json["toDate"]
  };
}
function ExportMaintenanceBookingRequestQueryToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    fromDate: value["fromDate"],
    toDate: value["toDate"]
  };
}

// src/rentals-api-v3/models/ExportMonthlySalesByCategoryRequestQuerySchema.ts
var ExportMonthlySalesByCategoryRequestQuerySchemaByEnum = {
  Category: "category",
  Source: "source"
};
function instanceOfExportMonthlySalesByCategoryRequestQuerySchema(value) {
  if (!("by" in value) || value["by"] === void 0) return false;
  return true;
}
function ExportMonthlySalesByCategoryRequestQuerySchemaFromJSON(json) {
  return ExportMonthlySalesByCategoryRequestQuerySchemaFromJSONTyped(json, false);
}
function ExportMonthlySalesByCategoryRequestQuerySchemaFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    fromDate: json["fromDate"] == null ? void 0 : json["fromDate"],
    toDate: json["toDate"] == null ? void 0 : json["toDate"],
    by: json["by"]
  };
}
function ExportMonthlySalesByCategoryRequestQuerySchemaToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    fromDate: value["fromDate"],
    toDate: value["toDate"],
    by: value["by"]
  };
}

// src/rentals-api-v3/models/ExportMonthlyUtilisationRequestQuerySchema.ts
function instanceOfExportMonthlyUtilisationRequestQuerySchema(value) {
  return true;
}
function ExportMonthlyUtilisationRequestQuerySchemaFromJSON(json) {
  return ExportMonthlyUtilisationRequestQuerySchemaFromJSONTyped(json, false);
}
function ExportMonthlyUtilisationRequestQuerySchemaFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    fromDate: json["fromDate"] == null ? void 0 : json["fromDate"],
    toDate: json["toDate"] == null ? void 0 : json["toDate"]
  };
}
function ExportMonthlyUtilisationRequestQuerySchemaToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    fromDate: value["fromDate"],
    toDate: value["toDate"]
  };
}

// src/rentals-api-v3/models/ExportVehicleRequestQuery.ts
function instanceOfExportVehicleRequestQuery(value) {
  if (!("fromDate" in value) || value["fromDate"] === void 0) return false;
  if (!("toDate" in value) || value["toDate"] === void 0) return false;
  return true;
}
function ExportVehicleRequestQueryFromJSON(json) {
  return ExportVehicleRequestQueryFromJSONTyped(json, false);
}
function ExportVehicleRequestQueryFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    fromDate: json["fromDate"],
    toDate: json["toDate"]
  };
}
function ExportVehicleRequestQueryToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    fromDate: value["fromDate"],
    toDate: value["toDate"]
  };
}

// src/rentals-api-v3/models/FerryAccommodationProduct.ts
var FerryAccommodationProductCategoryEnum = {
  FerryAccommodationProduct: "FerryAccommodationProduct"
};
function instanceOfFerryAccommodationProduct(value) {
  if (!("productId" in value) || value["productId"] === void 0) return false;
  if (!("sortOrder" in value) || value["sortOrder"] === void 0) return false;
  if (!("productCode" in value) || value["productCode"] === void 0) return false;
  if (!("name" in value) || value["name"] === void 0) return false;
  if (!("category" in value) || value["category"] === void 0) return false;
  if (!("isMandatory" in value) || value["isMandatory"] === void 0) return false;
  if (!("description" in value) || value["description"] === void 0) return false;
  if (!("price" in value) || value["price"] === void 0) return false;
  if (!("productType" in value) || value["productType"] === void 0) return false;
  if (!("isPercentageOnTotalCost" in value) || value["isPercentageOnTotalCost"] === void 0) return false;
  if (!("allowMultiple" in value) || value["allowMultiple"] === void 0) return false;
  if (!("commissionable" in value) || value["commissionable"] === void 0) return false;
  if (!("rentalDays" in value) || value["rentalDays"] === void 0) return false;
  if (!("numberOfDaysCalculated" in value) || value["numberOfDaysCalculated"] === void 0) return false;
  if (!("berths" in value) || value["berths"] === void 0) return false;
  if (!("maxAdults" in value) || value["maxAdults"] === void 0) return false;
  if (!("maxOccupancy" in value) || value["maxOccupancy"] === void 0) return false;
  if (!("minOccupancy" in value) || value["minOccupancy"] === void 0) return false;
  if (!("quantityAvailable" in value) || value["quantityAvailable"] === void 0) return false;
  return true;
}
function FerryAccommodationProductFromJSON(json) {
  return FerryAccommodationProductFromJSONTyped(json, false);
}
function FerryAccommodationProductFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    productId: json["productId"],
    sortOrder: json["sortOrder"],
    productCode: json["productCode"],
    name: json["name"],
    category: json["category"],
    isMandatory: json["isMandatory"],
    description: json["description"],
    price: CurrencyValueFromJSON(json["price"]),
    productType: json["productType"],
    isPercentageOnTotalCost: json["isPercentageOnTotalCost"],
    allowMultiple: json["allowMultiple"],
    commissionable: json["commissionable"],
    associatedProductCode: json["associatedProductCode"] == null ? void 0 : json["associatedProductCode"],
    rentalDays: json["rentalDays"],
    numberOfDaysCalculated: json["numberOfDaysCalculated"],
    maxPrice: json["maxPrice"] == null ? void 0 : CurrencyValueFromJSON(json["maxPrice"]),
    berths: json["berths"],
    maxAdults: json["maxAdults"],
    maxOccupancy: json["maxOccupancy"],
    minOccupancy: json["minOccupancy"],
    quantityAvailable: json["quantityAvailable"]
  };
}
function FerryAccommodationProductToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    productId: value["productId"],
    sortOrder: value["sortOrder"],
    productCode: value["productCode"],
    name: value["name"],
    category: value["category"],
    isMandatory: value["isMandatory"],
    description: value["description"],
    price: CurrencyValueToJSON(value["price"]),
    productType: value["productType"],
    isPercentageOnTotalCost: value["isPercentageOnTotalCost"],
    allowMultiple: value["allowMultiple"],
    commissionable: value["commissionable"],
    associatedProductCode: value["associatedProductCode"],
    rentalDays: value["rentalDays"],
    numberOfDaysCalculated: value["numberOfDaysCalculated"],
    maxPrice: CurrencyValueToJSON(value["maxPrice"]),
    berths: value["berths"],
    maxAdults: value["maxAdults"],
    maxOccupancy: value["maxOccupancy"],
    minOccupancy: value["minOccupancy"],
    quantityAvailable: value["quantityAvailable"]
  };
}

// src/rentals-api-v3/models/FerryPassenger.ts
var FerryPassengerTypeEnum = {
  Adult: "adult",
  Child: "child",
  Infant: "infant"
};
function instanceOfFerryPassenger(value) {
  if (!("firstName" in value) || value["firstName"] === void 0) return false;
  if (!("lastName" in value) || value["lastName"] === void 0) return false;
  if (!("type" in value) || value["type"] === void 0) return false;
  return true;
}
function FerryPassengerFromJSON(json) {
  return FerryPassengerFromJSONTyped(json, false);
}
function FerryPassengerFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    firstName: json["firstName"],
    lastName: json["lastName"],
    phoneNumber: json["phoneNumber"] == null ? void 0 : json["phoneNumber"],
    age: json["age"] == null ? void 0 : json["age"],
    type: json["type"]
  };
}
function FerryPassengerToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    firstName: value["firstName"],
    lastName: value["lastName"],
    phoneNumber: value["phoneNumber"],
    age: value["age"],
    type: value["type"]
  };
}

// src/rentals-api-v3/models/FerryPort.ts
function instanceOfFerryPort(value) {
  if (!("code" in value) || value["code"] === void 0) return false;
  if (!("name" in value) || value["name"] === void 0) return false;
  return true;
}
function FerryPortFromJSON(json) {
  return FerryPortFromJSONTyped(json, false);
}
function FerryPortFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    code: json["code"],
    name: json["name"],
    country: json["country"] == null ? void 0 : json["country"],
    lat: json["lat"] == null ? void 0 : json["lat"],
    lng: json["lng"] == null ? void 0 : json["lng"]
  };
}
function FerryPortToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    code: value["code"],
    name: value["name"],
    country: value["country"],
    lat: value["lat"],
    lng: value["lng"]
  };
}

// src/rentals-api-v3/models/FerryProductLine.ts
function instanceOfFerryProductLine(value) {
  if (!("productId" in value) || value["productId"] === void 0) return false;
  if (!("sortOrder" in value) || value["sortOrder"] === void 0) return false;
  if (!("productCode" in value) || value["productCode"] === void 0) return false;
  if (!("name" in value) || value["name"] === void 0) return false;
  if (!("category" in value) || value["category"] === void 0) return false;
  if (!("isMandatory" in value) || value["isMandatory"] === void 0) return false;
  if (!("description" in value) || value["description"] === void 0) return false;
  if (!("price" in value) || value["price"] === void 0) return false;
  if (!("productType" in value) || value["productType"] === void 0) return false;
  if (!("isPercentageOnTotalCost" in value) || value["isPercentageOnTotalCost"] === void 0) return false;
  if (!("allowMultiple" in value) || value["allowMultiple"] === void 0) return false;
  if (!("commissionable" in value) || value["commissionable"] === void 0) return false;
  if (!("rentalDays" in value) || value["rentalDays"] === void 0) return false;
  if (!("numberOfDaysCalculated" in value) || value["numberOfDaysCalculated"] === void 0) return false;
  if (!("qty" in value) || value["qty"] === void 0) return false;
  if (!("total" in value) || value["total"] === void 0) return false;
  return true;
}
function FerryProductLineFromJSON(json) {
  return FerryProductLineFromJSONTyped(json, false);
}
function FerryProductLineFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    ...json,
    productId: json["productId"],
    sortOrder: json["sortOrder"],
    productCode: json["productCode"],
    name: json["name"],
    category: json["category"],
    isMandatory: json["isMandatory"],
    description: json["description"],
    price: CurrencyValueFromJSON(json["price"]),
    productType: json["productType"],
    isPercentageOnTotalCost: json["isPercentageOnTotalCost"],
    allowMultiple: json["allowMultiple"],
    commissionable: json["commissionable"],
    associatedProductCode: json["associatedProductCode"] == null ? void 0 : json["associatedProductCode"],
    rentalDays: json["rentalDays"],
    numberOfDaysCalculated: json["numberOfDaysCalculated"],
    maxPrice: json["maxPrice"] == null ? void 0 : CurrencyValueFromJSON(json["maxPrice"]),
    qty: json["qty"],
    total: CurrencyValueFromJSON(json["total"])
  };
}
function FerryProductLineToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    ...value,
    productId: value["productId"],
    sortOrder: value["sortOrder"],
    productCode: value["productCode"],
    name: value["name"],
    category: value["category"],
    isMandatory: value["isMandatory"],
    description: value["description"],
    price: CurrencyValueToJSON(value["price"]),
    productType: value["productType"],
    isPercentageOnTotalCost: value["isPercentageOnTotalCost"],
    allowMultiple: value["allowMultiple"],
    commissionable: value["commissionable"],
    associatedProductCode: value["associatedProductCode"],
    rentalDays: value["rentalDays"],
    numberOfDaysCalculated: value["numberOfDaysCalculated"],
    maxPrice: CurrencyValueToJSON(value["maxPrice"]),
    qty: value["qty"],
    total: CurrencyValueToJSON(value["total"])
  };
}

// src/rentals-api-v3/models/FerrySailingTripAllOfId.ts
function instanceOfFerrySailingTripAllOfId(value) {
  return true;
}
function FerrySailingTripAllOfIdFromJSON(json) {
  return FerrySailingTripAllOfIdFromJSONTyped(json, false);
}
function FerrySailingTripAllOfIdFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function FerrySailingTripAllOfIdToJSON(value) {
  return value;
}

// src/rentals-api-v3/models/FerryShip.ts
function instanceOfFerryShip(value) {
  if (!("name" in value) || value["name"] === void 0) return false;
  return true;
}
function FerryShipFromJSON(json) {
  return FerryShipFromJSONTyped(json, false);
}
function FerryShipFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"]
  };
}
function FerryShipToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    name: value["name"]
  };
}

// src/rentals-api-v3/models/FerrySailingBooking.ts
function instanceOfFerrySailingBooking(value) {
  if (!("id" in value) || value["id"] === void 0) return false;
  if (!("isAvailable" in value) || value["isAvailable"] === void 0) return false;
  if (!("code" in value) || value["code"] === void 0) return false;
  if (!("departPort" in value) || value["departPort"] === void 0) return false;
  if (!("departDateTime" in value) || value["departDateTime"] === void 0) return false;
  if (!("destinationPort" in value) || value["destinationPort"] === void 0) return false;
  if (!("arriveDateTime" in value) || value["arriveDateTime"] === void 0) return false;
  if (!("ship" in value) || value["ship"] === void 0) return false;
  if (!("lines" in value) || value["lines"] === void 0) return false;
  return true;
}
function FerrySailingBookingFromJSON(json) {
  return FerrySailingBookingFromJSONTyped(json, false);
}
function FerrySailingBookingFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    id: FerrySailingTripAllOfIdFromJSON(json["id"]),
    isAvailable: json["isAvailable"],
    code: json["code"],
    departPort: FerryPortFromJSON(json["departPort"]),
    departDateTime: stringToDate(json["departDateTime"]),
    destinationPort: FerryPortFromJSON(json["destinationPort"]),
    arriveDateTime: stringToDate(json["arriveDateTime"]),
    ship: FerryShipFromJSON(json["ship"]),
    lines: json["lines"].map(FerryProductLineFromJSON)
  };
}
function FerrySailingBookingToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    id: FerrySailingTripAllOfIdToJSON(value["id"]),
    isAvailable: value["isAvailable"],
    code: value["code"],
    departPort: FerryPortToJSON(value["departPort"]),
    departDateTime: dateToString(value["departDateTime"]),
    destinationPort: FerryPortToJSON(value["destinationPort"]),
    arriveDateTime: dateToString(value["arriveDateTime"]),
    ship: FerryShipToJSON(value["ship"]),
    lines: value["lines"].map(FerryProductLineToJSON)
  };
}

// src/rentals-api-v3/models/FerryBooking.ts
function instanceOfFerryBooking(value) {
  if (!("reference" in value) || value["reference"] === void 0) return false;
  if (!("rentalReservationReference" in value) || value["rentalReservationReference"] === void 0) return false;
  if (!("status" in value) || value["status"] === void 0) return false;
  if (!("passengers" in value) || value["passengers"] === void 0) return false;
  if (!("outboundTrip" in value) || value["outboundTrip"] === void 0) return false;
  if (!("subTotal" in value) || value["subTotal"] === void 0) return false;
  if (!("total" in value) || value["total"] === void 0) return false;
  return true;
}
function FerryBookingFromJSON(json) {
  return FerryBookingFromJSONTyped(json, false);
}
function FerryBookingFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    reference: json["reference"],
    rentalReservationReference: json["rentalReservationReference"],
    bookingNo: json["bookingNo"] == null ? void 0 : json["bookingNo"],
    status: CreateBookingResponseStatusFromJSON(json["status"]),
    passengers: json["passengers"].map(FerryPassengerFromJSON),
    outboundTrip: FerrySailingBookingFromJSON(json["outboundTrip"]),
    returnTrip: json["returnTrip"] == null ? void 0 : FerrySailingBookingFromJSON(json["returnTrip"]),
    contactDetails: json["contactDetails"] == null ? void 0 : HirerDetailsFromJSON(json["contactDetails"]),
    subTotal: CurrencyValueFromJSON(json["subTotal"]),
    merchantFee: json["merchantFee"] == null ? void 0 : CurrencyValueFromJSON(json["merchantFee"]),
    total: CurrencyValueFromJSON(json["total"]),
    lastUpdated: json["lastUpdated"] == null ? void 0 : stringToDate(json["lastUpdated"])
  };
}
function FerryBookingToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    reference: value["reference"],
    rentalReservationReference: value["rentalReservationReference"],
    bookingNo: value["bookingNo"],
    status: CreateBookingResponseStatusToJSON(value["status"]),
    passengers: value["passengers"].map(FerryPassengerToJSON),
    outboundTrip: FerrySailingBookingToJSON(value["outboundTrip"]),
    returnTrip: FerrySailingBookingToJSON(value["returnTrip"]),
    contactDetails: HirerDetailsToJSON(value["contactDetails"]),
    subTotal: CurrencyValueToJSON(value["subTotal"]),
    merchantFee: CurrencyValueToJSON(value["merchantFee"]),
    total: CurrencyValueToJSON(value["total"]),
    lastUpdated: value["lastUpdated"] == null ? void 0 : dateToString(value["lastUpdated"])
  };
}

// src/rentals-api-v3/models/FerryTripDetailsRequestOutboundTrip.ts
function instanceOfFerryTripDetailsRequestOutboundTrip(value) {
  if (!("departPort" in value) || value["departPort"] === void 0) return false;
  if (!("destinationPort" in value) || value["destinationPort"] === void 0) return false;
  if (!("fromSailingDate" in value) || value["fromSailingDate"] === void 0) return false;
  return true;
}
function FerryTripDetailsRequestOutboundTripFromJSON(json) {
  return FerryTripDetailsRequestOutboundTripFromJSONTyped(json, false);
}
function FerryTripDetailsRequestOutboundTripFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    departPort: json["departPort"],
    destinationPort: json["destinationPort"],
    fromSailingDate: json["fromSailingDate"],
    fareType: json["fareType"] == null ? void 0 : json["fareType"],
    options: json["options"] == null ? void 0 : json["options"]
  };
}
function FerryTripDetailsRequestOutboundTripToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    departPort: value["departPort"],
    destinationPort: value["destinationPort"],
    fromSailingDate: value["fromSailingDate"],
    fareType: value["fareType"],
    options: value["options"]
  };
}

// src/rentals-api-v3/models/FerryTripDetailsRequestReturnTrip.ts
function instanceOfFerryTripDetailsRequestReturnTrip(value) {
  if (!("departPort" in value) || value["departPort"] === void 0) return false;
  if (!("destinationPort" in value) || value["destinationPort"] === void 0) return false;
  if (!("fromSailingDate" in value) || value["fromSailingDate"] === void 0) return false;
  return true;
}
function FerryTripDetailsRequestReturnTripFromJSON(json) {
  return FerryTripDetailsRequestReturnTripFromJSONTyped(json, false);
}
function FerryTripDetailsRequestReturnTripFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    departPort: json["departPort"],
    destinationPort: json["destinationPort"],
    fromSailingDate: json["fromSailingDate"],
    fareType: json["fareType"] == null ? void 0 : json["fareType"],
    options: json["options"] == null ? void 0 : json["options"]
  };
}
function FerryTripDetailsRequestReturnTripToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    departPort: value["departPort"],
    destinationPort: value["destinationPort"],
    fromSailingDate: value["fromSailingDate"],
    fareType: value["fareType"],
    options: value["options"]
  };
}

// src/rentals-api-v3/models/FerryCreateBookingRequest.ts
function instanceOfFerryCreateBookingRequest(value) {
  if (!("outboundTrip" in value) || value["outboundTrip"] === void 0) return false;
  if (!("passengers" in value) || value["passengers"] === void 0) return false;
  return true;
}
function FerryCreateBookingRequestFromJSON(json) {
  return FerryCreateBookingRequestFromJSONTyped(json, false);
}
function FerryCreateBookingRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    outboundTrip: FerryTripDetailsRequestOutboundTripFromJSON(json["outboundTrip"]),
    returnTrip: json["returnTrip"] == null ? void 0 : FerryTripDetailsRequestReturnTripFromJSON(json["returnTrip"]),
    passengers: json["passengers"].map(FerryPassengerFromJSON)
  };
}
function FerryCreateBookingRequestToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    outboundTrip: FerryTripDetailsRequestOutboundTripToJSON(value["outboundTrip"]),
    returnTrip: FerryTripDetailsRequestReturnTripToJSON(value["returnTrip"]),
    passengers: value["passengers"].map(FerryPassengerToJSON)
  };
}

// src/rentals-api-v3/models/FerryCreateQuoteRequest.ts
function instanceOfFerryCreateQuoteRequest(value) {
  if (!("outboundTrip" in value) || value["outboundTrip"] === void 0) return false;
  if (!("passengers" in value) || value["passengers"] === void 0) return false;
  if (!("gateway" in value) || value["gateway"] === void 0) return false;
  if (!("returnUrl" in value) || value["returnUrl"] === void 0) return false;
  if (!("failedUrl" in value) || value["failedUrl"] === void 0) return false;
  return true;
}
function FerryCreateQuoteRequestFromJSON(json) {
  return FerryCreateQuoteRequestFromJSONTyped(json, false);
}
function FerryCreateQuoteRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    outboundTrip: json["outboundTrip"],
    returnTrip: json["returnTrip"] == null ? void 0 : json["returnTrip"],
    passengers: json["passengers"].map(FerryPassengerFromJSON),
    gateway: json["gateway"],
    returnUrl: json["returnUrl"],
    failedUrl: json["failedUrl"]
  };
}
function FerryCreateQuoteRequestToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    outboundTrip: value["outboundTrip"],
    returnTrip: value["returnTrip"],
    passengers: value["passengers"].map(FerryPassengerToJSON),
    gateway: value["gateway"],
    returnUrl: value["returnUrl"],
    failedUrl: value["failedUrl"]
  };
}

// src/rentals-api-v3/models/FerryMessage.ts
function instanceOfFerryMessage(value) {
  if (!("description" in value) || value["description"] === void 0) return false;
  return true;
}
function FerryMessageFromJSON(json) {
  return FerryMessageFromJSONTyped(json, false);
}
function FerryMessageFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    code: json["code"] == null ? void 0 : json["code"],
    description: json["description"],
    severity: json["severity"] == null ? void 0 : json["severity"]
  };
}
function FerryMessageToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    code: value["code"],
    description: value["description"],
    severity: value["severity"]
  };
}

// src/rentals-api-v3/models/FerryGetBookingResponse.ts
function instanceOfFerryGetBookingResponse(value) {
  if (!("ferryBooking" in value) || value["ferryBooking"] === void 0) return false;
  if (!("status" in value) || value["status"] === void 0) return false;
  if (!("reference" in value) || value["reference"] === void 0) return false;
  return true;
}
function FerryGetBookingResponseFromJSON(json) {
  return FerryGetBookingResponseFromJSONTyped(json, false);
}
function FerryGetBookingResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    messages: json["messages"] == null ? void 0 : json["messages"].map(FerryMessageFromJSON),
    ferryBooking: FerryBookingFromJSON(json["ferryBooking"]),
    status: CreateBookingResponseStatusFromJSON(json["status"]),
    convertUrl: json["convertUrl"] == null ? void 0 : json["convertUrl"],
    reference: json["reference"],
    bookingNo: json["bookingNo"] == null ? void 0 : json["bookingNo"],
    paymentToken: json["paymentToken"] == null ? void 0 : json["paymentToken"]
  };
}
function FerryGetBookingResponseToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    messages: value["messages"] == null ? void 0 : value["messages"].map(FerryMessageToJSON),
    ferryBooking: FerryBookingToJSON(value["ferryBooking"]),
    status: CreateBookingResponseStatusToJSON(value["status"]),
    convertUrl: value["convertUrl"],
    reference: value["reference"],
    bookingNo: value["bookingNo"],
    paymentToken: value["paymentToken"]
  };
}

// src/rentals-api-v3/models/FerryGetOptionsQueryString.ts
function instanceOfFerryGetOptionsQueryString(value) {
  if (!("reservationRef" in value) || value["reservationRef"] === void 0) return false;
  return true;
}
function FerryGetOptionsQueryStringFromJSON(json) {
  return FerryGetOptionsQueryStringFromJSONTyped(json, false);
}
function FerryGetOptionsQueryStringFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    reservationRef: json["reservationRef"]
  };
}
function FerryGetOptionsQueryStringToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    reservationRef: value["reservationRef"]
  };
}

// src/rentals-api-v3/models/FerryGetQuoteResponse.ts
function instanceOfFerryGetQuoteResponse(value) {
  if (!("ferryBooking" in value) || value["ferryBooking"] === void 0) return false;
  if (!("status" in value) || value["status"] === void 0) return false;
  if (!("reference" in value) || value["reference"] === void 0) return false;
  return true;
}
function FerryGetQuoteResponseFromJSON(json) {
  return FerryGetQuoteResponseFromJSONTyped(json, false);
}
function FerryGetQuoteResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    messages: json["messages"] == null ? void 0 : json["messages"].map(FerryMessageFromJSON),
    ferryBooking: FerryBookingFromJSON(json["ferryBooking"]),
    status: CreateBookingResponseStatusFromJSON(json["status"]),
    reference: json["reference"],
    bookingNo: json["bookingNo"] == null ? void 0 : json["bookingNo"]
  };
}
function FerryGetQuoteResponseToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    messages: value["messages"] == null ? void 0 : value["messages"].map(FerryMessageToJSON),
    ferryBooking: FerryBookingToJSON(value["ferryBooking"]),
    status: CreateBookingResponseStatusToJSON(value["status"]),
    reference: value["reference"],
    bookingNo: value["bookingNo"]
  };
}

// src/rentals-api-v3/models/FerryGetRouteRequest.ts
function instanceOfFerryGetRouteRequest(value) {
  if (!("reservationRef" in value) || value["reservationRef"] === void 0) return false;
  return true;
}
function FerryGetRouteRequestFromJSON(json) {
  return FerryGetRouteRequestFromJSONTyped(json, false);
}
function FerryGetRouteRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    reservationRef: json["reservationRef"]
  };
}
function FerryGetRouteRequestToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    reservationRef: value["reservationRef"]
  };
}

// src/rentals-api-v3/models/FerryGetSailingsRequestAllOfOutboundTrip.ts
function instanceOfFerryGetSailingsRequestAllOfOutboundTrip(value) {
  if (!("departPort" in value) || value["departPort"] === void 0) return false;
  if (!("destinationPort" in value) || value["destinationPort"] === void 0) return false;
  if (!("sailingDate" in value) || value["sailingDate"] === void 0) return false;
  return true;
}
function FerryGetSailingsRequestAllOfOutboundTripFromJSON(json) {
  return FerryGetSailingsRequestAllOfOutboundTripFromJSONTyped(json, false);
}
function FerryGetSailingsRequestAllOfOutboundTripFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    departPort: json["departPort"],
    destinationPort: json["destinationPort"],
    sailingDate: json["sailingDate"],
    fareType: json["fareType"] == null ? void 0 : json["fareType"]
  };
}
function FerryGetSailingsRequestAllOfOutboundTripToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    departPort: value["departPort"],
    destinationPort: value["destinationPort"],
    sailingDate: value["sailingDate"],
    fareType: value["fareType"]
  };
}

// src/rentals-api-v3/models/FerryGetSailingsRequestAllOfPassengers.ts
function instanceOfFerryGetSailingsRequestAllOfPassengers(value) {
  if (!("adults" in value) || value["adults"] === void 0) return false;
  return true;
}
function FerryGetSailingsRequestAllOfPassengersFromJSON(json) {
  return FerryGetSailingsRequestAllOfPassengersFromJSONTyped(json, false);
}
function FerryGetSailingsRequestAllOfPassengersFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    adults: json["adults"],
    children: json["children"] == null ? void 0 : json["children"],
    infants: json["infants"] == null ? void 0 : json["infants"]
  };
}
function FerryGetSailingsRequestAllOfPassengersToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    adults: value["adults"],
    children: value["children"],
    infants: value["infants"]
  };
}

// src/rentals-api-v3/models/FerryGetSailingsRequestAllOfReturnTrip.ts
function instanceOfFerryGetSailingsRequestAllOfReturnTrip(value) {
  if (!("departPort" in value) || value["departPort"] === void 0) return false;
  if (!("destinationPort" in value) || value["destinationPort"] === void 0) return false;
  if (!("sailingDate" in value) || value["sailingDate"] === void 0) return false;
  return true;
}
function FerryGetSailingsRequestAllOfReturnTripFromJSON(json) {
  return FerryGetSailingsRequestAllOfReturnTripFromJSONTyped(json, false);
}
function FerryGetSailingsRequestAllOfReturnTripFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    departPort: json["departPort"],
    destinationPort: json["destinationPort"],
    sailingDate: json["sailingDate"],
    fareType: json["fareType"] == null ? void 0 : json["fareType"]
  };
}
function FerryGetSailingsRequestAllOfReturnTripToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    departPort: value["departPort"],
    destinationPort: value["destinationPort"],
    sailingDate: value["sailingDate"],
    fareType: value["fareType"]
  };
}

// src/rentals-api-v3/models/FerryGetSailingsRequest.ts
function instanceOfFerryGetSailingsRequest(value) {
  if (!("outboundTrip" in value) || value["outboundTrip"] === void 0) return false;
  if (!("passengers" in value) || value["passengers"] === void 0) return false;
  return true;
}
function FerryGetSailingsRequestFromJSON(json) {
  return FerryGetSailingsRequestFromJSONTyped(json, false);
}
function FerryGetSailingsRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    outboundTrip: FerryGetSailingsRequestAllOfOutboundTripFromJSON(json["outboundTrip"]),
    returnTrip: json["returnTrip"] == null ? void 0 : FerryGetSailingsRequestAllOfReturnTripFromJSON(json["returnTrip"]),
    passengers: FerryGetSailingsRequestAllOfPassengersFromJSON(json["passengers"])
  };
}
function FerryGetSailingsRequestToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    outboundTrip: FerryGetSailingsRequestAllOfOutboundTripToJSON(value["outboundTrip"]),
    returnTrip: FerryGetSailingsRequestAllOfReturnTripToJSON(value["returnTrip"]),
    passengers: FerryGetSailingsRequestAllOfPassengersToJSON(value["passengers"])
  };
}

// src/rentals-api-v3/models/FerrySailingOrder.ts
function instanceOfFerrySailingOrder(value) {
  if (!("id" in value) || value["id"] === void 0) return false;
  if (!("isAvailable" in value) || value["isAvailable"] === void 0) return false;
  if (!("code" in value) || value["code"] === void 0) return false;
  if (!("departPort" in value) || value["departPort"] === void 0) return false;
  if (!("departDateTime" in value) || value["departDateTime"] === void 0) return false;
  if (!("destinationPort" in value) || value["destinationPort"] === void 0) return false;
  if (!("arriveDateTime" in value) || value["arriveDateTime"] === void 0) return false;
  if (!("ship" in value) || value["ship"] === void 0) return false;
  if (!("lines" in value) || value["lines"] === void 0) return false;
  if (!("options" in value) || value["options"] === void 0) return false;
  if (!("accommodationOptions" in value) || value["accommodationOptions"] === void 0) return false;
  if (!("total" in value) || value["total"] === void 0) return false;
  return true;
}
function FerrySailingOrderFromJSON(json) {
  return FerrySailingOrderFromJSONTyped(json, false);
}
function FerrySailingOrderFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    id: FerrySailingTripAllOfIdFromJSON(json["id"]),
    isAvailable: json["isAvailable"],
    code: json["code"],
    departPort: FerryPortFromJSON(json["departPort"]),
    departDateTime: stringToDate(json["departDateTime"]),
    destinationPort: FerryPortFromJSON(json["destinationPort"]),
    arriveDateTime: stringToDate(json["arriveDateTime"]),
    ship: FerryShipFromJSON(json["ship"]),
    lines: json["lines"].map(FerryProductLineFromJSON),
    options: json["options"].map(SecondaryProductFromJSON),
    accommodationOptions: json["accommodationOptions"].map(FerryAccommodationProductFromJSON),
    total: CurrencyValueFromJSON(json["total"])
  };
}
function FerrySailingOrderToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    id: FerrySailingTripAllOfIdToJSON(value["id"]),
    isAvailable: value["isAvailable"],
    code: value["code"],
    departPort: FerryPortToJSON(value["departPort"]),
    departDateTime: dateToString(value["departDateTime"]),
    destinationPort: FerryPortToJSON(value["destinationPort"]),
    arriveDateTime: dateToString(value["arriveDateTime"]),
    ship: FerryShipToJSON(value["ship"]),
    lines: value["lines"].map(FerryProductLineToJSON),
    options: value["options"].map(SecondaryProductToJSON),
    accommodationOptions: value["accommodationOptions"].map(FerryAccommodationProductToJSON),
    total: CurrencyValueToJSON(value["total"])
  };
}

// src/rentals-api-v3/models/FerryGetSailingsResponse.ts
function instanceOfFerryGetSailingsResponse(value) {
  if (!("total" in value) || value["total"] === void 0) return false;
  if (!("outboundTrip" in value) || value["outboundTrip"] === void 0) return false;
  return true;
}
function FerryGetSailingsResponseFromJSON(json) {
  return FerryGetSailingsResponseFromJSONTyped(json, false);
}
function FerryGetSailingsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    total: CurrencyValueFromJSON(json["total"]),
    outboundTrip: FerrySailingOrderFromJSON(json["outboundTrip"]),
    returnTrip: json["returnTrip"] == null ? void 0 : FerrySailingOrderFromJSON(json["returnTrip"])
  };
}
function FerryGetSailingsResponseToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    total: CurrencyValueToJSON(value["total"]),
    outboundTrip: FerrySailingOrderToJSON(value["outboundTrip"]),
    returnTrip: FerrySailingOrderToJSON(value["returnTrip"])
  };
}

// src/rentals-api-v3/models/FerryGetStatusRequestQuery.ts
function instanceOfFerryGetStatusRequestQuery(value) {
  if (!("reservationRef" in value) || value["reservationRef"] === void 0) return false;
  return true;
}
function FerryGetStatusRequestQueryFromJSON(json) {
  return FerryGetStatusRequestQueryFromJSONTyped(json, false);
}
function FerryGetStatusRequestQueryFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    reservationRef: json["reservationRef"]
  };
}
function FerryGetStatusRequestQueryToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    reservationRef: value["reservationRef"]
  };
}

// src/rentals-api-v3/models/FerryGetStatusResponse.ts
function instanceOfFerryGetStatusResponse(value) {
  if (!("available" in value) || value["available"] === void 0) return false;
  if (!("reservationRef" in value) || value["reservationRef"] === void 0) return false;
  if (!("region" in value) || value["region"] === void 0) return false;
  if (!("status" in value) || value["status"] === void 0) return false;
  return true;
}
function FerryGetStatusResponseFromJSON(json) {
  return FerryGetStatusResponseFromJSONTyped(json, false);
}
function FerryGetStatusResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    available: json["available"],
    reservationRef: json["reservationRef"],
    region: json["region"],
    status: json["status"]
  };
}
function FerryGetStatusResponseToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    available: value["available"],
    reservationRef: value["reservationRef"],
    region: value["region"],
    status: value["status"]
  };
}

// src/rentals-api-v3/models/FerryGetTimetableRequest.ts
function instanceOfFerryGetTimetableRequest(value) {
  if (!("departPort" in value) || value["departPort"] === void 0) return false;
  if (!("destinationPort" in value) || value["destinationPort"] === void 0) return false;
  if (!("fromSailingDate" in value) || value["fromSailingDate"] === void 0) return false;
  if (!("toSailingDate" in value) || value["toSailingDate"] === void 0) return false;
  return true;
}
function FerryGetTimetableRequestFromJSON(json) {
  return FerryGetTimetableRequestFromJSONTyped(json, false);
}
function FerryGetTimetableRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    departPort: json["departPort"],
    destinationPort: json["destinationPort"],
    fromSailingDate: json["fromSailingDate"],
    toSailingDate: json["toSailingDate"]
  };
}
function FerryGetTimetableRequestToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    departPort: value["departPort"],
    destinationPort: value["destinationPort"],
    fromSailingDate: value["fromSailingDate"],
    toSailingDate: value["toSailingDate"]
  };
}

// src/rentals-api-v3/models/FerryOptions.ts
function instanceOfFerryOptions(value) {
  if (!("vehicleProducts" in value) || value["vehicleProducts"] === void 0) return false;
  if (!("passengerProducts" in value) || value["passengerProducts"] === void 0) return false;
  if (!("accommodationProducts" in value) || value["accommodationProducts"] === void 0) return false;
  return true;
}
function FerryOptionsFromJSON(json) {
  return FerryOptionsFromJSONTyped(json, false);
}
function FerryOptionsFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    vehicleProducts: json["vehicleProducts"].map(SecondaryProductFromJSON),
    passengerProducts: json["passengerProducts"].map(SecondaryProductFromJSON),
    accommodationProducts: json["accommodationProducts"].map(SecondaryProductFromJSON)
  };
}
function FerryOptionsToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    vehicleProducts: value["vehicleProducts"].map(SecondaryProductToJSON),
    passengerProducts: value["passengerProducts"].map(SecondaryProductToJSON),
    accommodationProducts: value["accommodationProducts"].map(SecondaryProductToJSON)
  };
}

// src/rentals-api-v3/models/FerryPassengerCountRequest.ts
function instanceOfFerryPassengerCountRequest(value) {
  if (!("passengers" in value) || value["passengers"] === void 0) return false;
  return true;
}
function FerryPassengerCountRequestFromJSON(json) {
  return FerryPassengerCountRequestFromJSONTyped(json, false);
}
function FerryPassengerCountRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    passengers: FerryGetSailingsRequestAllOfPassengersFromJSON(json["passengers"])
  };
}
function FerryPassengerCountRequestToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    passengers: FerryGetSailingsRequestAllOfPassengersToJSON(value["passengers"])
  };
}

// src/rentals-api-v3/models/FerryPassengerType.ts
var FerryPassengerType = {
  Adult: "adult",
  Child: "child",
  Infant: "infant"
};
function instanceOfFerryPassengerType(value) {
  for (const key in FerryPassengerType) {
    if (Object.prototype.hasOwnProperty.call(FerryPassengerType, key)) {
      if (FerryPassengerType[key] === value) {
        return true;
      }
    }
  }
  return false;
}
function FerryPassengerTypeFromJSON(json) {
  return FerryPassengerTypeFromJSONTyped(json, false);
}
function FerryPassengerTypeFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function FerryPassengerTypeToJSON(value) {
  return value;
}

// src/rentals-api-v3/models/FerryRoute.ts
function instanceOfFerryRoute(value) {
  if (!("code" in value) || value["code"] === void 0) return false;
  if (!("departPort" in value) || value["departPort"] === void 0) return false;
  if (!("destinationPort" in value) || value["destinationPort"] === void 0) return false;
  return true;
}
function FerryRouteFromJSON(json) {
  return FerryRouteFromJSONTyped(json, false);
}
function FerryRouteFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    code: json["code"],
    departPort: FerryPortFromJSON(json["departPort"]),
    destinationPort: FerryPortFromJSON(json["destinationPort"])
  };
}
function FerryRouteToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    code: value["code"],
    departPort: FerryPortToJSON(value["departPort"]),
    destinationPort: FerryPortToJSON(value["destinationPort"])
  };
}

// src/rentals-api-v3/models/FerrySailing.ts
function instanceOfFerrySailing(value) {
  if (!("code" in value) || value["code"] === void 0) return false;
  if (!("departPort" in value) || value["departPort"] === void 0) return false;
  if (!("departDateTime" in value) || value["departDateTime"] === void 0) return false;
  if (!("destinationPort" in value) || value["destinationPort"] === void 0) return false;
  if (!("arriveDateTime" in value) || value["arriveDateTime"] === void 0) return false;
  if (!("ship" in value) || value["ship"] === void 0) return false;
  return true;
}
function FerrySailingFromJSON(json) {
  return FerrySailingFromJSONTyped(json, false);
}
function FerrySailingFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    code: json["code"],
    departPort: FerryPortFromJSON(json["departPort"]),
    departDateTime: stringToDate(json["departDateTime"]),
    destinationPort: FerryPortFromJSON(json["destinationPort"]),
    arriveDateTime: stringToDate(json["arriveDateTime"]),
    ship: FerryShipFromJSON(json["ship"])
  };
}
function FerrySailingToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    code: value["code"],
    departPort: FerryPortToJSON(value["departPort"]),
    departDateTime: dateToString(value["departDateTime"]),
    destinationPort: FerryPortToJSON(value["destinationPort"]),
    arriveDateTime: dateToString(value["arriveDateTime"]),
    ship: FerryShipToJSON(value["ship"])
  };
}

// src/rentals-api-v3/models/FerrySailingQuoteRequest.ts
function instanceOfFerrySailingQuoteRequest(value) {
  if (!("outboundTrip" in value) || value["outboundTrip"] === void 0) return false;
  if (!("passengers" in value) || value["passengers"] === void 0) return false;
  return true;
}
function FerrySailingQuoteRequestFromJSON(json) {
  return FerrySailingQuoteRequestFromJSONTyped(json, false);
}
function FerrySailingQuoteRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    outboundTrip: FerryTripDetailsRequestOutboundTripFromJSON(json["outboundTrip"]),
    returnTrip: json["returnTrip"] == null ? void 0 : FerryTripDetailsRequestReturnTripFromJSON(json["returnTrip"]),
    passengers: FerryGetSailingsRequestAllOfPassengersFromJSON(json["passengers"])
  };
}
function FerrySailingQuoteRequestToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    outboundTrip: FerryTripDetailsRequestOutboundTripToJSON(value["outboundTrip"]),
    returnTrip: FerryTripDetailsRequestReturnTripToJSON(value["returnTrip"]),
    passengers: FerryGetSailingsRequestAllOfPassengersToJSON(value["passengers"])
  };
}

// src/rentals-api-v3/models/FerrySailingTrip.ts
function instanceOfFerrySailingTrip(value) {
  if (!("code" in value) || value["code"] === void 0) return false;
  if (!("departPort" in value) || value["departPort"] === void 0) return false;
  if (!("departDateTime" in value) || value["departDateTime"] === void 0) return false;
  if (!("destinationPort" in value) || value["destinationPort"] === void 0) return false;
  if (!("arriveDateTime" in value) || value["arriveDateTime"] === void 0) return false;
  if (!("ship" in value) || value["ship"] === void 0) return false;
  if (!("id" in value) || value["id"] === void 0) return false;
  if (!("isAvailable" in value) || value["isAvailable"] === void 0) return false;
  return true;
}
function FerrySailingTripFromJSON(json) {
  return FerrySailingTripFromJSONTyped(json, false);
}
function FerrySailingTripFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    code: json["code"],
    departPort: FerryPortFromJSON(json["departPort"]),
    departDateTime: stringToDate(json["departDateTime"]),
    destinationPort: FerryPortFromJSON(json["destinationPort"]),
    arriveDateTime: stringToDate(json["arriveDateTime"]),
    ship: FerryShipFromJSON(json["ship"]),
    id: FerrySailingTripAllOfIdFromJSON(json["id"]),
    isAvailable: json["isAvailable"]
  };
}
function FerrySailingTripToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    code: value["code"],
    departPort: FerryPortToJSON(value["departPort"]),
    departDateTime: dateToString(value["departDateTime"]),
    destinationPort: FerryPortToJSON(value["destinationPort"]),
    arriveDateTime: dateToString(value["arriveDateTime"]),
    ship: FerryShipToJSON(value["ship"]),
    id: FerrySailingTripAllOfIdToJSON(value["id"]),
    isAvailable: value["isAvailable"]
  };
}

// src/rentals-api-v3/models/FerryTripDetailsRequest.ts
function instanceOfFerryTripDetailsRequest(value) {
  if (!("outboundTrip" in value) || value["outboundTrip"] === void 0) return false;
  return true;
}
function FerryTripDetailsRequestFromJSON(json) {
  return FerryTripDetailsRequestFromJSONTyped(json, false);
}
function FerryTripDetailsRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    outboundTrip: FerryTripDetailsRequestOutboundTripFromJSON(json["outboundTrip"]),
    returnTrip: json["returnTrip"] == null ? void 0 : FerryTripDetailsRequestReturnTripFromJSON(json["returnTrip"])
  };
}
function FerryTripDetailsRequestToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    outboundTrip: FerryTripDetailsRequestOutboundTripToJSON(value["outboundTrip"]),
    returnTrip: FerryTripDetailsRequestReturnTripToJSON(value["returnTrip"])
  };
}

// src/rentals-api-v3/models/FerryUpdateQuoteRequest.ts
function instanceOfFerryUpdateQuoteRequest(value) {
  if (!("outboundTrip" in value) || value["outboundTrip"] === void 0) return false;
  if (!("passengers" in value) || value["passengers"] === void 0) return false;
  if (!("gateway" in value) || value["gateway"] === void 0) return false;
  if (!("returnUrl" in value) || value["returnUrl"] === void 0) return false;
  if (!("failedUrl" in value) || value["failedUrl"] === void 0) return false;
  return true;
}
function FerryUpdateQuoteRequestFromJSON(json) {
  return FerryUpdateQuoteRequestFromJSONTyped(json, false);
}
function FerryUpdateQuoteRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    outboundTrip: json["outboundTrip"],
    returnTrip: json["returnTrip"] == null ? void 0 : json["returnTrip"],
    passengers: json["passengers"].map(FerryPassengerFromJSON),
    gateway: json["gateway"],
    returnUrl: json["returnUrl"],
    failedUrl: json["failedUrl"]
  };
}
function FerryUpdateQuoteRequestToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    outboundTrip: value["outboundTrip"],
    returnTrip: value["returnTrip"],
    passengers: value["passengers"].map(FerryPassengerToJSON),
    gateway: value["gateway"],
    returnUrl: value["returnUrl"],
    failedUrl: value["failedUrl"]
  };
}

// src/rentals-api-v3/models/FerryUpdateQuoteRequestParams.ts
function instanceOfFerryUpdateQuoteRequestParams(value) {
  if (!("reservationRef" in value) || value["reservationRef"] === void 0) return false;
  if (!("bookingRef" in value) || value["bookingRef"] === void 0) return false;
  return true;
}
function FerryUpdateQuoteRequestParamsFromJSON(json) {
  return FerryUpdateQuoteRequestParamsFromJSONTyped(json, false);
}
function FerryUpdateQuoteRequestParamsFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    reservationRef: json["reservationRef"],
    bookingRef: json["bookingRef"]
  };
}
function FerryUpdateQuoteRequestParamsToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    reservationRef: value["reservationRef"],
    bookingRef: value["bookingRef"]
  };
}

// src/rentals-api-v3/models/FindReservationRequest.ts
function instanceOfFindReservationRequest(value) {
  if (!("lastName" in value) || value["lastName"] === void 0) return false;
  if (!("bookingNumber" in value) || value["bookingNumber"] === void 0) return false;
  if (!("pickUpBranchCode" in value) || value["pickUpBranchCode"] === void 0) return false;
  return true;
}
function FindReservationRequestFromJSON(json) {
  return FindReservationRequestFromJSONTyped(json, false);
}
function FindReservationRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    lastName: json["lastName"],
    bookingNumber: json["bookingNumber"],
    pickUpBranchCode: json["pickUpBranchCode"]
  };
}
function FindReservationRequestToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    lastName: value["lastName"],
    bookingNumber: value["bookingNumber"],
    pickUpBranchCode: value["pickUpBranchCode"]
  };
}

// src/rentals-api-v3/models/FindReservationResultHirer.ts
function instanceOfFindReservationResultHirer(value) {
  if (!("firstName" in value) || value["firstName"] === void 0) return false;
  if (!("lastName" in value) || value["lastName"] === void 0) return false;
  if (!("email" in value) || value["email"] === void 0) return false;
  return true;
}
function FindReservationResultHirerFromJSON(json) {
  return FindReservationResultHirerFromJSONTyped(json, false);
}
function FindReservationResultHirerFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    firstName: json["firstName"],
    lastName: json["lastName"],
    email: json["email"],
    checkedIn: json["checkedIn"] == null ? void 0 : json["checkedIn"]
  };
}
function FindReservationResultHirerToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    firstName: value["firstName"],
    lastName: value["lastName"],
    email: value["email"],
    checkedIn: value["checkedIn"]
  };
}

// src/rentals-api-v3/models/FindReservationResult.ts
function instanceOfFindReservationResult(value) {
  if (!("id" in value) || value["id"] === void 0) return false;
  if (!("ref" in value) || value["ref"] === void 0) return false;
  if (!("status" in value) || value["status"] === void 0) return false;
  if (!("availability" in value) || value["availability"] === void 0) return false;
  if (!("created" in value) || value["created"] === void 0) return false;
  if (!("updated" in value) || value["updated"] === void 0) return false;
  if (!("fleetTypeCode" in value) || value["fleetTypeCode"] === void 0) return false;
  if (!("pickUpSiteCode" in value) || value["pickUpSiteCode"] === void 0) return false;
  if (!("dropOffSiteCode" in value) || value["dropOffSiteCode"] === void 0) return false;
  if (!("fleetCategoryCode" in value) || value["fleetCategoryCode"] === void 0) return false;
  if (!("rentalDays" in value) || value["rentalDays"] === void 0) return false;
  if (!("pickUpDate" in value) || value["pickUpDate"] === void 0) return false;
  if (!("dropOffDate" in value) || value["dropOffDate"] === void 0) return false;
  return true;
}
function FindReservationResultFromJSON(json) {
  return FindReservationResultFromJSONTyped(json, false);
}
function FindReservationResultFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    reservationId: json["reservationId"] == null ? void 0 : json["reservationId"],
    allocatedReservationId: json["allocatedReservationId"] == null ? void 0 : json["allocatedReservationId"],
    accountId: json["accountId"] == null ? void 0 : json["accountId"],
    ref: json["ref"],
    status: BookingSummaryStatusFromJSON(json["status"]),
    voucherRef: json["voucherRef"] == null ? void 0 : json["voucherRef"],
    allocated: json["allocated"] == null ? void 0 : json["allocated"],
    rego: json["rego"] == null ? void 0 : json["rego"],
    availability: AvailabilityTypeFromJSON(json["availability"]),
    created: stringToDate(json["created"]),
    updated: stringToDate(json["updated"]),
    hirer: json["hirer"] == null ? void 0 : FindReservationResultHirerFromJSON(json["hirer"]),
    fleetTypeCode: FleetTypeCodeFromJSON(json["fleetTypeCode"]),
    pickUpSiteCode: json["pickUpSiteCode"],
    dropOffSiteCode: json["dropOffSiteCode"],
    fleetCategoryCode: json["fleetCategoryCode"],
    rentalDays: json["rentalDays"],
    pickUpDate: stringToDate(json["pickUpDate"]),
    dropOffDate: stringToDate(json["dropOffDate"])
  };
}
function FindReservationResultToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    id: value["id"],
    reservationId: value["reservationId"],
    allocatedReservationId: value["allocatedReservationId"],
    accountId: value["accountId"],
    ref: value["ref"],
    status: BookingSummaryStatusToJSON(value["status"]),
    voucherRef: value["voucherRef"],
    allocated: value["allocated"],
    rego: value["rego"],
    availability: AvailabilityTypeToJSON(value["availability"]),
    created: dateToString(value["created"]),
    updated: dateToString(value["updated"]),
    hirer: FindReservationResultHirerToJSON(value["hirer"]),
    fleetTypeCode: FleetTypeCodeToJSON(value["fleetTypeCode"]),
    pickUpSiteCode: value["pickUpSiteCode"],
    dropOffSiteCode: value["dropOffSiteCode"],
    fleetCategoryCode: value["fleetCategoryCode"],
    rentalDays: value["rentalDays"],
    pickUpDate: dateToString(value["pickUpDate"]),
    dropOffDate: dateToString(value["dropOffDate"])
  };
}

// src/rentals-api-v3/models/VideoChapter.ts
function instanceOfVideoChapter(value) {
  if (!("name" in value) || value["name"] === void 0) return false;
  if (!("startTime" in value) || value["startTime"] === void 0) return false;
  if (!("endTime" in value) || value["endTime"] === void 0) return false;
  return true;
}
function VideoChapterFromJSON(json) {
  return VideoChapterFromJSONTyped(json, false);
}
function VideoChapterFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
    startTime: json["startTime"],
    endTime: json["endTime"]
  };
}
function VideoChapterToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    name: value["name"],
    startTime: value["startTime"],
    endTime: value["endTime"]
  };
}

// src/rentals-api-v3/models/VideoContent.ts
function instanceOfVideoContent(value) {
  if (!("name" in value) || value["name"] === void 0) return false;
  if (!("intro" in value) || value["intro"] === void 0) return false;
  if (!("youtubeId" in value) || value["youtubeId"] === void 0) return false;
  if (!("chapters" in value) || value["chapters"] === void 0) return false;
  return true;
}
function VideoContentFromJSON(json) {
  return VideoContentFromJSONTyped(json, false);
}
function VideoContentFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
    intro: json["intro"],
    youtubeId: json["youtubeId"],
    chapters: json["chapters"].map(VideoChapterFromJSON)
  };
}
function VideoContentToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    name: value["name"],
    intro: value["intro"],
    youtubeId: value["youtubeId"],
    chapters: value["chapters"].map(VideoChapterToJSON)
  };
}

// src/rentals-api-v3/models/FleetCategoryContent.ts
function instanceOfFleetCategoryContent(value) {
  if (!("title" in value) || value["title"] === void 0) return false;
  if (!("subTitle" in value) || value["subTitle"] === void 0) return false;
  if (!("content" in value) || value["content"] === void 0) return false;
  if (!("name" in value) || value["name"] === void 0) return false;
  if (!("code" in value) || value["code"] === void 0) return false;
  if (!("countryCode" in value) || value["countryCode"] === void 0) return false;
  return true;
}
function FleetCategoryContentFromJSON(json) {
  return FleetCategoryContentFromJSONTyped(json, false);
}
function FleetCategoryContentFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    title: json["title"],
    subTitle: json["subTitle"],
    content: json["content"],
    name: json["name"],
    code: json["code"],
    countryCode: json["countryCode"],
    manualLink: json["manualLink"] == null ? void 0 : json["manualLink"],
    showThroughVideo: json["showThroughVideo"] == null ? void 0 : VideoContentFromJSON(json["showThroughVideo"])
  };
}
function FleetCategoryContentToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    title: value["title"],
    subTitle: value["subTitle"],
    content: value["content"],
    name: value["name"],
    code: value["code"],
    countryCode: value["countryCode"],
    manualLink: value["manualLink"],
    showThroughVideo: VideoContentToJSON(value["showThroughVideo"])
  };
}

// src/rentals-api-v3/models/FleetTypeHireDaysType.ts
var FleetTypeHireDaysType = {
  Calendar: "calendar",
  Hourly: "hourly"
};
function instanceOfFleetTypeHireDaysType(value) {
  for (const key in FleetTypeHireDaysType) {
    if (Object.prototype.hasOwnProperty.call(FleetTypeHireDaysType, key)) {
      if (FleetTypeHireDaysType[key] === value) {
        return true;
      }
    }
  }
  return false;
}
function FleetTypeHireDaysTypeFromJSON(json) {
  return FleetTypeHireDaysTypeFromJSONTyped(json, false);
}
function FleetTypeHireDaysTypeFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function FleetTypeHireDaysTypeToJSON(value) {
  return value;
}

// src/rentals-api-v3/models/GetBranchContentQuery.ts
function instanceOfGetBranchContentQuery(value) {
  return true;
}
function GetBranchContentQueryFromJSON(json) {
  return GetBranchContentQueryFromJSONTyped(json, false);
}
function GetBranchContentQueryFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    brand: json["brand"] == null ? void 0 : json["brand"]
  };
}
function GetBranchContentQueryToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    brand: value["brand"]
  };
}

// src/rentals-api-v3/models/GetFerryBookingRequestParams.ts
function instanceOfGetFerryBookingRequestParams(value) {
  if (!("reservationRef" in value) || value["reservationRef"] === void 0) return false;
  if (!("bookingRef" in value) || value["bookingRef"] === void 0) return false;
  return true;
}
function GetFerryBookingRequestParamsFromJSON(json) {
  return GetFerryBookingRequestParamsFromJSONTyped(json, false);
}
function GetFerryBookingRequestParamsFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    reservationRef: json["reservationRef"],
    bookingRef: json["bookingRef"]
  };
}
function GetFerryBookingRequestParamsToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    reservationRef: value["reservationRef"],
    bookingRef: value["bookingRef"]
  };
}

// src/rentals-api-v3/models/GetFerryBookingsRequestParams.ts
function instanceOfGetFerryBookingsRequestParams(value) {
  if (!("reservationRef" in value) || value["reservationRef"] === void 0) return false;
  return true;
}
function GetFerryBookingsRequestParamsFromJSON(json) {
  return GetFerryBookingsRequestParamsFromJSONTyped(json, false);
}
function GetFerryBookingsRequestParamsFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    reservationRef: json["reservationRef"]
  };
}
function GetFerryBookingsRequestParamsToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    reservationRef: value["reservationRef"]
  };
}

// src/rentals-api-v3/models/GetFerryQuoteRequestParams.ts
function instanceOfGetFerryQuoteRequestParams(value) {
  if (!("reservationRef" in value) || value["reservationRef"] === void 0) return false;
  if (!("bookingRef" in value) || value["bookingRef"] === void 0) return false;
  return true;
}
function GetFerryQuoteRequestParamsFromJSON(json) {
  return GetFerryQuoteRequestParamsFromJSONTyped(json, false);
}
function GetFerryQuoteRequestParamsFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    reservationRef: json["reservationRef"],
    bookingRef: json["bookingRef"]
  };
}
function GetFerryQuoteRequestParamsToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    reservationRef: value["reservationRef"],
    bookingRef: value["bookingRef"]
  };
}

// src/rentals-api-v3/models/GetFleetCategoryContentParams.ts
function instanceOfGetFleetCategoryContentParams(value) {
  if (!("fleetCategoryCode" in value) || value["fleetCategoryCode"] === void 0) return false;
  return true;
}
function GetFleetCategoryContentParamsFromJSON(json) {
  return GetFleetCategoryContentParamsFromJSONTyped(json, false);
}
function GetFleetCategoryContentParamsFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    fleetCategoryCode: json["fleetCategoryCode"]
  };
}
function GetFleetCategoryContentParamsToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    fleetCategoryCode: value["fleetCategoryCode"]
  };
}

// src/rentals-api-v3/models/GetFleetTypeBlySlugParams.ts
function instanceOfGetFleetTypeBlySlugParams(value) {
  return true;
}
function GetFleetTypeBlySlugParamsFromJSON(json) {
  return GetFleetTypeBlySlugParamsFromJSONTyped(json, false);
}
function GetFleetTypeBlySlugParamsFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    fleetTypeSlug: json["fleetTypeSlug"] == null ? void 0 : json["fleetTypeSlug"]
  };
}
function GetFleetTypeBlySlugParamsToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    fleetTypeSlug: value["fleetTypeSlug"]
  };
}

// src/rentals-api-v3/models/GetRewardPointsStatusQuery.ts
function instanceOfGetRewardPointsStatusQuery(value) {
  return true;
}
function GetRewardPointsStatusQueryFromJSON(json) {
  return GetRewardPointsStatusQueryFromJSONTyped(json, false);
}
function GetRewardPointsStatusQueryFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    fleetType: json["fleetType"] == null ? void 0 : json["fleetType"],
    dealId: json["dealId"] == null ? void 0 : json["dealId"]
  };
}
function GetRewardPointsStatusQueryToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    fleetType: value["fleetType"],
    dealId: value["dealId"]
  };
}

// src/rentals-api-v3/models/GetSelfServiceBookingParams.ts
function instanceOfGetSelfServiceBookingParams(value) {
  if (!("ref" in value) || value["ref"] === void 0) return false;
  return true;
}
function GetSelfServiceBookingParamsFromJSON(json) {
  return GetSelfServiceBookingParamsFromJSONTyped(json, false);
}
function GetSelfServiceBookingParamsFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    ref: json["ref"]
  };
}
function GetSelfServiceBookingParamsToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    ref: value["ref"]
  };
}

// src/rentals-api-v3/models/HirePeriod.ts
function instanceOfHirePeriod(value) {
  if (!("pickUpSiteCode" in value) || value["pickUpSiteCode"] === void 0) return false;
  if (!("dropOffSiteCode" in value) || value["dropOffSiteCode"] === void 0) return false;
  if (!("startDate" in value) || value["startDate"] === void 0) return false;
  if (!("endDate" in value) || value["endDate"] === void 0) return false;
  return true;
}
function HirePeriodFromJSON(json) {
  return HirePeriodFromJSONTyped(json, false);
}
function HirePeriodFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    fleetCategoryCode: json["fleetCategoryCode"] == null ? void 0 : json["fleetCategoryCode"],
    fleetTypeSlug: json["fleetTypeSlug"] == null ? void 0 : json["fleetTypeSlug"],
    pickUpSiteCode: json["pickUpSiteCode"],
    dropOffSiteCode: json["dropOffSiteCode"],
    startDate: stringToDate(json["startDate"]),
    endDate: stringToDate(json["endDate"]),
    minHireDays: json["minHireDays"] == null ? void 0 : json["minHireDays"]
  };
}
function HirePeriodToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    fleetCategoryCode: value["fleetCategoryCode"],
    fleetTypeSlug: value["fleetTypeSlug"],
    pickUpSiteCode: value["pickUpSiteCode"],
    dropOffSiteCode: value["dropOffSiteCode"],
    startDate: dateToString(value["startDate"]),
    endDate: dateToString(value["endDate"]),
    minHireDays: value["minHireDays"]
  };
}

// src/rentals-api-v3/models/InsuranceProductLine.ts
var InsuranceProductLineCategoryEnum = {
  InsuranceFee: "InsuranceFee"
};
function instanceOfInsuranceProductLine(value) {
  if (!("productId" in value) || value["productId"] === void 0) return false;
  if (!("sortOrder" in value) || value["sortOrder"] === void 0) return false;
  if (!("productCode" in value) || value["productCode"] === void 0) return false;
  if (!("name" in value) || value["name"] === void 0) return false;
  if (!("category" in value) || value["category"] === void 0) return false;
  if (!("isMandatory" in value) || value["isMandatory"] === void 0) return false;
  if (!("description" in value) || value["description"] === void 0) return false;
  if (!("price" in value) || value["price"] === void 0) return false;
  if (!("productType" in value) || value["productType"] === void 0) return false;
  if (!("isPercentageOnTotalCost" in value) || value["isPercentageOnTotalCost"] === void 0) return false;
  if (!("allowMultiple" in value) || value["allowMultiple"] === void 0) return false;
  if (!("commissionable" in value) || value["commissionable"] === void 0) return false;
  if (!("rentalDays" in value) || value["rentalDays"] === void 0) return false;
  if (!("numberOfDaysCalculated" in value) || value["numberOfDaysCalculated"] === void 0) return false;
  if (!("qty" in value) || value["qty"] === void 0) return false;
  if (!("total" in value) || value["total"] === void 0) return false;
  if (!("excessType" in value) || value["excessType"] === void 0) return false;
  if (!("excess" in value) || value["excess"] === void 0) return false;
  if (!("bond" in value) || value["bond"] === void 0) return false;
  return true;
}
function InsuranceProductLineFromJSON(json) {
  return InsuranceProductLineFromJSONTyped(json, false);
}
function InsuranceProductLineFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    ...json,
    productId: json["productId"],
    sortOrder: json["sortOrder"],
    productCode: json["productCode"],
    name: json["name"],
    category: json["category"],
    isMandatory: json["isMandatory"],
    description: json["description"],
    price: CurrencyValueFromJSON(json["price"]),
    productType: json["productType"],
    isPercentageOnTotalCost: json["isPercentageOnTotalCost"],
    allowMultiple: json["allowMultiple"],
    commissionable: json["commissionable"],
    associatedProductCode: json["associatedProductCode"] == null ? void 0 : json["associatedProductCode"],
    rentalDays: json["rentalDays"],
    numberOfDaysCalculated: json["numberOfDaysCalculated"],
    maxPrice: json["maxPrice"] == null ? void 0 : CurrencyValueFromJSON(json["maxPrice"]),
    qty: json["qty"],
    total: CurrencyValueFromJSON(json["total"]),
    isExcluded: json["isExcluded"] == null ? void 0 : json["isExcluded"],
    excessType: InsuranceTypeFromJSON(json["excessType"]),
    excess: CurrencyValueFromJSON(json["excess"]),
    bond: CurrencyValueFromJSON(json["bond"])
  };
}
function InsuranceProductLineToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    ...value,
    productId: value["productId"],
    sortOrder: value["sortOrder"],
    productCode: value["productCode"],
    name: value["name"],
    category: value["category"],
    isMandatory: value["isMandatory"],
    description: value["description"],
    price: CurrencyValueToJSON(value["price"]),
    productType: value["productType"],
    isPercentageOnTotalCost: value["isPercentageOnTotalCost"],
    allowMultiple: value["allowMultiple"],
    commissionable: value["commissionable"],
    associatedProductCode: value["associatedProductCode"],
    rentalDays: value["rentalDays"],
    numberOfDaysCalculated: value["numberOfDaysCalculated"],
    maxPrice: CurrencyValueToJSON(value["maxPrice"]),
    qty: value["qty"],
    total: CurrencyValueToJSON(value["total"]),
    isExcluded: value["isExcluded"],
    excessType: InsuranceTypeToJSON(value["excessType"]),
    excess: CurrencyValueToJSON(value["excess"]),
    bond: CurrencyValueToJSON(value["bond"])
  };
}

// src/rentals-api-v3/models/JucyAppStatusSchema.ts
function instanceOfJucyAppStatusSchema(value) {
  return true;
}
function JucyAppStatusSchemaFromJSON(json) {
  return JucyAppStatusSchemaFromJSONTyped(json, false);
}
function JucyAppStatusSchemaFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    au: json["au"] == null ? void 0 : json["au"],
    nz: json["nz"] == null ? void 0 : json["nz"]
  };
}
function JucyAppStatusSchemaToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    au: value["au"],
    nz: value["nz"]
  };
}

// src/rentals-api-v3/models/JucyApiStatusSchema.ts
function instanceOfJucyApiStatusSchema(value) {
  if (!("obe" in value) || value["obe"] === void 0) return false;
  return true;
}
function JucyApiStatusSchemaFromJSON(json) {
  return JucyApiStatusSchemaFromJSONTyped(json, false);
}
function JucyApiStatusSchemaFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    obe: JucyAppStatusSchemaFromJSON(json["obe"])
  };
}
function JucyApiStatusSchemaToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    obe: JucyAppStatusSchemaToJSON(value["obe"])
  };
}

// src/rentals-api-v3/models/LeadTime.ts
function instanceOfLeadTime(value) {
  return true;
}
function LeadTimeFromJSON(json) {
  return LeadTimeFromJSONTyped(json, false);
}
function LeadTimeFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    fleetTypeCode: json["fleetTypeCode"] == null ? void 0 : json["fleetTypeCode"],
    leadTime: json["leadTime"] == null ? void 0 : json["leadTime"]
  };
}
function LeadTimeToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    fleetTypeCode: value["fleetTypeCode"],
    leadTime: value["leadTime"]
  };
}

// src/rentals-api-v3/models/LinkReservationRequest.ts
function instanceOfLinkReservationRequest(value) {
  if (!("lastName" in value) || value["lastName"] === void 0) return false;
  if (!("bookingNumber" in value) || value["bookingNumber"] === void 0) return false;
  if (!("pickUpBranchCode" in value) || value["pickUpBranchCode"] === void 0) return false;
  return true;
}
function LinkReservationRequestFromJSON(json) {
  return LinkReservationRequestFromJSONTyped(json, false);
}
function LinkReservationRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    lastName: json["lastName"],
    bookingNumber: json["bookingNumber"],
    pickUpBranchCode: json["pickUpBranchCode"]
  };
}
function LinkReservationRequestToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    lastName: value["lastName"],
    bookingNumber: value["bookingNumber"],
    pickUpBranchCode: value["pickUpBranchCode"]
  };
}

// src/rentals-api-v3/models/ListBranchContentQuery.ts
function instanceOfListBranchContentQuery(value) {
  return true;
}
function ListBranchContentQueryFromJSON(json) {
  return ListBranchContentQueryFromJSONTyped(json, false);
}
function ListBranchContentQueryFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    brand: json["brand"] == null ? void 0 : json["brand"],
    countryCode: json["countryCode"] == null ? void 0 : json["countryCode"]
  };
}
function ListBranchContentQueryToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    brand: value["brand"],
    countryCode: value["countryCode"]
  };
}

// src/rentals-api-v3/models/ListFleetCategoriesQuery.ts
var ListFleetCategoriesQueryCountryCodeEnum = {
  All: "all",
  Au: "au",
  Nz: "nz"
};
function instanceOfListFleetCategoriesQuery(value) {
  return true;
}
function ListFleetCategoriesQueryFromJSON(json) {
  return ListFleetCategoriesQueryFromJSONTyped(json, false);
}
function ListFleetCategoriesQueryFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    fleetType: json["fleetType"] == null ? void 0 : json["fleetType"],
    countryCode: json["countryCode"] == null ? void 0 : json["countryCode"]
  };
}
function ListFleetCategoriesQueryToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    fleetType: value["fleetType"],
    countryCode: value["countryCode"]
  };
}

// src/rentals-api-v3/models/ListFleetCategoryContentQuery.ts
var ListFleetCategoryContentQueryCountryCodeEnum = {
  All: "all",
  Au: "au",
  Nz: "nz"
};
function instanceOfListFleetCategoryContentQuery(value) {
  return true;
}
function ListFleetCategoryContentQueryFromJSON(json) {
  return ListFleetCategoryContentQueryFromJSONTyped(json, false);
}
function ListFleetCategoryContentQueryFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    countryCode: json["countryCode"] == null ? void 0 : json["countryCode"]
  };
}
function ListFleetCategoryContentQueryToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    countryCode: value["countryCode"]
  };
}

// src/rentals-api-v3/models/ListShuttlesQuery.ts
function instanceOfListShuttlesQuery(value) {
  return true;
}
function ListShuttlesQueryFromJSON(json) {
  return ListShuttlesQueryFromJSONTyped(json, false);
}
function ListShuttlesQueryFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    countryCode: json["countryCode"] == null ? void 0 : json["countryCode"],
    branchCode: json["branchCode"] == null ? void 0 : json["branchCode"]
  };
}
function ListShuttlesQueryToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    countryCode: value["countryCode"],
    branchCode: value["branchCode"]
  };
}

// src/rentals-api-v3/models/LogSelfServiceEventParams.ts
function instanceOfLogSelfServiceEventParams(value) {
  if (!("reservationRef" in value) || value["reservationRef"] === void 0) return false;
  return true;
}
function LogSelfServiceEventParamsFromJSON(json) {
  return LogSelfServiceEventParamsFromJSONTyped(json, false);
}
function LogSelfServiceEventParamsFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    reservationRef: json["reservationRef"]
  };
}
function LogSelfServiceEventParamsToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    reservationRef: value["reservationRef"]
  };
}

// src/rentals-api-v3/models/LogSelfServiceEventRequest.ts
function instanceOfLogSelfServiceEventRequest(value) {
  if (!("eventType" in value) || value["eventType"] === void 0) return false;
  if (!("eventName" in value) || value["eventName"] === void 0) return false;
  return true;
}
function LogSelfServiceEventRequestFromJSON(json) {
  return LogSelfServiceEventRequestFromJSONTyped(json, false);
}
function LogSelfServiceEventRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    eventType: json["eventType"],
    eventName: json["eventName"]
  };
}
function LogSelfServiceEventRequestToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    eventType: value["eventType"],
    eventName: value["eventName"]
  };
}

// src/rentals-api-v3/models/LoyaltyRequestData.ts
function instanceOfLoyaltyRequestData(value) {
  if (!("id" in value) || value["id"] === void 0) return false;
  if (!("type" in value) || value["type"] === void 0) return false;
  return true;
}
function LoyaltyRequestDataFromJSON(json) {
  return LoyaltyRequestDataFromJSONTyped(json, false);
}
function LoyaltyRequestDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    type: json["type"]
  };
}
function LoyaltyRequestDataToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    id: value["id"],
    type: value["type"]
  };
}

// src/rentals-api-v3/models/MapMarker.ts
function instanceOfMapMarker(value) {
  if (!("lat" in value) || value["lat"] === void 0) return false;
  if (!("lng" in value) || value["lng"] === void 0) return false;
  if (!("zoom" in value) || value["zoom"] === void 0) return false;
  return true;
}
function MapMarkerFromJSON(json) {
  return MapMarkerFromJSONTyped(json, false);
}
function MapMarkerFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    lat: json["lat"],
    lng: json["lng"],
    zoom: json["zoom"]
  };
}
function MapMarkerToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    lat: value["lat"],
    lng: value["lng"],
    zoom: value["zoom"]
  };
}

// src/rentals-api-v3/models/MessageResponse.ts
function instanceOfMessageResponse(value) {
  if (!("message" in value) || value["message"] === void 0) return false;
  return true;
}
function MessageResponseFromJSON(json) {
  return MessageResponseFromJSONTyped(json, false);
}
function MessageResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    message: json["message"],
    statusCode: json["statusCode"] == null ? void 0 : json["statusCode"],
    data: json["data"] == null ? void 0 : json["data"]
  };
}
function MessageResponseToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    message: value["message"],
    statusCode: value["statusCode"],
    data: value["data"]
  };
}

// src/rentals-api-v3/models/MinimumHirePeriod.ts
function instanceOfMinimumHirePeriod(value) {
  if (!("id" in value) || value["id"] === void 0) return false;
  if (!("region" in value) || value["region"] === void 0) return false;
  if (!("minDays" in value) || value["minDays"] === void 0) return false;
  return true;
}
function MinimumHirePeriodFromJSON(json) {
  return MinimumHirePeriodFromJSONTyped(json, false);
}
function MinimumHirePeriodFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    pickUpLocationCode: json["pickUpLocationCode"] == null ? void 0 : json["pickUpLocationCode"],
    dropOffLocationCode: json["dropOffLocationCode"] == null ? void 0 : json["dropOffLocationCode"],
    fleetCategoryCode: json["fleetCategoryCode"] == null ? void 0 : json["fleetCategoryCode"],
    region: JucyCountryCodeFromJSON(json["region"]),
    minDays: json["minDays"],
    feeAmount: json["feeAmount"] == null ? void 0 : CurrencyValueFromJSON(json["feeAmount"]),
    daysNoCharge: json["daysNoCharge"] == null ? void 0 : json["daysNoCharge"],
    pickUpStartDate: json["pickUpStartDate"] == null ? void 0 : stringToDate(json["pickUpStartDate"]),
    pickUpEndDate: json["pickUpEndDate"] == null ? void 0 : stringToDate(json["pickUpEndDate"])
  };
}
function MinimumHirePeriodToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    id: value["id"],
    pickUpLocationCode: value["pickUpLocationCode"],
    dropOffLocationCode: value["dropOffLocationCode"],
    fleetCategoryCode: value["fleetCategoryCode"],
    region: JucyCountryCodeToJSON(value["region"]),
    minDays: value["minDays"],
    feeAmount: CurrencyValueToJSON(value["feeAmount"]),
    daysNoCharge: value["daysNoCharge"],
    pickUpStartDate: value.pickUpStartDate === void 0 ? void 0 : dateToString(value["pickUpStartDate"])?.substring(0, 10),
    pickUpEndDate: value.pickUpEndDate === void 0 ? void 0 : dateToString(value["pickUpEndDate"])?.substring(0, 10)
  };
}

// src/rentals-api-v3/models/MinimumHirePeriodFormat.ts
var MinimumHirePeriodFormat = {
  Json: "json",
  Xlsx: "xlsx",
  Csv: "csv"
};
function instanceOfMinimumHirePeriodFormat(value) {
  for (const key in MinimumHirePeriodFormat) {
    if (Object.prototype.hasOwnProperty.call(MinimumHirePeriodFormat, key)) {
      if (MinimumHirePeriodFormat[key] === value) {
        return true;
      }
    }
  }
  return false;
}
function MinimumHirePeriodFormatFromJSON(json) {
  return MinimumHirePeriodFormatFromJSONTyped(json, false);
}
function MinimumHirePeriodFormatFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function MinimumHirePeriodFormatToJSON(value) {
  return value;
}

// src/rentals-api-v3/models/MinimumHirePeriodRequest.ts
function instanceOfMinimumHirePeriodRequest(value) {
  return true;
}
function MinimumHirePeriodRequestFromJSON(json) {
  return MinimumHirePeriodRequestFromJSONTyped(json, false);
}
function MinimumHirePeriodRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    pickUpLocationCode: json["pickUpLocationCode"] == null ? void 0 : json["pickUpLocationCode"],
    dropOffLocationCode: json["dropOffLocationCode"] == null ? void 0 : json["dropOffLocationCode"],
    fleetCategoryCode: json["fleetCategoryCode"] == null ? void 0 : json["fleetCategoryCode"],
    fleetTypeCode: json["fleetTypeCode"] == null ? void 0 : json["fleetTypeCode"],
    region: json["region"] == null ? void 0 : JucyCountryCodeFromJSON(json["region"]),
    format: json["format"] == null ? void 0 : MinimumHirePeriodFormatFromJSON(json["format"])
  };
}
function MinimumHirePeriodRequestToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    pickUpLocationCode: value["pickUpLocationCode"],
    dropOffLocationCode: value["dropOffLocationCode"],
    fleetCategoryCode: value["fleetCategoryCode"],
    fleetTypeCode: value["fleetTypeCode"],
    region: JucyCountryCodeToJSON(value["region"]),
    format: MinimumHirePeriodFormatToJSON(value["format"])
  };
}

// src/rentals-api-v3/models/OperatorAvailableAccountsInner.ts
function instanceOfOperatorAvailableAccountsInner(value) {
  if (!("label" in value) || value["label"] === void 0) return false;
  if (!("key" in value) || value["key"] === void 0) return false;
  return true;
}
function OperatorAvailableAccountsInnerFromJSON(json) {
  return OperatorAvailableAccountsInnerFromJSONTyped(json, false);
}
function OperatorAvailableAccountsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    label: json["label"],
    key: json["key"]
  };
}
function OperatorAvailableAccountsInnerToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    label: value["label"],
    key: value["key"]
  };
}

// src/rentals-api-v3/models/Operator.ts
function instanceOfOperator(value) {
  if (!("email" in value) || value["email"] === void 0) return false;
  return true;
}
function OperatorFromJSON(json) {
  return OperatorFromJSONTyped(json, false);
}
function OperatorFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    email: json["email"],
    firstName: json["firstName"] == null ? void 0 : json["firstName"],
    lastName: json["lastName"] == null ? void 0 : json["lastName"],
    rcmId: json["rcmId"] == null ? void 0 : json["rcmId"],
    rcmOperatorId: json["rcmOperatorId"] == null ? void 0 : json["rcmOperatorId"],
    rcmUserName: json["rcmUserName"] == null ? void 0 : json["rcmUserName"],
    rcmAccessLevel: json["rcmAccessLevel"] == null ? void 0 : json["rcmAccessLevel"],
    rcmEmail: json["rcmEmail"] == null ? void 0 : json["rcmEmail"],
    availableAccounts: json["availableAccounts"] == null ? void 0 : json["availableAccounts"].map(OperatorAvailableAccountsInnerFromJSON)
  };
}
function OperatorToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    email: value["email"],
    firstName: value["firstName"],
    lastName: value["lastName"],
    rcmId: value["rcmId"],
    rcmOperatorId: value["rcmOperatorId"],
    rcmUserName: value["rcmUserName"],
    rcmAccessLevel: value["rcmAccessLevel"],
    rcmEmail: value["rcmEmail"],
    availableAccounts: value["availableAccounts"] == null ? void 0 : value["availableAccounts"].map(OperatorAvailableAccountsInnerToJSON)
  };
}

// src/rentals-api-v3/models/PaymentConfig.ts
function instanceOfPaymentConfig(value) {
  if (!("merchantFeeRate" in value) || value["merchantFeeRate"] === void 0) return false;
  return true;
}
function PaymentConfigFromJSON(json) {
  return PaymentConfigFromJSONTyped(json, false);
}
function PaymentConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    merchantFeeRate: json["merchantFeeRate"],
    afterpay: json["afterpay"] == null ? void 0 : AfterpayConfigFromJSON(json["afterpay"])
  };
}
function PaymentConfigToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    merchantFeeRate: value["merchantFeeRate"],
    afterpay: AfterpayConfigToJSON(value["afterpay"])
  };
}

// src/rentals-api-v3/models/Product.ts
function instanceOfProduct(value) {
  if (!("productId" in value) || value["productId"] === void 0) return false;
  if (!("sortOrder" in value) || value["sortOrder"] === void 0) return false;
  if (!("productCode" in value) || value["productCode"] === void 0) return false;
  if (!("name" in value) || value["name"] === void 0) return false;
  if (!("category" in value) || value["category"] === void 0) return false;
  if (!("isMandatory" in value) || value["isMandatory"] === void 0) return false;
  if (!("description" in value) || value["description"] === void 0) return false;
  if (!("price" in value) || value["price"] === void 0) return false;
  if (!("productType" in value) || value["productType"] === void 0) return false;
  if (!("isPercentageOnTotalCost" in value) || value["isPercentageOnTotalCost"] === void 0) return false;
  if (!("allowMultiple" in value) || value["allowMultiple"] === void 0) return false;
  if (!("commissionable" in value) || value["commissionable"] === void 0) return false;
  if (!("rentalDays" in value) || value["rentalDays"] === void 0) return false;
  if (!("numberOfDaysCalculated" in value) || value["numberOfDaysCalculated"] === void 0) return false;
  return true;
}
function ProductFromJSON(json) {
  return ProductFromJSONTyped(json, false);
}
function ProductFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    productId: json["productId"],
    sortOrder: json["sortOrder"],
    productCode: json["productCode"],
    name: json["name"],
    category: json["category"],
    isMandatory: json["isMandatory"],
    description: json["description"],
    price: CurrencyValueFromJSON(json["price"]),
    productType: json["productType"],
    isPercentageOnTotalCost: json["isPercentageOnTotalCost"],
    allowMultiple: json["allowMultiple"],
    commissionable: json["commissionable"],
    associatedProductCode: json["associatedProductCode"] == null ? void 0 : json["associatedProductCode"],
    rentalDays: json["rentalDays"],
    numberOfDaysCalculated: json["numberOfDaysCalculated"],
    maxPrice: json["maxPrice"] == null ? void 0 : CurrencyValueFromJSON(json["maxPrice"])
  };
}
function ProductToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    productId: value["productId"],
    sortOrder: value["sortOrder"],
    productCode: value["productCode"],
    name: value["name"],
    category: value["category"],
    isMandatory: value["isMandatory"],
    description: value["description"],
    price: CurrencyValueToJSON(value["price"]),
    productType: value["productType"],
    isPercentageOnTotalCost: value["isPercentageOnTotalCost"],
    allowMultiple: value["allowMultiple"],
    commissionable: value["commissionable"],
    associatedProductCode: value["associatedProductCode"],
    rentalDays: value["rentalDays"],
    numberOfDaysCalculated: value["numberOfDaysCalculated"],
    maxPrice: CurrencyValueToJSON(value["maxPrice"])
  };
}

// src/rentals-api-v3/models/ProductGroup.ts
function instanceOfProductGroup(value) {
  if (!("group" in value) || value["group"] === void 0) return false;
  if (!("webCategory" in value) || value["webCategory"] === void 0) return false;
  if (!("required" in value) || value["required"] === void 0) return false;
  if (!("allowMultiple" in value) || value["allowMultiple"] === void 0) return false;
  if (!("description" in value) || value["description"] === void 0) return false;
  return true;
}
function ProductGroupFromJSON(json) {
  return ProductGroupFromJSONTyped(json, false);
}
function ProductGroupFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    group: json["group"],
    webCategory: json["webCategory"],
    required: json["required"],
    allowMultiple: json["allowMultiple"],
    description: json["description"]
  };
}
function ProductGroupToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    group: value["group"],
    webCategory: value["webCategory"],
    required: value["required"],
    allowMultiple: value["allowMultiple"],
    description: value["description"]
  };
}

// src/rentals-api-v3/models/ProductItem.ts
function instanceOfProductItem(value) {
  if (!("productId" in value) || value["productId"] === void 0) return false;
  if (!("sortOrder" in value) || value["sortOrder"] === void 0) return false;
  if (!("productCode" in value) || value["productCode"] === void 0) return false;
  if (!("name" in value) || value["name"] === void 0) return false;
  if (!("category" in value) || value["category"] === void 0) return false;
  if (!("isMandatory" in value) || value["isMandatory"] === void 0) return false;
  if (!("description" in value) || value["description"] === void 0) return false;
  if (!("price" in value) || value["price"] === void 0) return false;
  if (!("productType" in value) || value["productType"] === void 0) return false;
  if (!("isPercentageOnTotalCost" in value) || value["isPercentageOnTotalCost"] === void 0) return false;
  if (!("allowMultiple" in value) || value["allowMultiple"] === void 0) return false;
  if (!("commissionable" in value) || value["commissionable"] === void 0) return false;
  if (!("rentalDays" in value) || value["rentalDays"] === void 0) return false;
  if (!("numberOfDaysCalculated" in value) || value["numberOfDaysCalculated"] === void 0) return false;
  if (!("qty" in value) || value["qty"] === void 0) return false;
  if (!("total" in value) || value["total"] === void 0) return false;
  return true;
}
function ProductItemFromJSON(json) {
  return ProductItemFromJSONTyped(json, false);
}
function ProductItemFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    productId: json["productId"],
    sortOrder: json["sortOrder"],
    productCode: json["productCode"],
    name: json["name"],
    category: json["category"],
    isMandatory: json["isMandatory"],
    description: json["description"],
    price: CurrencyValueFromJSON(json["price"]),
    productType: json["productType"],
    isPercentageOnTotalCost: json["isPercentageOnTotalCost"],
    allowMultiple: json["allowMultiple"],
    commissionable: json["commissionable"],
    associatedProductCode: json["associatedProductCode"] == null ? void 0 : json["associatedProductCode"],
    rentalDays: json["rentalDays"],
    numberOfDaysCalculated: json["numberOfDaysCalculated"],
    maxPrice: json["maxPrice"] == null ? void 0 : CurrencyValueFromJSON(json["maxPrice"]),
    qty: json["qty"],
    total: CurrencyValueFromJSON(json["total"])
  };
}
function ProductItemToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    productId: value["productId"],
    sortOrder: value["sortOrder"],
    productCode: value["productCode"],
    name: value["name"],
    category: value["category"],
    isMandatory: value["isMandatory"],
    description: value["description"],
    price: CurrencyValueToJSON(value["price"]),
    productType: value["productType"],
    isPercentageOnTotalCost: value["isPercentageOnTotalCost"],
    allowMultiple: value["allowMultiple"],
    commissionable: value["commissionable"],
    associatedProductCode: value["associatedProductCode"],
    rentalDays: value["rentalDays"],
    numberOfDaysCalculated: value["numberOfDaysCalculated"],
    maxPrice: CurrencyValueToJSON(value["maxPrice"]),
    qty: value["qty"],
    total: CurrencyValueToJSON(value["total"])
  };
}

// src/rentals-api-v3/models/ProductLine.ts
function instanceOfProductLine(value) {
  if (!("productId" in value) || value["productId"] === void 0) return false;
  if (!("sortOrder" in value) || value["sortOrder"] === void 0) return false;
  if (!("productCode" in value) || value["productCode"] === void 0) return false;
  if (!("name" in value) || value["name"] === void 0) return false;
  if (!("category" in value) || value["category"] === void 0) return false;
  if (!("isMandatory" in value) || value["isMandatory"] === void 0) return false;
  if (!("description" in value) || value["description"] === void 0) return false;
  if (!("price" in value) || value["price"] === void 0) return false;
  if (!("productType" in value) || value["productType"] === void 0) return false;
  if (!("isPercentageOnTotalCost" in value) || value["isPercentageOnTotalCost"] === void 0) return false;
  if (!("allowMultiple" in value) || value["allowMultiple"] === void 0) return false;
  if (!("commissionable" in value) || value["commissionable"] === void 0) return false;
  if (!("rentalDays" in value) || value["rentalDays"] === void 0) return false;
  if (!("numberOfDaysCalculated" in value) || value["numberOfDaysCalculated"] === void 0) return false;
  if (!("qty" in value) || value["qty"] === void 0) return false;
  if (!("total" in value) || value["total"] === void 0) return false;
  return true;
}
function ProductLineFromJSON(json) {
  return ProductLineFromJSONTyped(json, false);
}
function ProductLineFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    ...json,
    productId: json["productId"],
    sortOrder: json["sortOrder"],
    productCode: json["productCode"],
    name: json["name"],
    category: json["category"],
    isMandatory: json["isMandatory"],
    description: json["description"],
    price: CurrencyValueFromJSON(json["price"]),
    productType: json["productType"],
    isPercentageOnTotalCost: json["isPercentageOnTotalCost"],
    allowMultiple: json["allowMultiple"],
    commissionable: json["commissionable"],
    associatedProductCode: json["associatedProductCode"] == null ? void 0 : json["associatedProductCode"],
    rentalDays: json["rentalDays"],
    numberOfDaysCalculated: json["numberOfDaysCalculated"],
    maxPrice: json["maxPrice"] == null ? void 0 : CurrencyValueFromJSON(json["maxPrice"]),
    qty: json["qty"],
    total: CurrencyValueFromJSON(json["total"]),
    isExcluded: json["isExcluded"] == null ? void 0 : json["isExcluded"]
  };
}
function ProductLineToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    ...value,
    productId: value["productId"],
    sortOrder: value["sortOrder"],
    productCode: value["productCode"],
    name: value["name"],
    category: value["category"],
    isMandatory: value["isMandatory"],
    description: value["description"],
    price: CurrencyValueToJSON(value["price"]),
    productType: value["productType"],
    isPercentageOnTotalCost: value["isPercentageOnTotalCost"],
    allowMultiple: value["allowMultiple"],
    commissionable: value["commissionable"],
    associatedProductCode: value["associatedProductCode"],
    rentalDays: value["rentalDays"],
    numberOfDaysCalculated: value["numberOfDaysCalculated"],
    maxPrice: CurrencyValueToJSON(value["maxPrice"]),
    qty: value["qty"],
    total: CurrencyValueToJSON(value["total"]),
    isExcluded: value["isExcluded"]
  };
}

// src/rentals-api-v3/models/RentalCatalogQuery.ts
function instanceOfRentalCatalogQuery(value) {
  return true;
}
function RentalCatalogQueryFromJSON(json) {
  return RentalCatalogQueryFromJSONTyped(json, false);
}
function RentalCatalogQueryFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    fleetCategory: json["fleetCategory"] == null ? void 0 : json["fleetCategory"],
    fleetType: json["fleetType"] == null ? void 0 : json["fleetType"]
  };
}
function RentalCatalogQueryToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    fleetCategory: value["fleetCategory"],
    fleetType: value["fleetType"]
  };
}

// src/rentals-api-v3/models/RentalCatalogResponse.ts
function instanceOfRentalCatalogResponse(value) {
  if (!("products" in value) || value["products"] === void 0) return false;
  return true;
}
function RentalCatalogResponseFromJSON(json) {
  return RentalCatalogResponseFromJSONTyped(json, false);
}
function RentalCatalogResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    products: json["products"].map(CatalogItemFromJSON)
  };
}
function RentalCatalogResponseToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    products: value["products"].map(CatalogItemToJSON)
  };
}

// src/rentals-api-v3/models/ReservationRefParams.ts
function instanceOfReservationRefParams(value) {
  if (!("reservationRef" in value) || value["reservationRef"] === void 0) return false;
  return true;
}
function ReservationRefParamsFromJSON(json) {
  return ReservationRefParamsFromJSONTyped(json, false);
}
function ReservationRefParamsFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    reservationRef: json["reservationRef"]
  };
}
function ReservationRefParamsToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    reservationRef: value["reservationRef"]
  };
}

// src/rentals-api-v3/models/ReservationRewardPointsStatus.ts
function instanceOfReservationRewardPointsStatus(value) {
  if (!("eligible" in value) || value["eligible"] === void 0) return false;
  if (!("maxBasePoints" in value) || value["maxBasePoints"] === void 0) return false;
  if (!("maxBonusPoints" in value) || value["maxBonusPoints"] === void 0) return false;
  if (!("exchangeRate" in value) || value["exchangeRate"] === void 0) return false;
  if (!("locked" in value) || value["locked"] === void 0) return false;
  return true;
}
function ReservationRewardPointsStatusFromJSON(json) {
  return ReservationRewardPointsStatusFromJSONTyped(json, false);
}
function ReservationRewardPointsStatusFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    eligible: json["eligible"],
    type: json["type"] == null ? void 0 : json["type"],
    baseMultiplier: json["baseMultiplier"] == null ? void 0 : json["baseMultiplier"],
    bonusPoints: json["bonusPoints"] == null ? void 0 : json["bonusPoints"],
    bonusMultiplier: json["bonusMultiplier"] == null ? void 0 : json["bonusMultiplier"],
    maxBasePoints: json["maxBasePoints"],
    maxBonusPoints: json["maxBonusPoints"],
    exchangeRate: json["exchangeRate"],
    membershipId: json["membershipId"] == null ? void 0 : json["membershipId"],
    pointEstimate: json["pointEstimate"] == null ? void 0 : json["pointEstimate"],
    bonusPointEstimate: json["bonusPointEstimate"] == null ? void 0 : json["bonusPointEstimate"],
    earnableTotal: json["earnableTotal"] == null ? void 0 : CurrencyValueFromJSON(json["earnableTotal"]),
    bookingTotal: json["bookingTotal"] == null ? void 0 : CurrencyValueFromJSON(json["bookingTotal"]),
    locked: json["locked"]
  };
}
function ReservationRewardPointsStatusToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    eligible: value["eligible"],
    type: value["type"],
    baseMultiplier: value["baseMultiplier"],
    bonusPoints: value["bonusPoints"],
    bonusMultiplier: value["bonusMultiplier"],
    maxBasePoints: value["maxBasePoints"],
    maxBonusPoints: value["maxBonusPoints"],
    exchangeRate: value["exchangeRate"],
    membershipId: value["membershipId"],
    pointEstimate: value["pointEstimate"],
    bonusPointEstimate: value["bonusPointEstimate"],
    earnableTotal: CurrencyValueToJSON(value["earnableTotal"]),
    bookingTotal: CurrencyValueToJSON(value["bookingTotal"]),
    locked: value["locked"]
  };
}

// src/rentals-api-v3/models/RewardPointsConfig.ts
function instanceOfRewardPointsConfig(value) {
  if (!("eligible" in value) || value["eligible"] === void 0) return false;
  if (!("maxBasePoints" in value) || value["maxBasePoints"] === void 0) return false;
  if (!("maxBonusPoints" in value) || value["maxBonusPoints"] === void 0) return false;
  if (!("exchangeRate" in value) || value["exchangeRate"] === void 0) return false;
  return true;
}
function RewardPointsConfigFromJSON(json) {
  return RewardPointsConfigFromJSONTyped(json, false);
}
function RewardPointsConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    eligible: json["eligible"],
    type: json["type"] == null ? void 0 : json["type"],
    baseMultiplier: json["baseMultiplier"] == null ? void 0 : json["baseMultiplier"],
    bonusPoints: json["bonusPoints"] == null ? void 0 : json["bonusPoints"],
    bonusMultiplier: json["bonusMultiplier"] == null ? void 0 : json["bonusMultiplier"],
    maxBasePoints: json["maxBasePoints"],
    maxBonusPoints: json["maxBonusPoints"],
    exchangeRate: json["exchangeRate"]
  };
}
function RewardPointsConfigToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    eligible: value["eligible"],
    type: value["type"],
    baseMultiplier: value["baseMultiplier"],
    bonusPoints: value["bonusPoints"],
    bonusMultiplier: value["bonusMultiplier"],
    maxBasePoints: value["maxBasePoints"],
    maxBonusPoints: value["maxBonusPoints"],
    exchangeRate: value["exchangeRate"]
  };
}

// src/rentals-api-v3/models/SaveReservationRewardPointsResponse.ts
function instanceOfSaveReservationRewardPointsResponse(value) {
  if (!("message" in value) || value["message"] === void 0) return false;
  if (!("data" in value) || value["data"] === void 0) return false;
  return true;
}
function SaveReservationRewardPointsResponseFromJSON(json) {
  return SaveReservationRewardPointsResponseFromJSONTyped(json, false);
}
function SaveReservationRewardPointsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    message: json["message"],
    statusCode: json["statusCode"] == null ? void 0 : json["statusCode"],
    data: LoyaltyRequestDataFromJSON(json["data"])
  };
}
function SaveReservationRewardPointsResponseToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    message: value["message"],
    statusCode: value["statusCode"],
    data: LoyaltyRequestDataToJSON(value["data"])
  };
}

// src/rentals-api-v3/models/SelfServiceBooking.ts
function instanceOfSelfServiceBooking(value) {
  if (!("quoteId" in value) || value["quoteId"] === void 0) return false;
  if (!("reservationId" in value) || value["reservationId"] === void 0) return false;
  if (!("reservationReference" in value) || value["reservationReference"] === void 0) return false;
  if (!("status" in value) || value["status"] === void 0) return false;
  if (!("pickUpLocation" in value) || value["pickUpLocation"] === void 0) return false;
  if (!("dropOffLocation" in value) || value["dropOffLocation"] === void 0) return false;
  if (!("dateCreated" in value) || value["dateCreated"] === void 0) return false;
  if (!("pickUpDate" in value) || value["pickUpDate"] === void 0) return false;
  if (!("dropOffDate" in value) || value["dropOffDate"] === void 0) return false;
  if (!("rentalDays" in value) || value["rentalDays"] === void 0) return false;
  if (!("totalPrice" in value) || value["totalPrice"] === void 0) return false;
  if (!("driverAge" in value) || value["driverAge"] === void 0) return false;
  if (!("fleetCategory" in value) || value["fleetCategory"] === void 0) return false;
  return true;
}
function SelfServiceBookingFromJSON(json) {
  return SelfServiceBookingFromJSONTyped(json, false);
}
function SelfServiceBookingFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    quoteId: json["quoteId"],
    reservationId: json["reservationId"],
    reservationReference: json["reservationReference"],
    agentBalanceDue: json["agentBalanceDue"] == null ? void 0 : CurrencyValueFromJSON(json["agentBalanceDue"]),
    agentCollects: json["agentCollects"] == null ? void 0 : CurrencyValueFromJSON(json["agentCollects"]),
    agentCommission: json["agentCommission"] == null ? void 0 : CurrencyValueFromJSON(json["agentCommission"]),
    voucherReference: json["voucherReference"] == null ? void 0 : json["voucherReference"],
    agentName: json["agentName"] == null ? void 0 : json["agentName"],
    balanceDue: json["balanceDue"] == null ? void 0 : CurrencyValueFromJSON(json["balanceDue"]),
    payments: json["payments"] == null ? void 0 : json["payments"].map(BookingPaymentInfoFromJSON),
    status: BookingStatusFromJSON(json["status"]),
    pickUpLocation: json["pickUpLocation"],
    dropOffLocation: json["dropOffLocation"],
    dateCreated: stringToDate(json["dateCreated"]),
    pickUpDate: stringToDate(json["pickUpDate"]),
    dropOffDate: stringToDate(json["dropOffDate"]),
    rentalDays: json["rentalDays"],
    totalPrice: CurrencyValueFromJSON(json["totalPrice"]),
    driverAge: json["driverAge"],
    lines: json["lines"] == null ? void 0 : json["lines"].map(BookingLinesInnerFromJSON),
    hirerDetails: json["hirerDetails"] == null ? void 0 : HirerDetailsFromJSON(json["hirerDetails"]),
    fleetCategory: FleetCategoryFromJSON(json["fleetCategory"]),
    referrerCode: json["referrerCode"] == null ? void 0 : json["referrerCode"],
    bookedWith: json["bookedWith"] == null ? void 0 : BookedWithFromJSON(json["bookedWith"])
  };
}
function SelfServiceBookingToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    quoteId: value["quoteId"],
    reservationId: value["reservationId"],
    reservationReference: value["reservationReference"],
    agentBalanceDue: CurrencyValueToJSON(value["agentBalanceDue"]),
    agentCollects: CurrencyValueToJSON(value["agentCollects"]),
    agentCommission: CurrencyValueToJSON(value["agentCommission"]),
    voucherReference: value["voucherReference"],
    agentName: value["agentName"],
    balanceDue: CurrencyValueToJSON(value["balanceDue"]),
    payments: value["payments"] == null ? void 0 : value["payments"].map(BookingPaymentInfoToJSON),
    status: BookingStatusToJSON(value["status"]),
    pickUpLocation: value["pickUpLocation"],
    dropOffLocation: value["dropOffLocation"],
    dateCreated: dateToString(value["dateCreated"]),
    pickUpDate: dateToString(value["pickUpDate"]),
    dropOffDate: dateToString(value["dropOffDate"]),
    rentalDays: value["rentalDays"],
    totalPrice: CurrencyValueToJSON(value["totalPrice"]),
    driverAge: value["driverAge"],
    lines: value["lines"] == null ? void 0 : value["lines"].map(BookingLinesInnerToJSON),
    hirerDetails: HirerDetailsToJSON(value["hirerDetails"]),
    fleetCategory: FleetCategoryToJSON(value["fleetCategory"]),
    referrerCode: value["referrerCode"],
    bookedWith: BookedWithToJSON(value["bookedWith"])
  };
}

// src/rentals-api-v3/models/SelfServiceGetReservationRewardPointsStatus.ts
function instanceOfSelfServiceGetReservationRewardPointsStatus(value) {
  if (!("ref" in value) || value["ref"] === void 0) return false;
  return true;
}
function SelfServiceGetReservationRewardPointsStatusFromJSON(json) {
  return SelfServiceGetReservationRewardPointsStatusFromJSONTyped(json, false);
}
function SelfServiceGetReservationRewardPointsStatusFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    ref: json["ref"]
  };
}
function SelfServiceGetReservationRewardPointsStatusToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    ref: value["ref"]
  };
}

// src/rentals-api-v3/models/SelfServicePreferenceParam.ts
function instanceOfSelfServicePreferenceParam(value) {
  if (!("ref" in value) || value["ref"] === void 0) return false;
  return true;
}
function SelfServicePreferenceParamFromJSON(json) {
  return SelfServicePreferenceParamFromJSONTyped(json, false);
}
function SelfServicePreferenceParamFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    ref: json["ref"]
  };
}
function SelfServicePreferenceParamToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    ref: value["ref"]
  };
}

// src/rentals-api-v3/models/SelfServicePreferences.ts
var SelfServicePreferencesTypeEnum = {
  Direct: "direct",
  Agent: "agent"
};
function instanceOfSelfServicePreferences(value) {
  if (!("directContent" in value) || value["directContent"] === void 0) return false;
  if (!("type" in value) || value["type"] === void 0) return false;
  return true;
}
function SelfServicePreferencesFromJSON(json) {
  return SelfServicePreferencesFromJSONTyped(json, false);
}
function SelfServicePreferencesFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    directContent: json["directContent"],
    type: json["type"]
  };
}
function SelfServicePreferencesToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    directContent: value["directContent"],
    type: value["type"]
  };
}

// src/rentals-api-v3/models/SendPaymentRequest.ts
function instanceOfSendPaymentRequest(value) {
  if (!("total" in value) || value["total"] === void 0) return false;
  if (!("region" in value) || value["region"] === void 0) return false;
  return true;
}
function SendPaymentRequestFromJSON(json) {
  return SendPaymentRequestFromJSONTyped(json, false);
}
function SendPaymentRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    customerEmail: json["customerEmail"] == null ? void 0 : json["customerEmail"],
    customerName: json["customerName"] == null ? void 0 : json["customerName"],
    total: json["total"],
    reservationRef: json["reservationRef"] == null ? void 0 : json["reservationRef"],
    paymentRef: json["paymentRef"] == null ? void 0 : json["paymentRef"],
    region: JucyCountryCodeFromJSON(json["region"]),
    disableMerchantFee: json["disableMerchantFee"] == null ? void 0 : json["disableMerchantFee"],
    gateway: json["gateway"] == null ? void 0 : json["gateway"],
    brand: json["brand"] == null ? void 0 : json["brand"]
  };
}
function SendPaymentRequestToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    customerEmail: value["customerEmail"],
    customerName: value["customerName"],
    total: value["total"],
    reservationRef: value["reservationRef"],
    paymentRef: value["paymentRef"],
    region: JucyCountryCodeToJSON(value["region"]),
    disableMerchantFee: value["disableMerchantFee"],
    gateway: value["gateway"],
    brand: value["brand"]
  };
}

// src/rentals-api-v3/models/ShuttleImage.ts
function instanceOfShuttleImage(value) {
  return true;
}
function ShuttleImageFromJSON(json) {
  return ShuttleImageFromJSONTyped(json, false);
}
function ShuttleImageFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    small: json["small"] == null ? void 0 : json["small"],
    medium: json["medium"] == null ? void 0 : json["medium"],
    thumbnail: json["thumbnail"] == null ? void 0 : json["thumbnail"],
    main: json["main"] == null ? void 0 : json["main"]
  };
}
function ShuttleImageToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    small: value["small"],
    medium: value["medium"],
    thumbnail: value["thumbnail"],
    main: value["main"]
  };
}

// src/rentals-api-v3/models/Shuttle.ts
function instanceOfShuttle(value) {
  if (!("name" in value) || value["name"] === void 0) return false;
  if (!("code" in value) || value["code"] === void 0) return false;
  if (!("meetingLocation" in value) || value["meetingLocation"] === void 0) return false;
  if (!("branchCode" in value) || value["branchCode"] === void 0) return false;
  if (!("timeZone" in value) || value["timeZone"] === void 0) return false;
  return true;
}
function ShuttleFromJSON(json) {
  return ShuttleFromJSONTyped(json, false);
}
function ShuttleFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
    code: json["code"],
    image: json["image"] == null ? void 0 : ShuttleImageFromJSON(json["image"]),
    meetingLocation: MapMarkerFromJSON(json["meetingLocation"]),
    branchCode: json["branchCode"],
    timeZone: json["timeZone"]
  };
}
function ShuttleToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    name: value["name"],
    code: value["code"],
    image: ShuttleImageToJSON(value["image"]),
    meetingLocation: MapMarkerToJSON(value["meetingLocation"]),
    branchCode: value["branchCode"],
    timeZone: value["timeZone"]
  };
}

// src/rentals-api-v3/models/SiteAddress1.ts
function instanceOfSiteAddress1(value) {
  if (!("name" in value) || value["name"] === void 0) return false;
  if (!("line1" in value) || value["line1"] === void 0) return false;
  if (!("city" in value) || value["city"] === void 0) return false;
  if (!("postCode" in value) || value["postCode"] === void 0) return false;
  if (!("country" in value) || value["country"] === void 0) return false;
  return true;
}
function SiteAddress1FromJSON(json) {
  return SiteAddress1FromJSONTyped(json, false);
}
function SiteAddress1FromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
    line1: json["line1"],
    line2: json["line2"] == null ? void 0 : json["line2"],
    line3: json["line3"] == null ? void 0 : json["line3"],
    latitude: json["latitude"] == null ? void 0 : json["latitude"],
    longitude: json["longitude"] == null ? void 0 : json["longitude"],
    state: json["state"] == null ? void 0 : json["state"],
    city: json["city"],
    postCode: json["postCode"],
    county: json["county"] == null ? void 0 : json["county"],
    country: json["country"]
  };
}
function SiteAddress1ToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    name: value["name"],
    line1: value["line1"],
    line2: value["line2"],
    line3: value["line3"],
    latitude: value["latitude"],
    longitude: value["longitude"],
    state: value["state"],
    city: value["city"],
    postCode: value["postCode"],
    county: value["county"],
    country: value["country"]
  };
}

// src/rentals-api-v3/models/SiteServiceTime.ts
function instanceOfSiteServiceTime(value) {
  if (!("pickUp" in value) || value["pickUp"] === void 0) return false;
  if (!("dropOff" in value) || value["dropOff"] === void 0) return false;
  return true;
}
function SiteServiceTimeFromJSON(json) {
  return SiteServiceTimeFromJSONTyped(json, false);
}
function SiteServiceTimeFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    pickUp: json["pickUp"],
    dropOff: json["dropOff"]
  };
}
function SiteServiceTimeToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    pickUp: value["pickUp"],
    dropOff: value["dropOff"]
  };
}

// src/rentals-api-v3/models/SiteDefaultTimes.ts
function instanceOfSiteDefaultTimes(value) {
  if (!("sunday" in value) || value["sunday"] === void 0) return false;
  if (!("monday" in value) || value["monday"] === void 0) return false;
  if (!("tuesday" in value) || value["tuesday"] === void 0) return false;
  if (!("wednesday" in value) || value["wednesday"] === void 0) return false;
  if (!("thursday" in value) || value["thursday"] === void 0) return false;
  if (!("friday" in value) || value["friday"] === void 0) return false;
  if (!("saturday" in value) || value["saturday"] === void 0) return false;
  return true;
}
function SiteDefaultTimesFromJSON(json) {
  return SiteDefaultTimesFromJSONTyped(json, false);
}
function SiteDefaultTimesFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    sunday: SiteServiceTimeFromJSON(json["sunday"]),
    monday: SiteServiceTimeFromJSON(json["monday"]),
    tuesday: SiteServiceTimeFromJSON(json["tuesday"]),
    wednesday: SiteServiceTimeFromJSON(json["wednesday"]),
    thursday: SiteServiceTimeFromJSON(json["thursday"]),
    friday: SiteServiceTimeFromJSON(json["friday"]),
    saturday: SiteServiceTimeFromJSON(json["saturday"])
  };
}
function SiteDefaultTimesToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    sunday: SiteServiceTimeToJSON(value["sunday"]),
    monday: SiteServiceTimeToJSON(value["monday"]),
    tuesday: SiteServiceTimeToJSON(value["tuesday"]),
    wednesday: SiteServiceTimeToJSON(value["wednesday"]),
    thursday: SiteServiceTimeToJSON(value["thursday"]),
    friday: SiteServiceTimeToJSON(value["friday"]),
    saturday: SiteServiceTimeToJSON(value["saturday"])
  };
}

// src/rentals-api-v3/models/SiteHoliday.ts
function instanceOfSiteHoliday(value) {
  if (!("name" in value) || value["name"] === void 0) return false;
  if (!("startDateTime" in value) || value["startDateTime"] === void 0) return false;
  if (!("endDateTime" in value) || value["endDateTime"] === void 0) return false;
  return true;
}
function SiteHolidayFromJSON(json) {
  return SiteHolidayFromJSONTyped(json, false);
}
function SiteHolidayFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
    startDateTime: stringToDate(json["startDateTime"]),
    endDateTime: stringToDate(json["endDateTime"]),
    dow: json["dow"] == null ? void 0 : json["dow"]
  };
}
function SiteHolidayToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    name: value["name"],
    startDateTime: dateToString(value["startDateTime"]),
    endDateTime: dateToString(value["endDateTime"]),
    dow: value["dow"]
  };
}

// src/rentals-api-v3/models/SiteOfficeTime.ts
function instanceOfSiteOfficeTime(value) {
  if (!("open" in value) || value["open"] === void 0) return false;
  if (!("close" in value) || value["close"] === void 0) return false;
  return true;
}
function SiteOfficeTimeFromJSON(json) {
  return SiteOfficeTimeFromJSONTyped(json, false);
}
function SiteOfficeTimeFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    open: json["open"],
    close: json["close"]
  };
}
function SiteOfficeTimeToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    open: value["open"],
    close: value["close"]
  };
}

// src/rentals-api-v3/models/SiteSettingsServiceHours.ts
function instanceOfSiteSettingsServiceHours(value) {
  if (!("sunday" in value) || value["sunday"] === void 0) return false;
  if (!("monday" in value) || value["monday"] === void 0) return false;
  if (!("tuesday" in value) || value["tuesday"] === void 0) return false;
  if (!("wednesday" in value) || value["wednesday"] === void 0) return false;
  if (!("thursday" in value) || value["thursday"] === void 0) return false;
  if (!("friday" in value) || value["friday"] === void 0) return false;
  if (!("saturday" in value) || value["saturday"] === void 0) return false;
  return true;
}
function SiteSettingsServiceHoursFromJSON(json) {
  return SiteSettingsServiceHoursFromJSONTyped(json, false);
}
function SiteSettingsServiceHoursFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    sunday: SiteOfficeTimeFromJSON(json["sunday"]),
    monday: SiteOfficeTimeFromJSON(json["monday"]),
    tuesday: SiteOfficeTimeFromJSON(json["tuesday"]),
    wednesday: SiteOfficeTimeFromJSON(json["wednesday"]),
    thursday: SiteOfficeTimeFromJSON(json["thursday"]),
    friday: SiteOfficeTimeFromJSON(json["friday"]),
    saturday: SiteOfficeTimeFromJSON(json["saturday"])
  };
}
function SiteSettingsServiceHoursToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    sunday: SiteOfficeTimeToJSON(value["sunday"]),
    monday: SiteOfficeTimeToJSON(value["monday"]),
    tuesday: SiteOfficeTimeToJSON(value["tuesday"]),
    wednesday: SiteOfficeTimeToJSON(value["wednesday"]),
    thursday: SiteOfficeTimeToJSON(value["thursday"]),
    friday: SiteOfficeTimeToJSON(value["friday"]),
    saturday: SiteOfficeTimeToJSON(value["saturday"])
  };
}

// src/rentals-api-v3/models/SiteSettings.ts
function instanceOfSiteSettings(value) {
  if (!("fleetTypeId" in value) || value["fleetTypeId"] === void 0) return false;
  if (!("fleetTypeName" in value) || value["fleetTypeName"] === void 0) return false;
  if (!("fleetTypeSlug" in value) || value["fleetTypeSlug"] === void 0) return false;
  if (!("serviceHours" in value) || value["serviceHours"] === void 0) return false;
  if (!("isAfterHoursPickUpAvailable" in value) || value["isAfterHoursPickUpAvailable"] === void 0) return false;
  if (!("isAfterHoursDropOffAvailable" in value) || value["isAfterHoursDropOffAvailable"] === void 0) return false;
  return true;
}
function SiteSettingsFromJSON(json) {
  return SiteSettingsFromJSONTyped(json, false);
}
function SiteSettingsFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    fleetTypeId: json["fleetTypeId"],
    fleetTypeName: json["fleetTypeName"],
    fleetTypeSlug: json["fleetTypeSlug"],
    serviceHours: SiteSettingsServiceHoursFromJSON(json["serviceHours"]),
    isAfterHoursPickUpAvailable: json["isAfterHoursPickUpAvailable"],
    isAfterHoursDropOffAvailable: json["isAfterHoursDropOffAvailable"]
  };
}
function SiteSettingsToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    fleetTypeId: value["fleetTypeId"],
    fleetTypeName: value["fleetTypeName"],
    fleetTypeSlug: value["fleetTypeSlug"],
    serviceHours: SiteSettingsServiceHoursToJSON(value["serviceHours"]),
    isAfterHoursPickUpAvailable: value["isAfterHoursPickUpAvailable"],
    isAfterHoursDropOffAvailable: value["isAfterHoursDropOffAvailable"]
  };
}

// src/rentals-api-v3/models/Site.ts
function instanceOfSite(value) {
  if (!("id" in value) || value["id"] === void 0) return false;
  if (!("name" in value) || value["name"] === void 0) return false;
  if (!("siteCode" in value) || value["siteCode"] === void 0) return false;
  if (!("geoLocation" in value) || value["geoLocation"] === void 0) return false;
  if (!("domesticPickUp" in value) || value["domesticPickUp"] === void 0) return false;
  if (!("internationalPickUp" in value) || value["internationalPickUp"] === void 0) return false;
  if (!("address1" in value) || value["address1"] === void 0) return false;
  if (!("timeZone" in value) || value["timeZone"] === void 0) return false;
  if (!("country" in value) || value["country"] === void 0) return false;
  if (!("countryCode" in value) || value["countryCode"] === void 0) return false;
  if (!("minAges" in value) || value["minAges"] === void 0) return false;
  if (!("siteSettings" in value) || value["siteSettings"] === void 0) return false;
  if (!("holidays" in value) || value["holidays"] === void 0) return false;
  if (!("defaultTimes" in value) || value["defaultTimes"] === void 0) return false;
  if (!("businessUnit" in value) || value["businessUnit"] === void 0) return false;
  return true;
}
function SiteFromJSON(json) {
  return SiteFromJSONTyped(json, false);
}
function SiteFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
    siteCode: json["siteCode"],
    geoLocation: MapMarkerFromJSON(json["geoLocation"]),
    domesticPickUp: json["domesticPickUp"],
    internationalPickUp: json["internationalPickUp"],
    directionsLink: json["directionsLink"] == null ? void 0 : json["directionsLink"],
    address1: SiteAddress1FromJSON(json["address1"]),
    phone: json["phone"] == null ? void 0 : json["phone"],
    reservationsPhone: json["reservationsPhone"] == null ? void 0 : json["reservationsPhone"],
    timeZone: json["timeZone"],
    country: json["country"],
    countryCode: JucyCountryCodeFromJSON(json["countryCode"]),
    minAges: json["minAges"],
    siteSettings: json["siteSettings"].map(SiteSettingsFromJSON),
    holidays: json["holidays"].map(SiteHolidayFromJSON),
    defaultTimes: SiteDefaultTimesFromJSON(json["defaultTimes"]),
    businessUnit: json["businessUnit"]
  };
}
function SiteToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    id: value["id"],
    name: value["name"],
    siteCode: value["siteCode"],
    geoLocation: MapMarkerToJSON(value["geoLocation"]),
    domesticPickUp: value["domesticPickUp"],
    internationalPickUp: value["internationalPickUp"],
    directionsLink: value["directionsLink"],
    address1: SiteAddress1ToJSON(value["address1"]),
    phone: value["phone"],
    reservationsPhone: value["reservationsPhone"],
    timeZone: value["timeZone"],
    country: value["country"],
    countryCode: JucyCountryCodeToJSON(value["countryCode"]),
    minAges: value["minAges"],
    siteSettings: value["siteSettings"].map(SiteSettingsToJSON),
    holidays: value["holidays"].map(SiteHolidayToJSON),
    defaultTimes: SiteDefaultTimesToJSON(value["defaultTimes"]),
    businessUnit: value["businessUnit"]
  };
}

// src/rentals-api-v3/models/SubscribeRequest.ts
function instanceOfSubscribeRequest(value) {
  if (!("list" in value) || value["list"] === void 0) return false;
  if (!("email" in value) || value["email"] === void 0) return false;
  if (!("firstName" in value) || value["firstName"] === void 0) return false;
  if (!("lastName" in value) || value["lastName"] === void 0) return false;
  return true;
}
function SubscribeRequestFromJSON(json) {
  return SubscribeRequestFromJSONTyped(json, false);
}
function SubscribeRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    list: JucyCountryCodeFromJSON(json["list"]),
    email: json["email"],
    firstName: json["firstName"],
    lastName: json["lastName"],
    tags: json["tags"] == null ? void 0 : json["tags"]
  };
}
function SubscribeRequestToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    list: JucyCountryCodeToJSON(value["list"]),
    email: value["email"],
    firstName: value["firstName"],
    lastName: value["lastName"],
    tags: value["tags"]
  };
}

// src/rentals-api-v3/models/SubscribeResponse.ts
function instanceOfSubscribeResponse(value) {
  if (!("status" in value) || value["status"] === void 0) return false;
  return true;
}
function SubscribeResponseFromJSON(json) {
  return SubscribeResponseFromJSONTyped(json, false);
}
function SubscribeResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    status: json["status"],
    message: json["message"] == null ? void 0 : json["message"]
  };
}
function SubscribeResponseToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    status: value["status"],
    message: value["message"]
  };
}

// src/rentals-api-v3/models/TripDetails.ts
function instanceOfTripDetails(value) {
  if (!("pickUpLocation" in value) || value["pickUpLocation"] === void 0) return false;
  if (!("dropOffLocation" in value) || value["dropOffLocation"] === void 0) return false;
  if (!("pickUpDate" in value) || value["pickUpDate"] === void 0) return false;
  if (!("dropOffDate" in value) || value["dropOffDate"] === void 0) return false;
  if (!("rentalDays" in value) || value["rentalDays"] === void 0) return false;
  if (!("totalPrice" in value) || value["totalPrice"] === void 0) return false;
  if (!("fleetCategory" in value) || value["fleetCategory"] === void 0) return false;
  if (!("secondaryProducts" in value) || value["secondaryProducts"] === void 0) return false;
  if (!("insuranceProducts" in value) || value["insuranceProducts"] === void 0) return false;
  return true;
}
function TripDetailsFromJSON(json) {
  return TripDetailsFromJSONTyped(json, false);
}
function TripDetailsFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    pickUpLocation: json["pickUpLocation"],
    dropOffLocation: json["dropOffLocation"],
    pickUpDate: stringToDate(json["pickUpDate"]),
    dropOffDate: stringToDate(json["dropOffDate"]),
    rentalDays: json["rentalDays"],
    totalPrice: CurrencyValueFromJSON(json["totalPrice"]),
    lines: json["lines"] == null ? void 0 : json["lines"].map(ProductLineFromJSON),
    fleetCategory: FleetCategoryFromJSON(json["fleetCategory"]),
    secondaryProducts: json["secondaryProducts"].map(SecondaryProductGroupFromJSON),
    insuranceProducts: InsuranceProductGroupFromJSON(json["insuranceProducts"]),
    bundles: json["bundles"] == null ? void 0 : json["bundles"].map(ProductBundleFromJSON)
  };
}
function TripDetailsToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    pickUpLocation: value["pickUpLocation"],
    dropOffLocation: value["dropOffLocation"],
    pickUpDate: dateToString(value["pickUpDate"]),
    dropOffDate: dateToString(value["dropOffDate"]),
    rentalDays: value["rentalDays"],
    totalPrice: CurrencyValueToJSON(value["totalPrice"]),
    lines: value["lines"] == null ? void 0 : value["lines"].map(ProductLineToJSON),
    fleetCategory: FleetCategoryToJSON(value["fleetCategory"]),
    secondaryProducts: value["secondaryProducts"].map(SecondaryProductGroupToJSON),
    insuranceProducts: InsuranceProductGroupToJSON(value["insuranceProducts"]),
    bundles: value["bundles"] == null ? void 0 : value["bundles"].map(ProductBundleToJSON)
  };
}

// src/rentals-api-v3/models/TripInfoRequestBody.ts
function instanceOfTripInfoRequestBody(value) {
  if (!("pickUpLocation" in value) || value["pickUpLocation"] === void 0) return false;
  if (!("dropOffLocation" in value) || value["dropOffLocation"] === void 0) return false;
  if (!("pickUpDate" in value) || value["pickUpDate"] === void 0) return false;
  if (!("dropOffDate" in value) || value["dropOffDate"] === void 0) return false;
  if (!("fleetCategory" in value) || value["fleetCategory"] === void 0) return false;
  return true;
}
function TripInfoRequestBodyFromJSON(json) {
  return TripInfoRequestBodyFromJSONTyped(json, false);
}
function TripInfoRequestBodyFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    pickUpLocation: json["pickUpLocation"],
    dropOffLocation: json["dropOffLocation"],
    pickUpDate: json["pickUpDate"],
    dropOffDate: json["dropOffDate"],
    fleetCategory: json["fleetCategory"],
    driverAge: json["driverAge"] == null ? void 0 : json["driverAge"],
    numberOfPeople: json["numberOfPeople"] == null ? void 0 : json["numberOfPeople"],
    campaignCode: json["campaignCode"] == null ? void 0 : json["campaignCode"],
    pascal: json["pascal"] == null ? void 0 : json["pascal"]
  };
}
function TripInfoRequestBodyToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    pickUpLocation: value["pickUpLocation"],
    dropOffLocation: value["dropOffLocation"],
    pickUpDate: value["pickUpDate"],
    dropOffDate: value["dropOffDate"],
    fleetCategory: value["fleetCategory"],
    driverAge: value["driverAge"],
    numberOfPeople: value["numberOfPeople"],
    campaignCode: value["campaignCode"],
    pascal: value["pascal"]
  };
}

// src/rentals-api-v3/models/UpdateFlightDetailsRequestAdditionalDriversInner.ts
function instanceOfUpdateFlightDetailsRequestAdditionalDriversInner(value) {
  if (!("firstName" in value) || value["firstName"] === void 0) return false;
  if (!("lastName" in value) || value["lastName"] === void 0) return false;
  if (!("licenseNumber" in value) || value["licenseNumber"] === void 0) return false;
  if (!("licenseCountry" in value) || value["licenseCountry"] === void 0) return false;
  return true;
}
function UpdateFlightDetailsRequestAdditionalDriversInnerFromJSON(json) {
  return UpdateFlightDetailsRequestAdditionalDriversInnerFromJSONTyped(json, false);
}
function UpdateFlightDetailsRequestAdditionalDriversInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    additionalDriverId: json["additionalDriverId"] == null ? void 0 : json["additionalDriverId"],
    isDelete: json["isDelete"] == null ? void 0 : json["isDelete"],
    firstName: json["firstName"],
    lastName: json["lastName"],
    email: json["email"] == null ? void 0 : json["email"],
    licenseNumber: json["licenseNumber"],
    licenseCountry: json["licenseCountry"],
    licenseExpiry: json["licenseExpiry"] == null ? void 0 : json["licenseExpiry"],
    licenseFrontImage: json["licenseFrontImage"] == null ? void 0 : json["licenseFrontImage"],
    licenseBackImage: json["licenseBackImage"] == null ? void 0 : json["licenseBackImage"]
  };
}
function UpdateFlightDetailsRequestAdditionalDriversInnerToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    additionalDriverId: value["additionalDriverId"],
    isDelete: value["isDelete"],
    firstName: value["firstName"],
    lastName: value["lastName"],
    email: value["email"],
    licenseNumber: value["licenseNumber"],
    licenseCountry: value["licenseCountry"],
    licenseExpiry: value["licenseExpiry"],
    licenseFrontImage: value["licenseFrontImage"],
    licenseBackImage: value["licenseBackImage"]
  };
}

// src/rentals-api-v3/models/UpdateFlightDetailsRequestProductAndQuantityMapInner.ts
function instanceOfUpdateFlightDetailsRequestProductAndQuantityMapInner(value) {
  if (!("code" in value) || value["code"] === void 0) return false;
  if (!("qty" in value) || value["qty"] === void 0) return false;
  return true;
}
function UpdateFlightDetailsRequestProductAndQuantityMapInnerFromJSON(json) {
  return UpdateFlightDetailsRequestProductAndQuantityMapInnerFromJSONTyped(json, false);
}
function UpdateFlightDetailsRequestProductAndQuantityMapInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    code: json["code"],
    qty: json["qty"]
  };
}
function UpdateFlightDetailsRequestProductAndQuantityMapInnerToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    code: value["code"],
    qty: value["qty"]
  };
}

// src/rentals-api-v3/models/UpdateFlightDetailsRequest.ts
function instanceOfUpdateFlightDetailsRequest(value) {
  if (!("reservationReference" in value) || value["reservationReference"] === void 0) return false;
  if (!("departureShuttleRequired" in value) || value["departureShuttleRequired"] === void 0) return false;
  if (!("arrivalShuttleRequired" in value) || value["arrivalShuttleRequired"] === void 0) return false;
  if (!("numberOfPeople" in value) || value["numberOfPeople"] === void 0) return false;
  if (!("firstName" in value) || value["firstName"] === void 0) return false;
  if (!("lastName" in value) || value["lastName"] === void 0) return false;
  if (!("email" in value) || value["email"] === void 0) return false;
  if (!("mobile" in value) || value["mobile"] === void 0) return false;
  return true;
}
function UpdateFlightDetailsRequestFromJSON(json) {
  return UpdateFlightDetailsRequestFromJSONTyped(json, false);
}
function UpdateFlightDetailsRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    reservationReference: json["reservationReference"],
    departureFlightNumber: json["departureFlightNumber"] == null ? void 0 : json["departureFlightNumber"],
    departureShuttleRequired: json["departureShuttleRequired"],
    arrivalFlightNumber: json["arrivalFlightNumber"] == null ? void 0 : json["arrivalFlightNumber"],
    arrivalShuttleRequired: json["arrivalShuttleRequired"],
    numberOfPeople: json["numberOfPeople"],
    country: json["country"] == null ? void 0 : json["country"],
    firstName: json["firstName"],
    lastName: json["lastName"],
    email: json["email"],
    mobile: json["mobile"],
    dateOfBirth: json["dateOfBirth"] == null ? void 0 : json["dateOfBirth"],
    licenseNumber: json["licenseNumber"] == null ? void 0 : json["licenseNumber"],
    licenseCountry: json["licenseCountry"] == null ? void 0 : json["licenseCountry"],
    licenseExpiry: json["licenseExpiry"] == null ? void 0 : json["licenseExpiry"],
    agentVoucherReference: json["agentVoucherReference"] == null ? void 0 : json["agentVoucherReference"],
    productAndQuantityMap: json["productAndQuantityMap"] == null ? void 0 : json["productAndQuantityMap"].map(UpdateFlightDetailsRequestProductAndQuantityMapInnerFromJSON),
    deposit: json["deposit"] == null ? void 0 : json["deposit"],
    additionalDrivers: json["additionalDrivers"] == null ? void 0 : json["additionalDrivers"].map(UpdateFlightDetailsRequestAdditionalDriversInnerFromJSON),
    licenseFrontImage: json["licenseFrontImage"] == null ? void 0 : json["licenseFrontImage"],
    licenseBackImage: json["licenseBackImage"] == null ? void 0 : json["licenseBackImage"]
  };
}
function UpdateFlightDetailsRequestToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    reservationReference: value["reservationReference"],
    departureFlightNumber: value["departureFlightNumber"],
    departureShuttleRequired: value["departureShuttleRequired"],
    arrivalFlightNumber: value["arrivalFlightNumber"],
    arrivalShuttleRequired: value["arrivalShuttleRequired"],
    numberOfPeople: value["numberOfPeople"],
    country: value["country"],
    firstName: value["firstName"],
    lastName: value["lastName"],
    email: value["email"],
    mobile: value["mobile"],
    dateOfBirth: value["dateOfBirth"],
    licenseNumber: value["licenseNumber"],
    licenseCountry: value["licenseCountry"],
    licenseExpiry: value["licenseExpiry"],
    agentVoucherReference: value["agentVoucherReference"],
    productAndQuantityMap: value["productAndQuantityMap"] == null ? void 0 : value["productAndQuantityMap"].map(UpdateFlightDetailsRequestProductAndQuantityMapInnerToJSON),
    deposit: value["deposit"],
    additionalDrivers: value["additionalDrivers"] == null ? void 0 : value["additionalDrivers"].map(UpdateFlightDetailsRequestAdditionalDriversInnerToJSON),
    licenseFrontImage: value["licenseFrontImage"],
    licenseBackImage: value["licenseBackImage"]
  };
}

// src/rentals-api-v3/models/UpdateReservationRequest.ts
function instanceOfUpdateReservationRequest(value) {
  if (!("pickUpLocation" in value) || value["pickUpLocation"] === void 0) return false;
  if (!("dropOffLocation" in value) || value["dropOffLocation"] === void 0) return false;
  if (!("pickUpDate" in value) || value["pickUpDate"] === void 0) return false;
  if (!("dropOffDate" in value) || value["dropOffDate"] === void 0) return false;
  if (!("fleetCategory" in value) || value["fleetCategory"] === void 0) return false;
  if (!("insurance" in value) || value["insurance"] === void 0) return false;
  if (!("hirerDetails" in value) || value["hirerDetails"] === void 0) return false;
  return true;
}
function UpdateReservationRequestFromJSON(json) {
  return UpdateReservationRequestFromJSONTyped(json, false);
}
function UpdateReservationRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    pickUpLocation: json["pickUpLocation"],
    dropOffLocation: json["dropOffLocation"],
    pickUpDate: json["pickUpDate"],
    dropOffDate: json["dropOffDate"],
    fleetCategory: json["fleetCategory"],
    driverAge: json["driverAge"] == null ? void 0 : json["driverAge"],
    numberOfPeople: json["numberOfPeople"] == null ? void 0 : json["numberOfPeople"],
    campaignCode: json["campaignCode"] == null ? void 0 : json["campaignCode"],
    pascal: json["pascal"] == null ? void 0 : json["pascal"],
    insurance: json["insurance"],
    secondaryProducts: json["secondaryProducts"] == null ? void 0 : json["secondaryProducts"],
    hirerDetails: HirerDetailsSummaryFromJSON(json["hirerDetails"]),
    voucherReference: json["voucherReference"] == null ? void 0 : json["voucherReference"],
    gateway: json["gateway"] == null ? void 0 : json["gateway"],
    payment: json["payment"] == null ? void 0 : json["payment"]
  };
}
function UpdateReservationRequestToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    pickUpLocation: value["pickUpLocation"],
    dropOffLocation: value["dropOffLocation"],
    pickUpDate: value["pickUpDate"],
    dropOffDate: value["dropOffDate"],
    fleetCategory: value["fleetCategory"],
    driverAge: value["driverAge"],
    numberOfPeople: value["numberOfPeople"],
    campaignCode: value["campaignCode"],
    pascal: value["pascal"],
    insurance: value["insurance"],
    secondaryProducts: value["secondaryProducts"],
    hirerDetails: HirerDetailsSummaryToJSON(value["hirerDetails"]),
    voucherReference: value["voucherReference"],
    gateway: value["gateway"],
    payment: value["payment"]
  };
}

// src/rentals-api-v3/models/UpdateReservationValidationStatus.ts
var UpdateReservationValidationStatus = {
  Amendment: "amendment",
  Edit: "edit",
  Invalid: "invalid"
};
function instanceOfUpdateReservationValidationStatus(value) {
  for (const key in UpdateReservationValidationStatus) {
    if (Object.prototype.hasOwnProperty.call(UpdateReservationValidationStatus, key)) {
      if (UpdateReservationValidationStatus[key] === value) {
        return true;
      }
    }
  }
  return false;
}
function UpdateReservationValidationStatusFromJSON(json) {
  return UpdateReservationValidationStatusFromJSONTyped(json, false);
}
function UpdateReservationValidationStatusFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function UpdateReservationValidationStatusToJSON(value) {
  return value;
}

// src/rentals-api-v3/models/V2FleetTypeLocationsAvailableAtInner.ts
function instanceOfV2FleetTypeLocationsAvailableAtInner(value) {
  if (!("id" in value) || value["id"] === void 0) return false;
  if (!("siteCode" in value) || value["siteCode"] === void 0) return false;
  if (!("timezone" in value) || value["timezone"] === void 0) return false;
  if (!("country" in value) || value["country"] === void 0) return false;
  if (!("businessUnit" in value) || value["businessUnit"] === void 0) return false;
  return true;
}
function V2FleetTypeLocationsAvailableAtInnerFromJSON(json) {
  return V2FleetTypeLocationsAvailableAtInnerFromJSONTyped(json, false);
}
function V2FleetTypeLocationsAvailableAtInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    siteCode: json["siteCode"],
    timezone: json["timezone"],
    country: json["country"],
    businessUnit: json["businessUnit"]
  };
}
function V2FleetTypeLocationsAvailableAtInnerToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    id: value["id"],
    siteCode: value["siteCode"],
    timezone: value["timezone"],
    country: value["country"],
    businessUnit: value["businessUnit"]
  };
}

// src/rentals-api-v3/models/V2FleetType.ts
var V2FleetTypeHireDaysTypeEnum = {
  Calendar: "calendar",
  Hourly: "hourly"
};
function instanceOfV2FleetType(value) {
  if (!("id" in value) || value["id"] === void 0) return false;
  if (!("name" in value) || value["name"] === void 0) return false;
  if (!("slug" in value) || value["slug"] === void 0) return false;
  if (!("leadTimeHours" in value) || value["leadTimeHours"] === void 0) return false;
  if (!("depositPercent" in value) || value["depositPercent"] === void 0) return false;
  if (!("minHireDays" in value) || value["minHireDays"] === void 0) return false;
  if (!("minimumDriverAge" in value) || value["minimumDriverAge"] === void 0) return false;
  if (!("locationsAvailableAt" in value) || value["locationsAvailableAt"] === void 0) return false;
  if (!("hireDaysType" in value) || value["hireDaysType"] === void 0) return false;
  return true;
}
function V2FleetTypeFromJSON(json) {
  return V2FleetTypeFromJSONTyped(json, false);
}
function V2FleetTypeFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
    slug: json["slug"],
    leadTimeHours: json["leadTimeHours"],
    depositPercent: json["depositPercent"],
    minHireDays: json["minHireDays"],
    minimumDriverAge: json["minimumDriverAge"],
    locationsAvailableAt: json["locationsAvailableAt"].map(V2FleetTypeLocationsAvailableAtInnerFromJSON),
    hireDaysType: json["hireDaysType"]
  };
}
function V2FleetTypeToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    id: value["id"],
    name: value["name"],
    slug: value["slug"],
    leadTimeHours: value["leadTimeHours"],
    depositPercent: value["depositPercent"],
    minHireDays: value["minHireDays"],
    minimumDriverAge: value["minimumDriverAge"],
    locationsAvailableAt: value["locationsAvailableAt"].map(V2FleetTypeLocationsAvailableAtInnerToJSON),
    hireDaysType: value["hireDaysType"]
  };
}

// src/rentals-api-v3/models/ValidateUpdateResponse.ts
function instanceOfValidateUpdateResponse(value) {
  if (!("status" in value) || value["status"] === void 0) return false;
  if (!("reference" in value) || value["reference"] === void 0) return false;
  return true;
}
function ValidateUpdateResponseFromJSON(json) {
  return ValidateUpdateResponseFromJSONTyped(json, false);
}
function ValidateUpdateResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    updates: json["updates"] == null ? void 0 : TripDetailsFromJSON(json["updates"]),
    message: json["message"] == null ? void 0 : json["message"],
    original: json["original"] == null ? void 0 : BookingFromJSON(json["original"]),
    status: UpdateReservationValidationStatusFromJSON(json["status"]),
    reference: json["reference"],
    bookingNo: json["bookingNo"] == null ? void 0 : json["bookingNo"]
  };
}
function ValidateUpdateResponseToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    updates: TripDetailsToJSON(value["updates"]),
    message: value["message"],
    original: BookingToJSON(value["original"]),
    status: UpdateReservationValidationStatusToJSON(value["status"]),
    reference: value["reference"],
    bookingNo: value["bookingNo"]
  };
}
export {
  AddressFromJSON,
  AddressFromJSONTyped,
  AddressToJSON,
  AfterpayConfigFromJSON,
  AfterpayConfigFromJSONTyped,
  AfterpayConfigToJSON,
  AgentInfoFromJSON,
  AgentInfoFromJSONTyped,
  AgentInfoRequestFromJSON,
  AgentInfoRequestFromJSONTyped,
  AgentInfoRequestToJSON,
  AgentInfoToJSON,
  AgentRatesQueryFromJSON,
  AgentRatesQueryFromJSONTyped,
  AgentRatesQueryToJSON,
  AgentRatesRequestFromJSON,
  AgentRatesRequestFromJSONTyped,
  AgentRatesRequestToJSON,
  AgentRegionSettingsFromJSON,
  AgentRegionSettingsFromJSONTyped,
  AgentRegionSettingsToJSON,
  AgentSettingsFromJSON,
  AgentSettingsFromJSONTyped,
  AgentSettingsToJSON,
  AlternateDatesAvailabilityRequestFromJSON,
  AlternateDatesAvailabilityRequestFromJSONTyped,
  AlternateDatesAvailabilityRequestToJSON,
  AutoPaymentParamFromJSON,
  AutoPaymentParamFromJSONTyped,
  AutoPaymentParamToJSON,
  AutoPaymentRequestFromJSON,
  AutoPaymentRequestFromJSONTyped,
  AutoPaymentRequestToJSON,
  AvailabilitySearchResponseFromJSON,
  AvailabilitySearchResponseFromJSONTyped,
  AvailabilitySearchResponseToJSON,
  AvailabilityType,
  AvailabilityTypeFromJSON,
  AvailabilityTypeFromJSONTyped,
  AvailabilityTypeToJSON,
  BookedWithFromJSON,
  BookedWithFromJSONTyped,
  BookedWithToJSON,
  BookingFromJSON,
  BookingFromJSONTyped,
  BookingLinesInnerCategoryEnum,
  BookingLinesInnerFromJSON,
  BookingLinesInnerFromJSONTyped,
  BookingLinesInnerToJSON,
  BookingOptionsFromJSON,
  BookingOptionsFromJSONTyped,
  BookingOptionsToJSON,
  BookingPaymentInfoFromJSON,
  BookingPaymentInfoFromJSONTyped,
  BookingPaymentInfoToJSON,
  BookingStatus,
  BookingStatusFromJSON,
  BookingStatusFromJSONTyped,
  BookingStatusToJSON,
  BookingSummaryFromJSON,
  BookingSummaryFromJSONTyped,
  BookingSummaryHirerFromJSON,
  BookingSummaryHirerFromJSONTyped,
  BookingSummaryHirerToJSON,
  BookingSummaryQueryFromJSON,
  BookingSummaryQueryFromJSONTyped,
  BookingSummaryQueryStatusEnum,
  BookingSummaryQueryToJSON,
  BookingSummaryResponseFromJSON,
  BookingSummaryResponseFromJSONTyped,
  BookingSummaryResponseToJSON,
  BookingSummaryStatus,
  BookingSummaryStatusFromJSON,
  BookingSummaryStatusFromJSONTyped,
  BookingSummaryStatusToJSON,
  BookingSummaryToJSON,
  BookingToJSON,
  BookingType,
  BookingTypeFromJSON,
  BookingTypeFromJSONTyped,
  BookingTypeToJSON,
  BranchContentFromJSON,
  BranchContentFromJSONTyped,
  BranchContentPagesFromJSON,
  BranchContentPagesFromJSONTyped,
  BranchContentPagesToJSON,
  BranchContentToJSON,
  Brand,
  BrandFromJSON,
  BrandFromJSONTyped,
  BrandToJSON,
  BusinessUnitFromJSON,
  BusinessUnitFromJSONTyped,
  BusinessUnitToJSON,
  CatalogFloorPlanFromJSON,
  CatalogFloorPlanFromJSONTyped,
  CatalogFloorPlanToJSON,
  CatalogItemFromJSON,
  CatalogItemFromJSONTyped,
  CatalogItemPageFromJSON,
  CatalogItemPageFromJSONTyped,
  CatalogItemPageToJSON,
  CatalogItemToJSON,
  CommissionFromJSON,
  CommissionFromJSONTyped,
  CommissionStatus,
  CommissionStatusFromJSON,
  CommissionStatusFromJSONTyped,
  CommissionStatusToJSON,
  CommissionToJSON,
  ConvertQuotePaymentType,
  ConvertQuotePaymentTypeFromJSON,
  ConvertQuotePaymentTypeFromJSONTyped,
  ConvertQuotePaymentTypeToJSON,
  ConvertQuoteResponseFromJSON,
  ConvertQuoteResponseFromJSONTyped,
  ConvertQuoteResponseToJSON,
  CountryDataFromJSON,
  CountryDataFromJSONTyped,
  CountryDataToJSON,
  CreateBookingRequestFromJSON,
  CreateBookingRequestFromJSONTyped,
  CreateBookingRequestToJSON,
  CreateBookingResponseFromJSON,
  CreateBookingResponseFromJSONTyped,
  CreateBookingResponseStatus,
  CreateBookingResponseStatusFromJSON,
  CreateBookingResponseStatusFromJSONTyped,
  CreateBookingResponseStatusToJSON,
  CreateBookingResponseToJSON,
  CurrencyRateResultFromJSON,
  CurrencyRateResultFromJSONTyped,
  CurrencyRateResultToJSON,
  CurrencyValueFromJSON,
  CurrencyValueFromJSONTyped,
  CurrencyValueToJSON,
  DriversLicenceFromJSON,
  DriversLicenceFromJSONTyped,
  DriversLicenceToJSON,
  EmailQuoteRequestFromJSON,
  EmailQuoteRequestFromJSONTyped,
  EmailQuoteRequestToJSON,
  ErrorResponseFromJSON,
  ErrorResponseFromJSONTyped,
  ErrorResponseToJSON,
  ExcessReductionFeatureSchemaBasicFromJSON,
  ExcessReductionFeatureSchemaBasicFromJSONTyped,
  ExcessReductionFeatureSchemaBasicToJSON,
  ExcessReductionFeatureSchemaFromJSON,
  ExcessReductionFeatureSchemaFromJSONTyped,
  ExcessReductionFeatureSchemaToJSON,
  ExcessReductionFeatureType,
  ExcessReductionFeatureTypeFromJSON,
  ExcessReductionFeatureTypeFromJSONTyped,
  ExcessReductionFeatureTypeToJSON,
  ExchangeRatesFromJSON,
  ExchangeRatesFromJSONTyped,
  ExchangeRatesToJSON,
  ExportBookingRequestQueryFromJSON,
  ExportBookingRequestQueryFromJSONTyped,
  ExportBookingRequestQueryToJSON,
  ExportMaintenanceBookingRequestQueryFromJSON,
  ExportMaintenanceBookingRequestQueryFromJSONTyped,
  ExportMaintenanceBookingRequestQueryToJSON,
  ExportMonthlySalesByCategoryRequestQuerySchemaByEnum,
  ExportMonthlySalesByCategoryRequestQuerySchemaFromJSON,
  ExportMonthlySalesByCategoryRequestQuerySchemaFromJSONTyped,
  ExportMonthlySalesByCategoryRequestQuerySchemaToJSON,
  ExportMonthlyUtilisationRequestQuerySchemaFromJSON,
  ExportMonthlyUtilisationRequestQuerySchemaFromJSONTyped,
  ExportMonthlyUtilisationRequestQuerySchemaToJSON,
  ExportVehicleRequestQueryFromJSON,
  ExportVehicleRequestQueryFromJSONTyped,
  ExportVehicleRequestQueryToJSON,
  FeatureItemFromJSON,
  FeatureItemFromJSONTyped,
  FeatureItemToJSON,
  FeatureListFromJSON,
  FeatureListFromJSONTyped,
  FeatureListToJSON,
  FerryAccommodationProductCategoryEnum,
  FerryAccommodationProductFromJSON,
  FerryAccommodationProductFromJSONTyped,
  FerryAccommodationProductToJSON,
  FerryBookingFromJSON,
  FerryBookingFromJSONTyped,
  FerryBookingToJSON,
  FerryCreateBookingRequestFromJSON,
  FerryCreateBookingRequestFromJSONTyped,
  FerryCreateBookingRequestToJSON,
  FerryCreateQuoteRequestFromJSON,
  FerryCreateQuoteRequestFromJSONTyped,
  FerryCreateQuoteRequestToJSON,
  FerryGetBookingResponseFromJSON,
  FerryGetBookingResponseFromJSONTyped,
  FerryGetBookingResponseToJSON,
  FerryGetOptionsQueryStringFromJSON,
  FerryGetOptionsQueryStringFromJSONTyped,
  FerryGetOptionsQueryStringToJSON,
  FerryGetQuoteResponseFromJSON,
  FerryGetQuoteResponseFromJSONTyped,
  FerryGetQuoteResponseToJSON,
  FerryGetRouteRequestFromJSON,
  FerryGetRouteRequestFromJSONTyped,
  FerryGetRouteRequestToJSON,
  FerryGetSailingsRequestAllOfOutboundTripFromJSON,
  FerryGetSailingsRequestAllOfOutboundTripFromJSONTyped,
  FerryGetSailingsRequestAllOfOutboundTripToJSON,
  FerryGetSailingsRequestAllOfPassengersFromJSON,
  FerryGetSailingsRequestAllOfPassengersFromJSONTyped,
  FerryGetSailingsRequestAllOfPassengersToJSON,
  FerryGetSailingsRequestAllOfReturnTripFromJSON,
  FerryGetSailingsRequestAllOfReturnTripFromJSONTyped,
  FerryGetSailingsRequestAllOfReturnTripToJSON,
  FerryGetSailingsRequestFromJSON,
  FerryGetSailingsRequestFromJSONTyped,
  FerryGetSailingsRequestToJSON,
  FerryGetSailingsResponseFromJSON,
  FerryGetSailingsResponseFromJSONTyped,
  FerryGetSailingsResponseToJSON,
  FerryGetStatusRequestQueryFromJSON,
  FerryGetStatusRequestQueryFromJSONTyped,
  FerryGetStatusRequestQueryToJSON,
  FerryGetStatusResponseFromJSON,
  FerryGetStatusResponseFromJSONTyped,
  FerryGetStatusResponseToJSON,
  FerryGetTimetableRequestFromJSON,
  FerryGetTimetableRequestFromJSONTyped,
  FerryGetTimetableRequestToJSON,
  FerryMessageFromJSON,
  FerryMessageFromJSONTyped,
  FerryMessageToJSON,
  FerryOptionsFromJSON,
  FerryOptionsFromJSONTyped,
  FerryOptionsToJSON,
  FerryPassengerCountRequestFromJSON,
  FerryPassengerCountRequestFromJSONTyped,
  FerryPassengerCountRequestToJSON,
  FerryPassengerFromJSON,
  FerryPassengerFromJSONTyped,
  FerryPassengerToJSON,
  FerryPassengerType,
  FerryPassengerTypeEnum,
  FerryPassengerTypeFromJSON,
  FerryPassengerTypeFromJSONTyped,
  FerryPassengerTypeToJSON,
  FerryPortFromJSON,
  FerryPortFromJSONTyped,
  FerryPortToJSON,
  FerryProductLineFromJSON,
  FerryProductLineFromJSONTyped,
  FerryProductLineToJSON,
  FerryRouteFromJSON,
  FerryRouteFromJSONTyped,
  FerryRouteToJSON,
  FerrySailingBookingFromJSON,
  FerrySailingBookingFromJSONTyped,
  FerrySailingBookingToJSON,
  FerrySailingFromJSON,
  FerrySailingFromJSONTyped,
  FerrySailingOrderFromJSON,
  FerrySailingOrderFromJSONTyped,
  FerrySailingOrderToJSON,
  FerrySailingQuoteRequestFromJSON,
  FerrySailingQuoteRequestFromJSONTyped,
  FerrySailingQuoteRequestToJSON,
  FerrySailingToJSON,
  FerrySailingTripAllOfIdFromJSON,
  FerrySailingTripAllOfIdFromJSONTyped,
  FerrySailingTripAllOfIdToJSON,
  FerrySailingTripFromJSON,
  FerrySailingTripFromJSONTyped,
  FerrySailingTripToJSON,
  FerryShipFromJSON,
  FerryShipFromJSONTyped,
  FerryShipToJSON,
  FerryTripDetailsRequestFromJSON,
  FerryTripDetailsRequestFromJSONTyped,
  FerryTripDetailsRequestOutboundTripFromJSON,
  FerryTripDetailsRequestOutboundTripFromJSONTyped,
  FerryTripDetailsRequestOutboundTripToJSON,
  FerryTripDetailsRequestReturnTripFromJSON,
  FerryTripDetailsRequestReturnTripFromJSONTyped,
  FerryTripDetailsRequestReturnTripToJSON,
  FerryTripDetailsRequestToJSON,
  FerryUpdateQuoteRequestFromJSON,
  FerryUpdateQuoteRequestFromJSONTyped,
  FerryUpdateQuoteRequestParamsFromJSON,
  FerryUpdateQuoteRequestParamsFromJSONTyped,
  FerryUpdateQuoteRequestParamsToJSON,
  FerryUpdateQuoteRequestToJSON,
  FindReservationRequestFromJSON,
  FindReservationRequestFromJSONTyped,
  FindReservationRequestToJSON,
  FindReservationResultFromJSON,
  FindReservationResultFromJSONTyped,
  FindReservationResultHirerFromJSON,
  FindReservationResultHirerFromJSONTyped,
  FindReservationResultHirerToJSON,
  FindReservationResultToJSON,
  FleetCategoryAvailabilityEnum,
  FleetCategoryContentFromJSON,
  FleetCategoryContentFromJSONTyped,
  FleetCategoryContentToJSON,
  FleetCategoryFromJSON,
  FleetCategoryFromJSONTyped,
  FleetCategoryToJSON,
  FleetTypeCode,
  FleetTypeCodeFromJSON,
  FleetTypeCodeFromJSONTyped,
  FleetTypeCodeToJSON,
  FleetTypeHireDaysType,
  FleetTypeHireDaysTypeFromJSON,
  FleetTypeHireDaysTypeFromJSONTyped,
  FleetTypeHireDaysTypeToJSON,
  GalleryItemFromJSON,
  GalleryItemFromJSONTyped,
  GalleryItemToJSON,
  GalleryItemType,
  GalleryItemTypeFromJSON,
  GalleryItemTypeFromJSONTyped,
  GalleryItemTypeToJSON,
  GetBranchContentQueryFromJSON,
  GetBranchContentQueryFromJSONTyped,
  GetBranchContentQueryToJSON,
  GetFerryBookingRequestParamsFromJSON,
  GetFerryBookingRequestParamsFromJSONTyped,
  GetFerryBookingRequestParamsToJSON,
  GetFerryBookingsRequestParamsFromJSON,
  GetFerryBookingsRequestParamsFromJSONTyped,
  GetFerryBookingsRequestParamsToJSON,
  GetFerryQuoteRequestParamsFromJSON,
  GetFerryQuoteRequestParamsFromJSONTyped,
  GetFerryQuoteRequestParamsToJSON,
  GetFleetCategoryContentParamsFromJSON,
  GetFleetCategoryContentParamsFromJSONTyped,
  GetFleetCategoryContentParamsToJSON,
  GetFleetTypeBlySlugParamsFromJSON,
  GetFleetTypeBlySlugParamsFromJSONTyped,
  GetFleetTypeBlySlugParamsToJSON,
  GetRewardPointsStatusQueryFromJSON,
  GetRewardPointsStatusQueryFromJSONTyped,
  GetRewardPointsStatusQueryToJSON,
  GetSelfServiceBookingParamsFromJSON,
  GetSelfServiceBookingParamsFromJSONTyped,
  GetSelfServiceBookingParamsToJSON,
  HirePeriodFromJSON,
  HirePeriodFromJSONTyped,
  HirePeriodToJSON,
  HirerDetailsFromJSON,
  HirerDetailsFromJSONTyped,
  HirerDetailsSummaryFromJSON,
  HirerDetailsSummaryFromJSONTyped,
  HirerDetailsSummaryToJSON,
  HirerDetailsToJSON,
  InsuranceProductFromJSON,
  InsuranceProductFromJSONTyped,
  InsuranceProductGroupFromJSON,
  InsuranceProductGroupFromJSONTyped,
  InsuranceProductGroupToJSON,
  InsuranceProductLineCategoryEnum,
  InsuranceProductLineFromJSON,
  InsuranceProductLineFromJSONTyped,
  InsuranceProductLineToJSON,
  InsuranceProductToJSON,
  InsuranceType,
  InsuranceTypeFromJSON,
  InsuranceTypeFromJSONTyped,
  InsuranceTypeToJSON,
  JucyApiStatusSchemaFromJSON,
  JucyApiStatusSchemaFromJSONTyped,
  JucyApiStatusSchemaToJSON,
  JucyAppStatusSchemaFromJSON,
  JucyAppStatusSchemaFromJSONTyped,
  JucyAppStatusSchemaToJSON,
  JucyCountryCode,
  JucyCountryCodeFromJSON,
  JucyCountryCodeFromJSONTyped,
  JucyCountryCodeToJSON,
  LeadTime1FromJSON,
  LeadTime1FromJSONTyped,
  LeadTime1ToJSON,
  LeadTimeFromJSON,
  LeadTimeFromJSONTyped,
  LeadTimeToJSON,
  LinkReservationRequestFromJSON,
  LinkReservationRequestFromJSONTyped,
  LinkReservationRequestToJSON,
  ListBranchContentQueryFromJSON,
  ListBranchContentQueryFromJSONTyped,
  ListBranchContentQueryToJSON,
  ListFleetCategoriesQueryCountryCodeEnum,
  ListFleetCategoriesQueryFromJSON,
  ListFleetCategoriesQueryFromJSONTyped,
  ListFleetCategoriesQueryToJSON,
  ListFleetCategoryContentQueryCountryCodeEnum,
  ListFleetCategoryContentQueryFromJSON,
  ListFleetCategoryContentQueryFromJSONTyped,
  ListFleetCategoryContentQueryToJSON,
  ListShuttlesQueryFromJSON,
  ListShuttlesQueryFromJSONTyped,
  ListShuttlesQueryToJSON,
  LogSelfServiceEventParamsFromJSON,
  LogSelfServiceEventParamsFromJSONTyped,
  LogSelfServiceEventParamsToJSON,
  LogSelfServiceEventRequestFromJSON,
  LogSelfServiceEventRequestFromJSONTyped,
  LogSelfServiceEventRequestToJSON,
  LoyaltyRequestDataFromJSON,
  LoyaltyRequestDataFromJSONTyped,
  LoyaltyRequestDataToJSON,
  MandatoryProductFromJSON,
  MandatoryProductFromJSONTyped,
  MandatoryProductToJSON,
  MapMarkerFromJSON,
  MapMarkerFromJSONTyped,
  MapMarkerToJSON,
  MessageResponseFromJSON,
  MessageResponseFromJSONTyped,
  MessageResponseToJSON,
  MinimumHirePeriodFormat,
  MinimumHirePeriodFormatFromJSON,
  MinimumHirePeriodFormatFromJSONTyped,
  MinimumHirePeriodFormatToJSON,
  MinimumHirePeriodFromJSON,
  MinimumHirePeriodFromJSONTyped,
  MinimumHirePeriodRequestFromJSON,
  MinimumHirePeriodRequestFromJSONTyped,
  MinimumHirePeriodRequestToJSON,
  MinimumHirePeriodToJSON,
  OperatorAvailableAccountsInnerFromJSON,
  OperatorAvailableAccountsInnerFromJSONTyped,
  OperatorAvailableAccountsInnerToJSON,
  OperatorFromJSON,
  OperatorFromJSONTyped,
  OperatorToJSON,
  PaymentConfigFromJSON,
  PaymentConfigFromJSONTyped,
  PaymentConfigToJSON,
  ProductBundleFromJSON,
  ProductBundleFromJSONTyped,
  ProductBundleToJSON,
  ProductFromJSON,
  ProductFromJSONTyped,
  ProductGroupFromJSON,
  ProductGroupFromJSONTyped,
  ProductGroupToJSON,
  ProductItemFromJSON,
  ProductItemFromJSONTyped,
  ProductItemToJSON,
  ProductLineFromJSON,
  ProductLineFromJSONTyped,
  ProductLineToJSON,
  ProductToJSON,
  QuoteAvailability,
  QuoteAvailabilityFromJSON,
  QuoteAvailabilityFromJSONTyped,
  QuoteAvailabilityToJSON,
  QuoteStatus,
  QuoteStatusFromJSON,
  QuoteStatusFromJSONTyped,
  QuoteStatusToJSON,
  RentalCatalogQueryFromJSON,
  RentalCatalogQueryFromJSONTyped,
  RentalCatalogQueryToJSON,
  RentalCatalogResponseFromJSON,
  RentalCatalogResponseFromJSONTyped,
  RentalCatalogResponseToJSON,
  ReservationRefParamsFromJSON,
  ReservationRefParamsFromJSONTyped,
  ReservationRefParamsToJSON,
  ReservationRewardPointsStatusFromJSON,
  ReservationRewardPointsStatusFromJSONTyped,
  ReservationRewardPointsStatusToJSON,
  RewardPointsConfigFromJSON,
  RewardPointsConfigFromJSONTyped,
  RewardPointsConfigToJSON,
  SaveReservationRewardPointsResponseFromJSON,
  SaveReservationRewardPointsResponseFromJSONTyped,
  SaveReservationRewardPointsResponseToJSON,
  SecondaryProductCategoryEnum,
  SecondaryProductFromJSON,
  SecondaryProductFromJSONTyped,
  SecondaryProductGroupFromJSON,
  SecondaryProductGroupFromJSONTyped,
  SecondaryProductGroupToJSON,
  SecondaryProductToJSON,
  SelfServiceBookingFromJSON,
  SelfServiceBookingFromJSONTyped,
  SelfServiceBookingToJSON,
  SelfServiceGetReservationRewardPointsStatusFromJSON,
  SelfServiceGetReservationRewardPointsStatusFromJSONTyped,
  SelfServiceGetReservationRewardPointsStatusToJSON,
  SelfServicePreferenceParamFromJSON,
  SelfServicePreferenceParamFromJSONTyped,
  SelfServicePreferenceParamToJSON,
  SelfServicePreferencesFromJSON,
  SelfServicePreferencesFromJSONTyped,
  SelfServicePreferencesToJSON,
  SelfServicePreferencesTypeEnum,
  SendPaymentRequestFromJSON,
  SendPaymentRequestFromJSONTyped,
  SendPaymentRequestToJSON,
  ShuttleFromJSON,
  ShuttleFromJSONTyped,
  ShuttleImageFromJSON,
  ShuttleImageFromJSONTyped,
  ShuttleImageToJSON,
  ShuttleToJSON,
  SiteAddress1FromJSON,
  SiteAddress1FromJSONTyped,
  SiteAddress1ToJSON,
  SiteDefaultTimesFromJSON,
  SiteDefaultTimesFromJSONTyped,
  SiteDefaultTimesToJSON,
  SiteFromJSON,
  SiteFromJSONTyped,
  SiteHolidayFromJSON,
  SiteHolidayFromJSONTyped,
  SiteHolidayToJSON,
  SiteOfficeTimeFromJSON,
  SiteOfficeTimeFromJSONTyped,
  SiteOfficeTimeToJSON,
  SiteServiceTimeFromJSON,
  SiteServiceTimeFromJSONTyped,
  SiteServiceTimeToJSON,
  SiteSettingsFromJSON,
  SiteSettingsFromJSONTyped,
  SiteSettingsServiceHoursFromJSON,
  SiteSettingsServiceHoursFromJSONTyped,
  SiteSettingsServiceHoursToJSON,
  SiteSettingsToJSON,
  SiteToJSON,
  SubscribeRequestFromJSON,
  SubscribeRequestFromJSONTyped,
  SubscribeRequestToJSON,
  SubscribeResponseFromJSON,
  SubscribeResponseFromJSONTyped,
  SubscribeResponseToJSON,
  TripDetailsFromJSON,
  TripDetailsFromJSONTyped,
  TripDetailsToJSON,
  TripInfoRequestBodyFromJSON,
  TripInfoRequestBodyFromJSONTyped,
  TripInfoRequestBodyToJSON,
  UpdateFlightDetailsRequestAdditionalDriversInnerFromJSON,
  UpdateFlightDetailsRequestAdditionalDriversInnerFromJSONTyped,
  UpdateFlightDetailsRequestAdditionalDriversInnerToJSON,
  UpdateFlightDetailsRequestFromJSON,
  UpdateFlightDetailsRequestFromJSONTyped,
  UpdateFlightDetailsRequestProductAndQuantityMapInnerFromJSON,
  UpdateFlightDetailsRequestProductAndQuantityMapInnerFromJSONTyped,
  UpdateFlightDetailsRequestProductAndQuantityMapInnerToJSON,
  UpdateFlightDetailsRequestToJSON,
  UpdateReservationRequestFromJSON,
  UpdateReservationRequestFromJSONTyped,
  UpdateReservationRequestToJSON,
  UpdateReservationValidationStatus,
  UpdateReservationValidationStatusFromJSON,
  UpdateReservationValidationStatusFromJSONTyped,
  UpdateReservationValidationStatusToJSON,
  V2FleetTypeFromJSON,
  V2FleetTypeFromJSONTyped,
  V2FleetTypeHireDaysTypeEnum,
  V2FleetTypeLocationsAvailableAtInnerFromJSON,
  V2FleetTypeLocationsAvailableAtInnerFromJSONTyped,
  V2FleetTypeLocationsAvailableAtInnerToJSON,
  V2FleetTypeToJSON,
  ValidateUpdateResponseFromJSON,
  ValidateUpdateResponseFromJSONTyped,
  ValidateUpdateResponseToJSON,
  VideoChapterFromJSON,
  VideoChapterFromJSONTyped,
  VideoChapterToJSON,
  VideoContentFromJSON,
  VideoContentFromJSONTyped,
  VideoContentToJSON,
  instanceOfAddress,
  instanceOfAfterpayConfig,
  instanceOfAgentInfo,
  instanceOfAgentInfoRequest,
  instanceOfAgentRatesQuery,
  instanceOfAgentRatesRequest,
  instanceOfAgentRegionSettings,
  instanceOfAgentSettings,
  instanceOfAlternateDatesAvailabilityRequest,
  instanceOfAutoPaymentParam,
  instanceOfAutoPaymentRequest,
  instanceOfAvailabilitySearchResponse,
  instanceOfAvailabilityType,
  instanceOfBookedWith,
  instanceOfBooking,
  instanceOfBookingLinesInner,
  instanceOfBookingOptions,
  instanceOfBookingPaymentInfo,
  instanceOfBookingStatus,
  instanceOfBookingSummary,
  instanceOfBookingSummaryHirer,
  instanceOfBookingSummaryQuery,
  instanceOfBookingSummaryResponse,
  instanceOfBookingSummaryStatus,
  instanceOfBookingType,
  instanceOfBranchContent,
  instanceOfBranchContentPages,
  instanceOfBrand,
  instanceOfBusinessUnit,
  instanceOfCatalogFloorPlan,
  instanceOfCatalogItem,
  instanceOfCatalogItemPage,
  instanceOfCommission,
  instanceOfCommissionStatus,
  instanceOfConvertQuotePaymentType,
  instanceOfConvertQuoteResponse,
  instanceOfCountryData,
  instanceOfCreateBookingRequest,
  instanceOfCreateBookingResponse,
  instanceOfCreateBookingResponseStatus,
  instanceOfCurrencyRateResult,
  instanceOfCurrencyValue,
  instanceOfDriversLicence,
  instanceOfEmailQuoteRequest,
  instanceOfErrorResponse,
  instanceOfExcessReductionFeatureSchema,
  instanceOfExcessReductionFeatureSchemaBasic,
  instanceOfExcessReductionFeatureType,
  instanceOfExchangeRates,
  instanceOfExportBookingRequestQuery,
  instanceOfExportMaintenanceBookingRequestQuery,
  instanceOfExportMonthlySalesByCategoryRequestQuerySchema,
  instanceOfExportMonthlyUtilisationRequestQuerySchema,
  instanceOfExportVehicleRequestQuery,
  instanceOfFeatureItem,
  instanceOfFeatureList,
  instanceOfFerryAccommodationProduct,
  instanceOfFerryBooking,
  instanceOfFerryCreateBookingRequest,
  instanceOfFerryCreateQuoteRequest,
  instanceOfFerryGetBookingResponse,
  instanceOfFerryGetOptionsQueryString,
  instanceOfFerryGetQuoteResponse,
  instanceOfFerryGetRouteRequest,
  instanceOfFerryGetSailingsRequest,
  instanceOfFerryGetSailingsRequestAllOfOutboundTrip,
  instanceOfFerryGetSailingsRequestAllOfPassengers,
  instanceOfFerryGetSailingsRequestAllOfReturnTrip,
  instanceOfFerryGetSailingsResponse,
  instanceOfFerryGetStatusRequestQuery,
  instanceOfFerryGetStatusResponse,
  instanceOfFerryGetTimetableRequest,
  instanceOfFerryMessage,
  instanceOfFerryOptions,
  instanceOfFerryPassenger,
  instanceOfFerryPassengerCountRequest,
  instanceOfFerryPassengerType,
  instanceOfFerryPort,
  instanceOfFerryProductLine,
  instanceOfFerryRoute,
  instanceOfFerrySailing,
  instanceOfFerrySailingBooking,
  instanceOfFerrySailingOrder,
  instanceOfFerrySailingQuoteRequest,
  instanceOfFerrySailingTrip,
  instanceOfFerrySailingTripAllOfId,
  instanceOfFerryShip,
  instanceOfFerryTripDetailsRequest,
  instanceOfFerryTripDetailsRequestOutboundTrip,
  instanceOfFerryTripDetailsRequestReturnTrip,
  instanceOfFerryUpdateQuoteRequest,
  instanceOfFerryUpdateQuoteRequestParams,
  instanceOfFindReservationRequest,
  instanceOfFindReservationResult,
  instanceOfFindReservationResultHirer,
  instanceOfFleetCategory,
  instanceOfFleetCategoryContent,
  instanceOfFleetTypeCode,
  instanceOfFleetTypeHireDaysType,
  instanceOfGalleryItem,
  instanceOfGalleryItemType,
  instanceOfGetBranchContentQuery,
  instanceOfGetFerryBookingRequestParams,
  instanceOfGetFerryBookingsRequestParams,
  instanceOfGetFerryQuoteRequestParams,
  instanceOfGetFleetCategoryContentParams,
  instanceOfGetFleetTypeBlySlugParams,
  instanceOfGetRewardPointsStatusQuery,
  instanceOfGetSelfServiceBookingParams,
  instanceOfHirePeriod,
  instanceOfHirerDetails,
  instanceOfHirerDetailsSummary,
  instanceOfInsuranceProduct,
  instanceOfInsuranceProductGroup,
  instanceOfInsuranceProductLine,
  instanceOfInsuranceType,
  instanceOfJucyApiStatusSchema,
  instanceOfJucyAppStatusSchema,
  instanceOfJucyCountryCode,
  instanceOfLeadTime,
  instanceOfLeadTime1,
  instanceOfLinkReservationRequest,
  instanceOfListBranchContentQuery,
  instanceOfListFleetCategoriesQuery,
  instanceOfListFleetCategoryContentQuery,
  instanceOfListShuttlesQuery,
  instanceOfLogSelfServiceEventParams,
  instanceOfLogSelfServiceEventRequest,
  instanceOfLoyaltyRequestData,
  instanceOfMandatoryProduct,
  instanceOfMapMarker,
  instanceOfMessageResponse,
  instanceOfMinimumHirePeriod,
  instanceOfMinimumHirePeriodFormat,
  instanceOfMinimumHirePeriodRequest,
  instanceOfOperator,
  instanceOfOperatorAvailableAccountsInner,
  instanceOfPaymentConfig,
  instanceOfProduct,
  instanceOfProductBundle,
  instanceOfProductGroup,
  instanceOfProductItem,
  instanceOfProductLine,
  instanceOfQuoteAvailability,
  instanceOfQuoteStatus,
  instanceOfRentalCatalogQuery,
  instanceOfRentalCatalogResponse,
  instanceOfReservationRefParams,
  instanceOfReservationRewardPointsStatus,
  instanceOfRewardPointsConfig,
  instanceOfSaveReservationRewardPointsResponse,
  instanceOfSecondaryProduct,
  instanceOfSecondaryProductGroup,
  instanceOfSelfServiceBooking,
  instanceOfSelfServiceGetReservationRewardPointsStatus,
  instanceOfSelfServicePreferenceParam,
  instanceOfSelfServicePreferences,
  instanceOfSendPaymentRequest,
  instanceOfShuttle,
  instanceOfShuttleImage,
  instanceOfSite,
  instanceOfSiteAddress1,
  instanceOfSiteDefaultTimes,
  instanceOfSiteHoliday,
  instanceOfSiteOfficeTime,
  instanceOfSiteServiceTime,
  instanceOfSiteSettings,
  instanceOfSiteSettingsServiceHours,
  instanceOfSubscribeRequest,
  instanceOfSubscribeResponse,
  instanceOfTripDetails,
  instanceOfTripInfoRequestBody,
  instanceOfUpdateFlightDetailsRequest,
  instanceOfUpdateFlightDetailsRequestAdditionalDriversInner,
  instanceOfUpdateFlightDetailsRequestProductAndQuantityMapInner,
  instanceOfUpdateReservationRequest,
  instanceOfUpdateReservationValidationStatus,
  instanceOfV2FleetType,
  instanceOfV2FleetTypeLocationsAvailableAtInner,
  instanceOfValidateUpdateResponse,
  instanceOfVideoChapter,
  instanceOfVideoContent
};
//# sourceMappingURL=index.mjs.map